import {
  Component,
  ElementRef,
  HostListener,
  OnInit,
  ViewChild,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AuthService } from '../../shared/services/auth.service';
import { JwtHelperService } from '@auth0/angular-jwt'; // If you're using JWTs// npm install @auth0/angular-jwt
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { TooltipComponent } from '../../shared/tooltip/tooltip.component';

declare const bootstrap: any;
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  ValidatorFn, // <-- Add this import
  Validators,
} from '@angular/forms';
import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
  HttpParams,
} from '@angular/common/http';
import {
  catchError,
  finalize,
  forkJoin,
  lastValueFrom,
  map,
  Observable,
  of,
  switchMap,
  tap,
  take,
  throwError,
} from 'rxjs';
import { environment } from '../../../../environments/environment';
import { Router, ActivatedRoute } from '@angular/router';
import {
  MultiSelectDropdownComponent,
  Option,
} from './multi-select-dropdown.component';
import { SingleSelectDropdownComponent } from './single-select-dropdown.component';
import { MobileBusinessViewComponent } from './mobile-business-view/mobile-business-view.component';
import { ChangeDetectorRef } from '@angular/core';
import { EnvironmentInjector, EnvironmentProviders } from '@angular/core';
import { SetupService } from '../../shared/services/setup.service';
import { MobileNavService } from '../../shared/mobile/mobile-bottom-nav/mobile-nav.service';
import { ToastService } from '../../shared/services/toast.service';
import { ThemeService } from 'ng2-charts';
import { jwtDecode } from 'jwt-decode';

export interface PendingEmployeeChanges {
  added: Omit<
    Employee,
    | 'isEditing'
    | 'isNew'
    | 'originalEmployee'
    | 'originalIsActive'
    | 'roleDescription'
  >[];
  updated: Omit<
    Employee,
    | 'isEditing'
    | 'isNew'
    | 'originalEmployee'
    | 'originalIsActive'
    | 'roleDescription'
  >[];
  deleted: Employee[]; // Keep full Employee objects for deletion, but only send ID
}

interface OperatingSchedule {
  operatingScheduleID: number;
  dayOfWeek: number;
  openTime: string | null;
  closeTime: string | null;
  isClosed: boolean;
  businessID: number;
}

export interface TenantProfile {
  tenantProfileID: number;
  tenantProfileName: string; // Corresponds to businessName
  location: string;
  businessBrief: string;
  industry: string | null;
  businessType: string | null;
  businessSize: string;
  vendorType: string;
  businessModels: string; // This will likely be a comma-separated string from the API
  targetMarkets: string; // This will likely be a comma-separated string from the API
  salesChannels: string; // This will likely be a comma-separated string from the API
  // Add any other properties your TenantProfile DTO from the backend has
  keyChallenges?: string; // If it's optional
}
interface Holiday {
  countryCode: string;
  startDate: string; // "YYYY-MM-DD"
  endDate: string; // "YYYY-MM-DD"
  type: string;
  name: { text: string; language: string }[];
  federal: number;
  // ... other properties you might have
}
interface OperatingScheduleEntry {
  operatingScheduleID?: number; // Optional as it might not be present on initial creation
  dayOfWeek: number;
  openTime: string | null;
  closeTime: string | null;
  isClosed: boolean;
  businessID: number;
}

interface OperatingException {
  operatingExceptionID?: number; // Optional
  exceptionDate: string; // "YYYY-MM-DDT00:00:00" from API
  calendarYear?: number; // Optional
  openTime: string | null;
  closeTime: string | null;
  isClosed: boolean;
  reason: string;
  businessID?: number; // Optional
}

// Your existing local model for exceptions in the UI
interface UIOperatingException {
  title?: string; // For display, e.g., "December 25" - public holidays have this
  exceptionDate: string; // "YYYY-MM-DD" for input type="date"
  openTime: string | null;
  closeTime: string | null;
  isClosed: boolean;
  reason: string;
}

interface DailyOperatingHours {
  name: string;
  openingTime: string | null;
  closingTime: string | null;
  closed: boolean;
}
export interface CategoryDTO {
  categoryId: number;
  categoryName: string;
  createdAt: string; // ISO string
}
interface ItemUpdatePayload {
  itemID: number;
  itemName: string;
  itemCode: string | null;
  description: string | null;
  itemTypeID: number;
  purchaseUOMID: number;
  lowStockThreshold: number | null;
  purchaseQuantity: number | null;
  isActive: boolean;
  sellingPrice: number | null;
  profitMarginPercent: number | null;
  purchasePrice: number | null;
  valuationMethodCode: string | null;
  categoryID: number | null;
  supplierID: number | null;
  createdAt: string | null;
  updatedAt: string | null;
  createdBy: string | null;
}
export interface ItemCreatePayload {
  itemCode?: string | null;
  itemName: string;
  description?: string | null;
  itemTypeID: number;
  baseUOMID: number;
  lowStockThreshold?: number | null;
  isActive: boolean;
  targetSellingPrice?: number | null;
  targetProfitMarginPercent?: number | null;
  targetCost?: number | null;
  valuationMethodCode?: string | null;
  categoryID?: number | null;
}
export interface ItemDTO {
  itemID: number;
  itemTypeID: number;
  purchaseUOMID: number;
  lowStockThreshold: number | null;
  isActive: boolean;
  description: string | null;
  itemName: string;
  itemCode: string | null;
  supplierID: number | null;
  createdAt: string; // Current timestamp
  purchaseQuantity: number | null;
  updatedAt: string;
  createdBy: string | null;
  sellingPrice: number | null;
  profitMarginPercent: number | null;
  purchasePrice: number | null;
  valuationMethodCode: string | null;
  categoryID: number | null;

  // Add other properties if needed from your ItemDTO
}
export interface ItemSupplierPriceHistoryDTO {
  itemSupplierPriceID: number;
  itemID: number;
  supplierLocationID: number;
  purchasePrice: number;
  purchaseQuantity: number;
  currencyCode: string;
  purchaseUOMID: number; // This is the uomID you need
  uomConversionFactor: number;
  supplierItemCode?: string;
  leadTimeDays?: number | null;
  createdBy: string | null;
  validFrom: string;
  validTo: string | null; // Allow null here
  createdAt?: string | null; // Consider allowing null if your backend can send it
}

// For /api/SupplierLocations/GetAll
export interface SupplierLocationsDTO {
  locationID: number;
  supplierID: number;
  branchName?: string;
  addressLine1?: string;
  addressLine2?: string;
  city?: string;
  region?: string;
  postalCode?: string;
  country?: string;
  locationContactPerson?: string;
  locationEmail?: string;
  locationPhone?: string;
  isActive: boolean;
  createdAt?: string;
  updatedAt?: string;
}

//VARIABLE OH
export interface VariableOverheadItem {
  invalidLowStockThreshold: boolean;
  variableOverheadItemID?: number | null; // Optional, indicates if it's an existing item
  itemSupplierPriceHistoryID?: number | null; // Made optional as it might not always be present for new items
  lowStockThreshold: number | null;
  overhead: string | null; // Can be null (e.g., before selection)
  customOverhead?: string | null; // Optional custom name
  overheadName?: string; // Derived name for display purposes (e.g., from 'overhead' or 'customOverhead')
  supplierID: number | null;
  purchasePrice: number | null;
  purchaseQuantity: number | null;
  uomID: number | null;
  leadTimeDays: number | null;
  userIDEntered?: number | null; // Made optional as it might be set by the backend
  overheadCostPoolID: number | null; // Changed to allow null, as it might not be set initially
  categoryID: number | null; // Added as requested
  isNew?: boolean; // Mark as new when added
  isModified?: boolean; // Mark as modified when changes occur
  isEditing?: boolean; // Indicates if the item is currently in edit mode
  originalItem?: VariableOverheadItem; // Stores original state for potential rollback

  // Validation flags (all made optional as they might be dynamically added/calculated)
  invalidOverhead?: boolean;
  invalidSupplier?: boolean;
  invalidPurchasePrice?: boolean;
  invalidPurchaseQuantity?: boolean;
  invalidUOM?: boolean;
  invalidCategory?: boolean; // Added for validation as requested

  // Overall validity for the inline save button
  isValid?: boolean; // Add this if you haven't already, essential for inline save logic
  touched: boolean;

  validFrom?: string; // Optional, might default or be set by backend
  validTo?: string | null; // Optional, allows null
}
interface SupplierDTO {
  supplierID: number;
  companyName: string;
  primaryContactPerson: string;
  primaryEmail: string;
  primaryPhone: string;
  website: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

interface UnitOfMeasureDTO {
  uomID: number; // This should match your item.uomID
  uomCode: string;
  uomName: string;
  // If your backend actually sends 'uomid', you might need to adjust this DTO
  // Or, if you want to keep the DTO reflecting the backend, cast it during the map
}

// You'll also need a DTO for the Variable Overhead Cost Item if it's different from OverheadCostItemDTO
// Based on the fields, it looks like a new DTO might be needed for variable overheads

// --- Salary Related Interfaces ---
export interface OverheadCostItemDTO {
  overheadCostItemID: number;
  overheadCostPoolID: number | null;
  overheadName: string;
  description?: string;
  createdAt?: string;
  updatedAt?: string;
}
interface OverheadAllocationRateDTO {
  overheadAllocationRateID: number;
  overheadCostItemID: number;
  periodTypeID: number;
  rateValue: number;
  currencyCode: string;
  validFrom: string;
  validTo: string;
  createdAt: string;
  updatedAt: string;
}

export interface FixedOverheadItem {
  touched: boolean;
  fixedOverheadID?: number; // Optional, indicates if it's an existing item
  overhead: string;
  customOverhead?: string;
  cost: number | null; // Allows cost to be null
  periodTypeID: number | null;
  isEditing: boolean;
  invalidOverhead: boolean;
  invalidCost: boolean;
  invalidperiodTypeID: boolean;
  overheadAllocationRateID: number | null;
  overheadCostPoolID: number | null;
  isNew?: boolean; // Mark as new when added
  isModified?: boolean; // Mark as modified when changes occur
  originalItem?: FixedOverheadItem; // Stores original state for potential rollback
  createdAt: string;
  validTo: string;
  validFrom: string;
  isValid?: boolean; // ADD THIS LINE: Property to track overall validity for inline saving
}
export interface Salary {
  salaryID?: number | null; // Optional for new salaries, null for placeholders
  employeeID: number | null;
  periodTypeID: number | null; // Allow it to be a number OR null
  effectiveFromDate: string;
  effectiveToDate: string | null;
  amount: number;
  hoursWorked: number | null;
  currency: string;
  hoursManuallyEdited?: boolean;
  // Client-side only properties
  isEditing?: boolean;
  isNew?: boolean;
  originalSalary?: Salary; // To store original state for comparison
}

interface PendingSalaryChanges {
  added: Salary[]; // This array should contain full Salary objects (including isNew)
  updated: Salary[]; // This array should contain full Salary objects
  deleted: string[]; // Or Salary IDs for deleted ones
}

interface Employee {
  employeeID: number | null;
  firstName: string;
  lastName: string;
  contactInfo: string | null;
  hireDate: string;
  roleID: number | null;
  roleDescription?: string; // This is what we need to populate
  isActive: boolean;
  isEditing?: boolean;
  isNew?: boolean;
  isDeleted?: boolean;
  originalIsActive?: boolean;
  isModified?: boolean;
  originalEmployee?: Employee; // Added for robust revert
}
interface EmployeeSalary {
  salaryID: number;
  employeeID: number;
  effectiveFromDate: Date;
  effectiveToDate: Date | null;
  amount: number;
  hoursWorked: number;
  currency: string;
  periodTypeID?: number | null;
  periodTypeDescription?: string;
}

export interface PeriodType {
  periodTypeID: number | null; // Make it number or null
  description: string;
}

interface Role {
  roleID: number | null; // null for new roles
  isAdmin: boolean; // New property to indicate if the role is admin
  roleName: string;
  description: string | null;
  createdAt?: string; // Optional, as it might not be sent on updates/adds
  updatedAt?: string; // Optional
  isEditing?: boolean; // UI flag
  isNew?: boolean; // UI flag for newly added rows
  isDeleted?: boolean; // New UI flag for roles marked for deletion
}

@Component({
  selector: 'app-business-form',
  standalone: true,
  imports: [
    CommonModule,
    TooltipComponent,
    RouterModule,
    FormsModule,
    ReactiveFormsModule, // <-- Add it here
    MultiSelectDropdownComponent,
    SingleSelectDropdownComponent,
    MobileBusinessViewComponent,
  ],
  templateUrl: './business-form.component.html',
  styleUrls: ['./business-form.component.css'],
})
export class BusinessFormComponent implements OnInit {
  mainActiveTab: string = 'details';
  fixedOverheadItems: FixedOverheadItem[] = [];
  @ViewChild('tooltip', { static: false }) tooltipElement!: ElementRef;
  tenantName: any;
  fullName: any;
  ngAfterViewInit(): void {
    if (this.tooltipElement) {
      new bootstrap.Tooltip(this.tooltipElement.nativeElement);
    }
  }
  //initialized tenant id, do not change id,
  tenantProfileID: number = 0;
  // Sub-tab within Employees section

  empSubTab: 'rolesList' | 'employeesList' | 'salariesList' = 'employeesList';
  showRoleForm = false;
  public selectedEmployeeId: number | null = null;
  private tempSalaryIdCounter = -1;
  editingRole: Role | null = null;
  public variableOverheadItems: VariableOverheadItem[] = [];
  public variableOverheads: { value: string; label: string }[] = [];
  public suppliers: SupplierDTO[] = [];
  public unitsOfMeasure: UnitOfMeasureDTO[] = [];
  private _hoursOpenPerMonth: number | null = null;
  private isOperatingScheduleLoaded = false;
  public categories: CategoryDTO[] = []; // <-- Declared here
  inlineSaving: boolean = false;
  alertInfo: string | SafeHtml | null = '';
  showMessageModal: boolean = false;
  public items: ItemDTO[] = [];
  isSavingDelete: boolean = false;
  isFirstLogin = false;
  welcomeDismissed = false;
  holidays: any[] = [];
  exceptions: any[] = [];
  currentYear = new Date().getFullYear();
  modalMessage: SafeHtml | null = null;
  showDeleteConfirm: boolean = false;
  confirmEmployeeDelete: boolean = true;
  public variableOverheadCostPoolID: number = 0; // Example, set to your actual ID
  currentUser: string | null = localStorage.getItem('rememberedEmail');
  deletedOverheadIds: number[] = []; // New array to store IDs of deleted items
  showAlertMessageFromNext: boolean = false;
  public isLoadingData: boolean = true; // Added for loading state
  public isProcessing: boolean = false; // Added for loading state
  // Form fields
  loading: boolean = false;
  errorMessage: string | null = null;
  successMessage: string | null = null;
  currencies: string[] = ['ZAR', 'USD', 'GBP', 'CAD'];
  private savingInitiator: 'add-button' | 'tab-change' | 'manual-save' | null =
    null;
  // For Variable Overheads

  public supplierLocations: SupplierLocationsDTO[] = []; // Also declare and initialize this
  industries: Option[] = [];
  businessTypes: Option[] = [];
  filteredBusinessTypes: Option[] = [];

  selectedIndustry: string = '';
  selectedBusinessType: string = '';

  industryMap: { [key: string]: Option[] } = {};

  // Assuming you have a variable cost pool ID for variable overheads

  // Assuming you have a variable cost pool ID for variable overheads

  // Tab & Sub-tab navigation
  currentTab: string = 'businessDetails'; // Default active tab

  // Employee List Properties
  employees: Employee[] = [];
  roles: Role[] = [];
  pendingEmployeeChanges: PendingEmployeeChanges = {
    added: [],
    updated: [],
    deleted: [],
  };
  showSaveEmployeeModal: boolean = false;
  isSavingEmployees: boolean = false;
  employeeModalMessage: string | null | SafeHtml = null;
  isEmployeeSaveSuccess: boolean | null = null;

  // Salary List Properties
  employeeSalaries: Salary[] = [];
  periodTypes: PeriodType[] = [];
  pendingSalaryChanges: PendingSalaryChanges = {
    added: [],
    updated: [],
    deleted: [],
  };
  showSaveSalaryModal: boolean = false; // New modal for salaries
  isSavingSalaries: boolean = false;
  salaryModalMessage: string | null = null;
  isSalarySaveSuccess: boolean | null = null;

  // Old Salary Form (we'll phase this out for inline editing, but keep its data types)
  salaryForm: FormGroup;
  showSalaryForm: boolean = false;
  editingSalary: Salary | null = null;
  tabs: string[] = ['details', 'schedule', 'expenses', 'employees', 'salaries'];

  businessName: string = '';
  industry: string | null = null;
  businessModel: string[] = [];
  location: string = '';
  businessType: string | null = null;
  businessBrief: string = '';
  businessSize: string = '';
  targetMarket: string[] = [];
  vendorType: string = '';
  salesChannel: string[] = [];
  keyChallenges: string = '';

  // Dropdown options arrays

  businessModels: Option[] = [];

  businessSizes: Option[] = [];
  targetMarkets: Option[] = [];
  vendorTypes: Option[] = [];
  salesChannels: Option[] = [];
  fixedOverheads: Option[] = [];
  existingProfile: any = null;
  isLoading = false;
  currentProfileId = 0;
  // Overhead items arrays for expenses tab
  activeTab: string = 'details';
  isLockActive: boolean = false;
  allDaysOpenTime: string | null = null;
  allDaysCloseTime: string | null = null;
  onTabChangeCall: boolean = false;
  get isLast(): boolean {
    const idx = this.tabs.indexOf(this.mainActiveTab);
    return idx === this.tabs.length - 1;
  }
  showTooltip = false;
  showIndustryTooltip = false;
  toggleTooltip(event: Event) {
    event.stopPropagation();
    this.showTooltip = !this.showTooltip;
  }
  toggleTooltipIndustry(event: Event) {
    event.stopPropagation();
    this.showIndustryTooltip = !this.showIndustryTooltip;
  }

  @HostListener('document:click')
  closeTooltip() {
    this.showTooltip = false;
    this.showIndustryTooltip = false;
  }

  mobileSetupCompleted = false;

  onFinish(opts: { skipNavigate?: boolean; mobileFirstLogin?: boolean } = {}): void {
    this.isProcessing = true;
    this.isLockActive = true;
    const token =
      localStorage.getItem('authToken') || sessionStorage.getItem('authToken');
    if (!token) {
      return this.showMessage('Authentication error: No auth token found.');
    }

    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    });
    const year = new Date().getFullYear();

    this.getLatestTenantProfileId()
      .pipe(
        switchMap((businessId) => {
          if (businessId == null) {
            return throwError(() => new Error('Business ID not found.'));
          }

          // Core data streams
          const schedule$ = this.http.get<OperatingSchedule[]>(
            `${environment.apiUrl}/api/OperatingSchedule/${businessId}/schedule`,
            { headers }
          );
          const exceptions$ = this.http.get<OperatingException[]>(
            `${environment.apiUrl}/api/OperatingException/${businessId}/${year}/exceptions`,
            { headers }
          );
          const holidays$ =
            this.getPublicHolidaysForCurrentYearObservable(token);
          const suppliers$ = this.http.get<SupplierDTO[]>(
            `${environment.apiUrl}/api/Suppliers/GetAll`,
            { headers }
          );
          const uom$ = this.http
            .get<any[]>(`${environment.apiUrl}/api/UnitOfMeasure/GetAll`, {
              headers,
            })
            .pipe(
              map((data) =>
                data.map((u) => ({
                  uomID: u.uomid,
                  uomCode: u.uomCode,
                  uomName: u.uomName,
                }))
              ),
              catchError(() => of([] as UnitOfMeasureDTO[]))
            );
          const categories$ = this.http
            .get<CategoryDTO[]>(`${environment.apiUrl}/api/Category/GetAll`, {
              headers,
            })
            .pipe(catchError(() => of([])));
          const items$ = this.http
            .get<ItemDTO[]>(`${environment.apiUrl}/api/Items/ByType/3`, {
              headers,
            })
            .pipe(catchError(() => of([] as ItemDTO[])));
          const supplierLocations$ = this.http
            .get<SupplierLocationsDTO[]>(
              `${environment.apiUrl}/api/SupplierLocations/GetAll`,
              { headers }
            )
            .pipe(catchError(() => of([])));

          const employees$ = this.http
            .get<Employee[]>(`${environment.apiUrl}/api/Employees/GetAll`, {
              headers,
            })
            .pipe(catchError(() => of([])));

          const roles$ = this.http
            .get<Role[]>(`${environment.apiUrl}/api/Role/GetAll`, { headers })
            .pipe(catchError(() => of([])));

          const salaries$ = this.http
            .get<any[]>(`${environment.apiUrl}/api/EmployeeSalaries/GetAll`, {
              headers,
            })
            .pipe(catchError(() => of([])));

          return forkJoin({
            schedule: schedule$,
            apiEx: exceptions$,
            holidays: holidays$,
            suppliers: suppliers$,
            uom: uom$,
            categories: categories$,
            items: items$,
            supplierLocations: supplierLocations$,
            employees: employees$,
            roles: roles$,
            salaries: salaries$,
          }).pipe(
            catchError(() => {
              this.isLoading = false;
              return throwError(() => new Error('Load error'));
            })
          );
        })
      )
      .subscribe({
        next: (result) => {
          const {
            schedule,
            apiEx,
            holidays,
            suppliers,
            uom,
            categories,
            items,
            supplierLocations,
            employees,
            roles,
            salaries,
          } = result;

          const missing: string[] = [];
          if (opts.mobileFirstLogin) {
            if (!schedule.length) missing.push('Operating schedule');
            if (!employees.length) missing.push('Employees');
            if (!salaries.length) missing.push('Salaries');
            if (missing.length) {
              this.isProcessing = false;
              return this.showMessage(
                'Please complete the wizard:<br>' + missing.map((item) => `• ${item}`).join('<br>')
              );
            }
          } else {
            if (!schedule.length) missing.push('Operating schedule');
            if (!apiEx.length && !holidays.length)
              missing.push('Exceptions or public holidays');
            if (!suppliers.length) missing.push('Suppliers');
            if (!uom.length) missing.push('Units of measure');
            if (!categories.length) missing.push('Categories');
            if (!supplierLocations.length) missing.push('Supplier locations');
            if (!employees.length) missing.push('Employees');
            if (!roles.length) missing.push('Roles');
            if (!salaries.length) missing.push('Salaries');
            if (missing.length) {
              this.isProcessing = false;
              const msg =
                'Missing required data:<br>' +
                missing.map((item) => `• ${item}`).join('<br>');
              return this.showMessage(msg);
            }
          }

          // Prefill exceptions from public holidays when API has none (mobile first-login)
          if ((!apiEx || !apiEx.length) && holidays?.length) {
            this.exceptions = (holidays as any[]).map((h: any) => ({
              title: h.name?.[0]?.text ?? '',
              exceptionDate: h.startDate,
              openTime: '00:00',
              closeTime: '23:59',
              isClosed: true,
              reason: h.name?.[0]?.text ?? 'Public Holiday',
            }));
          }

          this.isProcessing = false;

          const finalizeSetup = () => {
            this.setupService.completeSetup();
            if (opts.skipNavigate) {
              this.mobileSetupCompleted = true;
              this.isFirstLogin = false;
              localStorage.removeItem('pendingOnboarding');
              this.mobileNavService.setFirstLogin(false);
            } else {
              this.router.navigate(['/inventory']);
            }
          };

          // Wait for JWT refresh so the new Admin User role claim is persisted
          // before the router activates /inventory and config reads getUserRole().
          // Uses silentRefreshToken which never logs out on failure.
          this.authService.silentRefreshToken().pipe(take(1)).subscribe({
            next: () => finalizeSetup(),
            error: () => finalizeSetup(),
          });
        },
        error: () => {
          this.isProcessing = false;
          // Error already handled
        },
      });
  }

  private showMessage(msg: string) {
    this.alertInfo = msg;
    this.showMessageModal = true;
  }
  // ... (your existing constructor and other methods)

  /**
   * Applies the set 'allDaysOpenTime' and 'allDaysCloseTime' to all days
   * in the operatingHours array, without marking them as closed.
   *
   */
  private holidayApiUrl = 'https://openholidaysapi.org/PublicHolidays';

  getSouthAfricaPublicHolidays(from: string, to: string): Observable<any> {
    const params = new HttpParams()
      .set('countryIsoCode', 'ZA')
      .set('languageIsoCode', 'EN')
      .set('validFrom', from)
      .set('validTo', to);

    return this.http.get(this.holidayApiUrl, {
      headers: { accept: 'text/json' },
      params,
    });
  }

  applyToAllDays() {
    // Only apply if both opening and closing times are set
    if (this.allDaysOpenTime && this.allDaysCloseTime) {
      this.operatingHours.forEach((day) => {
        day.openTime = this.allDaysOpenTime;
        day.closeTime = this.allDaysCloseTime;
        day.isClosed = false; // Ensure they are not marked as closed when applying hours
      });
      // Optionally, you might want to clear the "Apply to All" inputs after applying
      // this.allDaysOpenTime = null;
      // this.allDaysCloseTime = null;
    } else {
      // You could add a small alert or toast notification here
      console.warn('Please set both opening and closing times for all days.');
      // Example: this.alertInfo = 'Please set both opening and closing times for all days.'; this.showMessageModal = true;
    }
  }

  /** Sets every day to open 24 hours (00:00 – 23:59, not closed). */
  applyAllDays24_7(): void {
    this.operatingHours.forEach((day) => {
      day.openTime = '00:00';
      day.closeTime = '23:59';
      day.isClosed = false;
    });
  }

  /**
   * Toggles a single day between 24-hour mode (00:00 – 23:59) and a default
   * business day (08:00 – 17:00). If the day is already set to 24h it resets;
   * otherwise it applies 24h.
   */
  toggleDay24Hours(index: number): void {
    const day = this.operatingHours[index];
    if (!day) return;
    if (this.isDayOpen24Hours(index)) {
      day.openTime = '08:00';
      day.closeTime = '17:00';
    } else {
      day.openTime = '00:00';
      day.closeTime = '23:59';
      day.isClosed = false;
    }
  }

  /** Returns true when a day is configured as open for the full 24 hours. */
  isDayOpen24Hours(index: number): boolean {
    const day = this.operatingHours[index];
    if (!day) return false;
    return day.openTime === '00:00' && day.closeTime === '23:59' && !day.isClosed;
  }

  loadExistingProfile(): void {
    this.isLoading = true;
    this.errorMessage = null; // Clear previous errors

    // --- Authentication: Get token and set headers ---
    const token = localStorage.getItem('authToken');

    if (!token) {
      console.error('Authentication error: No auth token found.');
      this.isLoading = false;
      this.existingProfile = null;
      this.errorMessage = '⚠️Authentication required. Please log in.';
      return;
    }

    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    });
    // --- End Authentication ---

    // 1. First, get the latest tenant profile ID
    this.getLatestTenantProfileId().subscribe({
      next: (tenantProfileId: number | null) => {
        if (tenantProfileId === null) {
          console.warn('No tenant profile found. Starting with a new profile.');
          this.isLoading = false;
          this.existingProfile = null;
          this.detectAndApplyFirstLogin();
          return;
        }

        this.tenantProfileID = tenantProfileId;
        // 2. Now fetch the actual profile data using the ID as a query parameter
        const profileUrl = `${environment.apiUrl}/api/TenantProfile/GetById?TenantProfileId=${this.tenantProfileID}`;
        this.http.get<TenantProfile | null>(profileUrl, { headers }).subscribe({
          next: (response) => {
            if (response) {
              this.existingProfile = response;
              this.tenantProfileID = response.tenantProfileID;
              this.populateFormWithExistingData(this.existingProfile);
            } else {
              this.existingProfile = null;
            }
            this.detectAndApplyFirstLogin();
            this.isLoading = false;
          },
          error: (error) => {
            console.error('Error fetching profile data:', error);
            this.isLoading = false;
            this.existingProfile = null;

            let errorMessage = 'Failed to load profile. ';
            if (error.status === 404) {
              errorMessage +=
                'No existing profile found. This might be the first time setup.';
            } else {
              errorMessage += 'Please try again later.';
              this.errorMessage = errorMessage;
            }
          },
        });
      },
      error: (error) => {
        console.error('Error getting tenant profile ID:', error);
        this.isLoading = false;
        this.errorMessage = 'Failed to load profile. Please try again later.';
      },
    });
    this.isProcessing = false;
  }

  private detectAndApplyFirstLogin(): void {
    const pending = localStorage.getItem('pendingOnboarding');
    const profileEmpty = !this.businessName && !this.location && !this.industry;

    // A non-empty profile means setup has been completed before — clear any
    // stale onboarding payload from a previously-aborted wizard run.
    if (!profileEmpty && pending) {
      localStorage.removeItem('pendingOnboarding');
    }

    this.isFirstLogin = profileEmpty;

    if (this.isFirstLogin && pending) {
      try {
        const { tenantName } = JSON.parse(pending);
        if (!this.businessName) this.businessName = tenantName || '';
      } catch { /* ignore malformed payload */ }
    }

    this.mobileNavService.setFirstLogin(this.isFirstLogin);
  }

  checkSetupStatus(): void {
    const token = localStorage.getItem('token');
    if (token) {
      this.setupService.checkSetupStatus().subscribe((response: any) => {

        this.isLockActive = !response.isSetupComplete;
      });
    } else {
      this.isLockActive = true; // Lock if not authenticated
    }
  }

  populateFormWithExistingData(profile: any) {
    // Map DTO fields to your existing form properties
    this.currentProfileId = profile.tenantProfileID || 0;
    this.businessName = profile.tenantProfileName || '';
    this.location = profile.location || '';
    this.businessBrief = profile.businessBrief || '';

    // Set the industry first
    this.industry = profile.industry || '';

    // IMPORTANT: Trigger the filtering logic after setting the industry
    // This will populate the `filteredBusinessTypes` array.
    this.onIndustryChange();

    // Now, set the business type. The dropdown will now have the correct options
    // to find and display this value.
    this.businessType = profile.businessType || '';

    this.businessSize = profile.businessSize || '';
    this.vendorType = profile.vendorType || '';
    this.keyChallenges = profile.keyChallenges || '';

    // Use a timeout to ensure change detection runs after all properties are set
    setTimeout(() => {
      // Map DTO fields to your existing form properties
      this.currentProfileId = profile.tenantProfileID || 0;
      this.businessName = profile.tenantProfileName || '';
      this.location = profile.location || '';
      this.businessBrief = profile.businessBrief || '';
      this.industry = profile.industry || '';
      this.businessType = profile.businessType || '';
      this.businessSize = profile.businessSize || '';
      this.vendorType = profile.vendorType || '';
      this.keyChallenges = profile.keyChallenges || '';

      // Handle multi-select fields - convert comma-separated strings to arrays
      if (profile.businessModels) {
        this.businessModel = profile.businessModels
          .split(',')
          .map((s: string) => s.trim())
          .filter(Boolean); // Remove any empty strings
      }

      if (profile.targetMarkets) {
        this.targetMarket = profile.targetMarkets
          .split(',')
          .map((s: string) => s.trim())
          .filter(Boolean); // Remove any empty strings
      }

      if (profile.salesChannels) {
        this.salesChannel = profile.salesChannels
          .split(',')
          .map((s: string) => s.trim())
          .filter(Boolean); // Remove any empty strings
      }
      // Trigger change detection
      this.cdr.detectChanges();
    });
  }
  prepareProfileData() {
    return {
      tenantProfileID: this.currentProfileId,
      tenantProfileName: this.businessName || '',
      industry: this.industry || '',
      businessModels: this.businessModel ? this.businessModel.join(', ') : '',
      location: this.location || '',
      businessType: this.businessType || '',
      businessBrief: this.businessBrief || '',
      businessSize: this.businessSize || '',
      targetMarkets: this.targetMarket ? this.targetMarket.join(', ') : '',
      vendorType: this.vendorType || '',
      salesChannels: this.salesChannel ? this.salesChannel.join(', ') : '',
      keyChallenges: '',
    };
  }
  getLatestTenantProfileId(): Observable<number | null> {
    const token =
      localStorage.getItem('authToken') || sessionStorage.getItem('authToken');

    if (!token) {
      console.error('Authentication error: No auth token found.');
      // In a real Angular app, you'd redirect to login or show a user-friendly message
      return throwError(
        () => new Error('Authentication error: No auth token found.')
      );
    }

    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    });

    const tenantProfilesUrl = `${environment.apiUrl}/api/TenantProfile/GetAll`;

    return this.http.get<any[]>(tenantProfilesUrl, { headers }).pipe(
      map((data) => {
        if (data && Array.isArray(data) && data.length > 0) {
          // Find the tenantProfileID with the highest value
          const latestProfile = data.reduce((prev, current) =>
            prev.tenantProfileID > current.tenantProfileID ? prev : current
          );
          return latestProfile.tenantProfileID;
        } else {
          console.warn('No tenant profiles found or data is empty.');
          return null;
        }
      }),
      catchError((error) => {
        console.error('Error fetching tenant profiles:', error);
        return throwError(() => new Error('No Tenant Profiles.'));
      })
    );
  }

  setEmpSubTab(tab: 'employeesList' | 'salariesList' | 'rolesList') {
    this.empSubTab = tab;
  }

  originalRoleState: { [key: number]: Role } = {};

  newEmployeesCounter: number = 0; // For temporary negative IDs for new employees

  // Store original state of employees being edited or toggled status
  originalEmployeeState: { [employeeID: number]: Employee } = {};

  // Pending changes for batch saving

  // Modal properties (similar to your Roles component)

  newRolesCounter: number = 0; // To help with unique IDs for new rows before saving
  // Modal properties
  showSaveModal: boolean = false;
  isSaving: boolean = false;
  isSuccess: boolean | null = null;

  // New properties to track changes for the "Save All Changes" button
  rolesToDelete: Role[] = []; // Stores roles marked for deletion
  pendingChanges: {
    added: Role[];
    updated: Role[];
    deleted: Role[];
  } = {
    added: [],
    updated: [],
    deleted: [],
  };

  employeeForm: FormGroup;
  displaySaveSuccessMessage: boolean = true;

  editingEmployee: Employee | null = null;

  showEmployeeForm = false;

  roleForm!: FormGroup; // Declare it first (optional ! if not using strict mode)
  private jwtHelper: JwtHelperService = new JwtHelperService();
  constructor(
    private fb: FormBuilder,
    private http: HttpClient,
    private router: Router,
    private route: ActivatedRoute,
    private sanitizer: DomSanitizer,
    private cdr: ChangeDetectorRef,
    private envInjector: EnvironmentInjector,
    private setupService: SetupService,
    private mobileNavService: MobileNavService,
    private authService: AuthService,
    private toast: ToastService
  ) {
    // Initialize all forms inside constructor
    this.employeeForm = this.fb.group({
      firstName: ['', [Validators.required, Validators.maxLength(50)]],
      lastName: ['', [Validators.required, Validators.maxLength(50)]],
      contactInfo: ['', [Validators.maxLength(100)]],
      hireDate: ['', Validators.required],
      isActive: [true, Validators.required],
      roleID: ['', Validators.required],
    });

    this.salaryForm = this.fb.group({
      salaryID: [null],
      employeeID: [null, Validators.required],
      periodTypeID: [null, Validators.required],
      effectiveFromDate: ['', [Validators.required, this.dateValidator()]],
      effectiveToDate: [null, this.dateValidator()],
      amount: [
        null,
        [
          Validators.required,
          Validators.min(0),
          Validators.pattern(/^\d*\.?\d{0,2}$/),
        ],
      ],
      hoursWorked: [
        null,
        [
          Validators.required,
          Validators.min(0),
          Validators.pattern(/^\d*\.?\d{0,2}$/),
        ],
      ],
      currency: ['ZAR', Validators.required],
    });

    this.roleForm = this.fb.group({
      roleName: ['', Validators.required],
      description: [''],
    });
  }

  getPeriodTypeDescription(periodTypeId: number | null | undefined): string {
    // <--- CHANGE THIS LINE
    if (
      periodTypeId === null ||
      periodTypeId === undefined ||
      this.periodTypes.length === 0
    ) {
      return 'N/A'; // Or whatever placeholder text you prefer
    }
    const periodType = this.periodTypes.find(
      (pt) => pt.periodTypeID === periodTypeId
    );
    return periodType ? periodType.description : 'Unknown Period Type';
  }

  // Helper method to check if salary is hourly payment type
  isHourlyPaymentType(salary: Salary): boolean {
    const hourlyPeriodType = this.periodTypes.find(
      (pt) => pt.description.toLowerCase() === 'hourly'
    );
    return !!(hourlyPeriodType && salary.periodTypeID === hourlyPeriodType.periodTypeID);
  }

  isTokenExpired(): Observable<boolean> {
    const token = localStorage.getItem('authToken');
    if (!token) return of(true); // No token, consider expired
    try {
      return of(this.jwtHelper.isTokenExpired(token)); // Check expiration
    } catch (e) {
      console.error('Error decoding token:', e);
      return of(true); // Invalid token, consider expired
    }
  }

  loadEmployeesAndRoles(): void {
    this.loading = true;
    const token = localStorage.getItem('authToken');
    if (!token) {
      this.errorMessage = '⚠️Authentication error. Please log in again.';
      this.loading = false;
      return;
    }

    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    });

    // Create observables for fetching employees and roles
    const employees$ = this.http.get<Employee[]>(
      `${environment.apiUrl}/api/Employees/GetAll`,
      { headers }
    );
    const roles$ = this.http.get<Role[]>(
      `${environment.apiUrl}/api/Role/GetAll`,
      { headers }
    ); // Assuming you have a GetAll for Roles

    // Use forkJoin to wait for both observables to complete
    forkJoin([employees$, roles$]).subscribe({
      next: ([employeesData, rolesData]) => {
        this.roles = rolesData; // Store all roles

        // Map roles to a dictionary for faster lookup
        const roleMap = new Map<number, Role>();
        this.roles.forEach((role) => {
          if (role.roleID === null) return;
          roleMap.set(role.roleID, role);
        });

        // Populate roleDescription for each employee
        this.employees = employeesData.map((emp) => {
          const role = roleMap.get(emp.roleID!); // Use non-null assertion if roleID is always present and valid
          return {
            ...emp,
            roleDescription: role ? role.roleName : 'N/A', // Prefer description, fallback to roleName
            originalIsActive: emp.isActive, // Initialize original states
            isModified: false,
            isEditing: false,
            isNew: false,
            originalEmployee: {
              ...emp,
              roleDescription: role ? role.description || role.roleName : 'N/A',
            }, // Deep copy with description
          };
        });

        this.loading = false;
        // Optionally, call updateHasPendingEmployeeChanges() if you have a "Save All" button
        // this.updateHasPendingEmployeeChanges();
      },
      error: (err) => {
        this.errorMessage =
          'Failed to load data: ' + (err.message || 'Unknown error');
        this.loading = false;
        console.error(err);
      },
    });
  }

  // You'll also need a helper for your select option text

  // Remember to call this in ngOnInit()
  // ngOnInit(): void {
  //   this.loadEmployeesAndRoles();
  // }
  onStatusToggle(emp: Employee): void {
    // The [(ngModel)] already updates emp.isActive.
    // Now, we need to mark it as modified if it's not a new employee
    // and its current status differs from its original status.

    if (!emp.isNew) {
      // Only track changes for existing employees
      if (emp.isActive !== emp.originalIsActive) {
        // Mark this employee as needing to be saved
        // This is often done by adding it to a 'pendingChanges' array
        // or setting a 'isModified' flag on the employee object itself.
        emp.isModified = true; // Add a 'isModified' property to your Employee interface
        this.updateHasPendingEmployeeChanges(); // Call a function to re-evaluate overall pending changes
      } else {
        emp.isModified = false;
        this.updateHasPendingEmployeeChanges();
      }
    }
    // If it's a new employee, it's inherently "modified" until saved the first time.
    // The toggle just sets its initial active state.
  }
  updateHasPendingEmployeeChanges(): void {
    // Re-evaluate the hasPendingEmployeeChanges() state
    // This might trigger change detection if you're using it to enable/disable buttons
  }

  // Method to switch main tabs
  setMainTab(tab: string) {
    this.mainActiveTab = tab;
    // If switching to employees main tab, reset empSubTab if desired:
    if (tab === 'employees') {
      this.empSubTab = 'rolesList';
    }
  }

  editRole(role: Role) {
    this.editingRole = role;
    this.roleForm.patchValue({
      roleName: role.roleName,
      description: role.description,
    });
    this.showRoleForm = true;
  }

  deleteRole(roleId: number) {
    if (confirm('Delete this role?')) {
      this.http.delete(`${environment.apiUrl}/Delete/${roleId}`).subscribe({
        next: () => this.loadRoles(),
        error: (err) =>
          (this.errorMessage = err.message || 'Error deleting role.'),
      });
    }
  }
  markRoleForDeletion(role: Role): void {
    // Prevent deletion if the role is currently being edited
    if (role.isEditing) {
      // alert(
      //   'Please save or cancel the current edit before marking this role for deletion.'
      // );
      return;
    }

    // const confirmMessage = `Are you sure you want to mark "${role.roleName}" for deletion? This will remove it from the list immediately. It will be permanently removed from the database when you click "Save Changes".`;
    // if (!confirm(confirmMessage)) {
    //   return; // User cancelled
    // }

    // Handle new roles (which only exist locally)
    if (role.isNew) {
      // Remove from the 'roles' array (UI)
      this.roles = this.roles.filter((r) => r.roleID !== role.roleID);
      // Remove from pending additions if it was previously added
      this.pendingChanges.added = this.pendingChanges.added.filter(
        (r) => r.roleID !== role.roleID
      );
      return; // No need to add to pending.deleted as it never existed on backend
    }

    // Handle existing roles (which exist on backend)
    // First, remove from pending updates if it was being updated
    this.pendingChanges.updated = this.pendingChanges.updated.filter(
      (r) => r.roleID !== role.roleID
    );

    // Check if it's already in pending deletions
    const existingDeletionIndex = this.pendingChanges.deleted.findIndex(
      (r) => r.roleID === role.roleID
    );

    if (existingDeletionIndex === -1) {
      // If not already marked for deletion, add it
      role.isDeleted = true; // Mark for visual indication (optional, but good practice if you want to show a strikethrough)
      this.pendingChanges.deleted.push({ ...role }); // Push a copy
    } else {
      // If it was already marked for deletion, this means the user clicked it again to "un-delete" it.
      // This scenario is less common for a "delete" button that immediately removes from UI,
      // but if you were toggling a "soft delete" visual, this would be the place.
      // For immediate UI removal, this 'else' block might not be strictly needed or might contain different logic.
      // For this setup (immediate UI removal), we don't need to un-mark or keep it in pending.deleted once removed from UI.
      // However, if you want a visual "marked for deletion" then only remove on save, the previous `if/else` toggle was better.
    }

    // Finally, remove the role from the UI (this.roles array)
    this.roles = this.roles.filter((r) => r.roleID !== role.roleID);
  }

  // === "Save All Changes" Logic ===

  // Checks if there are any changes pending
  hasPendingChanges(): boolean {
    return (
      this.pendingChanges.added.length > 0 ||
      this.pendingChanges.updated.length > 0 ||
      this.pendingChanges.deleted.length > 0
    );
  }
  private getAuthHeaders(): HttpHeaders {
    const token = localStorage.getItem('authToken') || sessionStorage.getItem('authToken');
    if (!token) {
      throw new Error('⚠️Authentication error. Please log in again.');
    }
    return new HttpHeaders({
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    });
  }
  confirmSaveAllChanges(): void {
    this.isSaving = true;
    this.modalMessage = 'Saving changes...';
    this.isSuccess = null;

    const headers = this.getAuthHeaders();

    // Group all API calls using forkJoin or handle them sequentially
    // For simplicity, we'll send them one by one. In a real app, consider batching.

    const saveOperations: Promise<any>[] = [];

    // 1. Handle Added Roles
    if (this.pendingChanges.added.length > 0) {
      this.pendingChanges.added.forEach((role) => {
        const rolePayload = {
          roleName: role.roleName,
          description: role.description,
        };
        saveOperations.push(
          this.http
            .post(`${environment.apiUrl}/api/Role/Add`, rolePayload, {
              headers,
            })
            .toPromise() // Convert observable to promise for Promise.all
        );
      });
    }

    // 2. Handle Updated Roles
    if (this.pendingChanges.updated.length > 0) {
      this.pendingChanges.updated.forEach((role) => {
        const rolePayload = {
          roleID: role.roleID,
          roleName: role.roleName,
          description: role.description,
        };
        saveOperations.push(
          this.http
            .put(
              `${environment.apiUrl}/api/Role/Update?RoleId=${role.roleID}`,
              rolePayload,
              { headers }
            )
            .toPromise()
        );
      });
    }

    // 3. Handle Deleted Roles
    if (this.pendingChanges.deleted.length > 0) {
      this.pendingChanges.deleted.forEach((role) => {
        saveOperations.push(
          this.http
            .delete(
              `${environment.apiUrl}/api/Role/Delete?RoleId=${role.roleID}`,
              { headers }
            )
            .toPromise()
        );
      });
    }

    // Execute all save operations concurrently
    Promise.all(saveOperations)
      .then(() => {
        this.modalMessage = this.sanitizer.bypassSecurityTrustHtml(`
  <span style="display: flex; align-items: center; gap: 8px;">
    All changes saved successfully
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="color: #28a745;">
        <path d="M22 11.08V12a10 10 0 1 1-5.93-8.15"></path>
        <polyline points="22 4 12 14.01 9 11.01"></polyline>
    </svg>
  </span>
`);
        this.isSuccess = true;
        this.isSaving = false;
        // Reload roles to get fresh data from the server and clear all local state
        this.loadRoles();
        // Optionally, close modal after a short delay
        setTimeout(() => this.closeSaveModal(), 5000);
      })
      .catch((error) => {
        this.modalMessage =
          'Failed to save all changes. Some operations might have failed.';
        this.isSuccess = false;
        this.isSaving = false;
        console.error('Error saving changes:', error);
        // Optionally, reload roles even on error to reflect server state
        // and discard local unsaved changes, or provide specific error details
        // this.loadRoles();
      });
  }
  private clearPendingChanges(): void {
    this.pendingChanges = {
      added: [],
      updated: [],
      deleted: [],
    };
  }
  // Opens the save confirmation modal
  openSaveAllChangesModal(): void {
    this.isSaving = false;
    this.modalMessage = null;
    this.isSuccess = null;

    // First, ensure all inline edits are "saved" to pendingChanges or cancelled
    // This is crucial. If a user is actively editing a row and clicks "Save Changes"
    // that row's changes might not be in pendingChanges.updated yet.
    // A robust solution would iterate `this.roles` and if `isEditing` is true,
    // call `saveRoleInline` for that role, or force cancel and alert the user.
    // For simplicity, let's just make sure no role is currently in editing mode.
    const activeEdits = this.roles.some((role) => role.isEditing);
    if (activeEdits) {
      this.showMessageModal = true;
      this.alertInfo = `⚠️Please save or cancel all active inline edits before saving all changes.`;

      return;
    }

    // Populate pendingChanges if any role was saved inline without immediate API call
    // (This is handled by saveRoleInline, so just ensure it's up to date)
    // The `pendingChanges` object should already be populated by `saveRoleInline`
    // and `markRoleForDeletion`.

    if (this.hasPendingChanges()) {
      this.showSaveModal = true;
    } else {
      this.showMessageModal = true;
      this.alertInfo = `⚠️No changes to save`;

      //alert('No changes to save.');
    }
  }

  closeSaveModal(): void {
    this.showSaveModal = false;
    this.isSaving = false;
    this.modalMessage = null;
    this.isSuccess = null;
  }
  // Method to switch sub-tabs within Employees

  // Load all employees

  // Load all salaries
  loadSalaries(): void {
    this.loading = true;
    this.errorMessage = null;
    const headers = this.getAuthHeaders();
    this.http
      .get<any[]>( // Get as 'any[]' because we'll process the date strings
        `${environment.apiUrl}/api/EmployeeSalaries/GetAll`,
        { headers }
      )
      .subscribe({
        next: (data: any[]) => {
          this.employeeSalaries = data.map((sal: any) => {
            // Helper function to format any date string to YYYY-MM-DD
            // This ensures the HTML date input can read it correctly.
            const formatToYYYYMMDD = (
              dateStr: string | null | undefined
            ): string | null => {
              if (!dateStr) {
                return null;
              }
              try {
                // Create a Date object from the API string
                const date = new Date(dateStr);
                // Check if date is valid
                if (isNaN(date.getTime())) {
                  console.warn(
                    'Invalid date string received from API:',
                    dateStr
                  );
                  return null; // Or return an empty string/original string
                }
                // Get the YYYY-MM-DD part
                return date.toISOString().split('T')[0];
              } catch (e) {
                console.error('Error formatting date:', dateStr, e);
                return null;
              }
            };

            const formattedFromDate = formatToYYYYMMDD(sal.effectiveFromDate);
            const formattedToDate = formatToYYYYMMDD(sal.effectiveToDate);

            const salary: Salary = {
              ...sal, // Copy existing properties
              // Override date properties with the correctly formatted strings
              effectiveFromDate: formattedFromDate || '', // Default to empty string for date input if null
              effectiveToDate: formattedToDate,
              // Ensure salaryID is correctly typed as number | null
              salaryID:
                sal.salaryID !== undefined && sal.salaryID !== null
                  ? Number(sal.salaryID)
                  : null,
              isEditing: false,
              isNew: false,
            };
            // Store the original salary using the correctly formatted dates
            salary.originalSalary = { ...salary };
            return salary;
          });

          this.loading = false;
        },
        error: (err) => {
          console.error('Error loading salaries:', err);
          this.errorMessage =
            '⚠️Failed to load salaries. Please try again later.';
          this.loading = false;
        },
      });
  }
  // Load period types
  initializeHoursOpenPerMonth(): Observable<number> {
    const headers = new HttpHeaders({
      Authorization: `Bearer ${localStorage.getItem('authToken') || ''}`,
      'Content-Type': 'application/json',
    });
    return this.getLatestTenantProfileId().pipe(
      tap((tenantProfileId) => {
        if (tenantProfileId === null) {
          console.warn(
            'initializeHoursOpenPerMonth: No latest tenant profile ID found. Returning 0 hours.'
          );
        }
      }),
      switchMap((tenantProfileId) => {
        if (tenantProfileId === null) {
          const fallback = this.computeHoursOpenPerMonthFromSchedule(
            this.operatingHours
          );
          if (fallback > 0) {
            this._hoursOpenPerMonth = fallback;
            this.isOperatingScheduleLoaded = true;
            return of(fallback);
          }
          return of(0);
        }

        const scheduleUrl = `${environment.apiUrl}/api/OperatingSchedule/${tenantProfileId}/schedule`;
        return this.http
          .get<OperatingSchedule[]>(scheduleUrl, { headers })
          .pipe(
            tap((schedule) => {
              if (!schedule || schedule.length === 0) {
                console.warn(
                  'initializeHoursOpenPerMonth: Fetched schedule is empty or null.'
                );
              }
            }),
            map((schedule) => {
              const hours = this.computeHoursOpenPerMonthFromSchedule(schedule);
              this._hoursOpenPerMonth = hours;
              this.isOperatingScheduleLoaded = true;
              return hours;
            }),
            catchError((err) => {
              console.error(
                'initializeHoursOpenPerMonth: Error fetching or processing operating schedule:',
                err
              );
              this._hoursOpenPerMonth = 0;
              return of(0);
            })
          );
      })
    );
  }
  loadPeriodTypes(): void {
    const token = localStorage.getItem('authToken');
    if (!token) {
      this.errorMessage = '⚠️Authentication error. Please log in again.';
      this.loading = false;
      return;
    }

    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    });
    this.http
      .get<PeriodType[]>(`${environment.apiUrl}/api/PeriodTypes/GetAll`, {
        headers,
      })
      .subscribe({
        next: (data) => {
          this.periodTypes = data;
        },
        error: (err) => {
          this.errorMessage = 'Failed to load period types';
          console.error(err);
        },
      });
  }

  // Load roles
  loadRoles(): void {
    const token = localStorage.getItem('authToken');
    if (!token) {
      this.showMessageModal = true;
      this.alertInfo = `⚠️Session time expired. Please Login`;

      return;
    }

    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    });

    this.http
      .get<Role[]>(`${environment.apiUrl}/api/Role/GetAll`, { headers })
      .subscribe({
        next: (data) => {
          // ✅ Filter out admin roles before assigning
          this.roles = data
            .filter((r) => !r.isAdmin)
            .map((r) => ({
              ...r,
              isEditing: false,
              isNew: false,
            }));
        },
        error: (err) => {
          this.errorMessage = 'Failed to load roles';
          console.error(err);
        },
      });
  }

  addNewRole() {
    // Remove any unsaved new row first
    this.roles = this.roles.filter((r) => !r.isNew);

    // Insert a blank new role at index 0
    const newRole: Role = {
      roleID: null,
      roleName: '',
      description: '',
      isNew: true,
      isEditing: true,
      isAdmin: false,
    };
    this.roles.unshift(newRole);
  }
  startEditRole(role: Role) {
    // === ADD THIS LINE ===
    if (role.roleID != null) {
      // This correctly copies the *current* state of 'role'
      this.originalRoleState[role.roleID] = { ...role };
    }
    role.isEditing = true;
    role.isNew = role.isNew === true;
  }
  cancelRoleEdit(role: Role, index: number): void {
    // If it's a new unsaved role, remove it from the list
    if (role.isNew) {
      this.roles.splice(index, 1);
      // Also remove from pendingChanges.added if it was there (shouldn't be, but good for robustness)
      this.pendingChanges.added = this.pendingChanges.added.filter(
        (r) => r.roleID !== role.roleID
      );
    }
    // If it's an existing role that was being edited, revert to original state
    else if (role.roleID !== null && this.originalRoleState[role.roleID]) {
      const original = this.originalRoleState[role.roleID];
      // Revert the properties of the role object in the 'roles' array
      role.roleName = original.roleName;
      role.description = original.description;
      role.isEditing = false;
      delete this.originalRoleState[role.roleID]; // Clear original state
      // If this role was previously marked for update, remove it from pending updates
      this.pendingChanges.updated = this.pendingChanges.updated.filter(
        (r) => r.roleID !== role.roleID
      );
    }
    role.isEditing = false; // Ensure editing mode is off
  }

  saveRoleInline(role: Role, index: number): void {
    // 1. Basic Validation (Client-side)
    if (!role.roleName || role.roleName.trim() === '') {
      this.errorMessage = 'Role name is required.';
      return;
    }
    this.errorMessage = null; // Clear previous error

    // 2. Mark role as not editing
    role.isEditing = false;

    // 3. Handle New Roles
    if (role.isNew) {
      // Check if this specific new role is already in pendingChanges.added
      const existingNewIndex = this.pendingChanges.added.findIndex(
        (r) => r.roleID === role.roleID
      );

      // Create a clean copy to add to pendingChanges (without UI flags like isEditing, isNew)
      // and ensuring roleID is null for new backend creation.
      const newRolePayload = {
        roleID: null, // Ensure ID is null for new creation on backend
        roleName: role.roleName.trim(),
        description: role.description?.trim() || '',
      };

      if (existingNewIndex > -1) {
        // Update existing entry in pendingChanges.added (e.g., if user edited it multiple times before saving all)
        this.pendingChanges.added[existingNewIndex] = {
          ...newRolePayload,
          isNew: true,
          isEditing: false,
          isDeleted: false,
          roleID: role.roleID,
          isAdmin: role.isAdmin,
        }; // Keep temporary roleID for internal tracking until batch save
      } else {
        // Add to pendingChanges.added
        this.pendingChanges.added.push({
          ...newRolePayload,
          isNew: true,
          isEditing: false,
          isDeleted: false,
          roleID: role.roleID,
          isAdmin: false,
        }); // Keep temporary roleID
      }
    }
    // 4. Handle Existing Roles (Updated)
    else if (role.roleID !== null && this.originalRoleState[role.roleID]) {
      const original = this.originalRoleState[role.roleID];

      // Compare current state with original state to detect actual changes
      const isNameChanged = role.roleName.trim() !== original.roleName.trim();
      const isDescriptionChanged =
        (role.description?.trim() || '') !==
        (original.description?.trim() || '');

      if (isNameChanged || isDescriptionChanged) {
        // Create a clean copy to add to pendingChanges
        const updatedRolePayload = {
          roleID: role.roleID,
          roleName: role.roleName.trim(),
          description: role.description?.trim() || '',
        };

        // Check if this role is already in pendingChanges.updated
        const existingUpdatedIndex = this.pendingChanges.updated.findIndex(
          (r) => r.roleID === role.roleID
        );
        if (existingUpdatedIndex > -1) {
          // Update existing entry in pendingChanges.updated
          this.pendingChanges.updated[existingUpdatedIndex] = {
            ...updatedRolePayload,
            isEditing: false,
            isNew: false,
            isDeleted: false,
            isAdmin: role.isAdmin || false, // Ensure isAdmin is set correctly
          };
        } else {
          // Add to pendingChanges.updated
          this.pendingChanges.updated.push({
            ...updatedRolePayload,
            isEditing: false,
            isNew: false,
            isDeleted: false,
            isAdmin: false,
          });
        }
      } else {
      }

      // 5. Clear original state as this role is no longer actively being edited
      delete this.originalRoleState[role.roleID];
    }
    // No API calls here! The actual API calls happen in confirmSaveAllChanges()
  }

  // Delete: if new (unsaved), just remove row; if existing, call DELETE then remove
  deleteRoleInline(role: Role, index: number) {
    if (role.isNew) {
      // Just drop the unsaved row
      this.roles.splice(index, 1);
      return;
    }
    if (role.roleID == null) {
      return;
    }
    if (!confirm('Delete this role?')) {
      return;
    }
    const token = localStorage.getItem('authToken');
    if (!token) {
      this.showMessageModal = true;
      this.alertInfo = `⚠️Session time expired. Please Login`;
      return;
    }
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    });
    this.http
      .delete(`${environment.apiUrl}/api/Role/Delete/${role.roleID}`, {
        headers,
      })
      .subscribe({
        next: () => {
          this.roles.splice(index, 1);
          if (role.roleID != null) {
            delete this.originalRoleState[role.roleID];
          }
        },
        error: (err) => {
          console.error('Error deleting role:', err);
          this.errorMessage = err.message || 'Error deleting role.';
        },
      });
  }
  saveEmployee() {}
  // Create or update salary

  // Edit employee
  editEmployee(employee: Employee): void {
    this.editingEmployee = employee;
    this.employeeForm.patchValue({
      firstName: employee.firstName,
      lastName: employee.lastName,
      contactInfo: employee.contactInfo,
      hireDate: new Date(employee.hireDate).toISOString().split('T')[0],
      isActive: employee.isActive,
      roleID: employee.roleID,
    });
    this.showEmployeeForm = true;
  }

  // Edit salary
  editSalary(salary: Salary): void {
    // <--- Change EmployeeSalary to Salary here
    this.editingSalary = salary;
    this.salaryForm.patchValue({
      employeeID: salary.employeeID,
      effectiveFromDate: new Date(salary.effectiveFromDate) // Convert string to Date for ISO string formatting
        .toISOString()
        .split('T')[0],
      effectiveToDate: salary.effectiveToDate // Check for null before converting
        ? new Date(salary.effectiveToDate).toISOString().split('T')[0]
        : null,
      amount: salary.amount,
      hoursWorked: salary.hoursWorked,
      currency: salary.currency,
      periodTypeID: salary.periodTypeID,
    });
    this.showSalaryForm = true;
  }

  // Delete employee
  deleteEmployee(id: number, skipConfirm: boolean = false): void {
    if (skipConfirm || confirm('Are you sure you want to delete this employee?')) {
      const headers = this.getAuthHeaders();
      this.http
        .delete(`${environment.apiUrl}/api/Employees/Delete/${id}`, { headers })
        .subscribe({
          next: () => {
            this.loadEmployeesAndRoles();
            this.toast.success('Employee deleted successfully', 3000);
          },
          error: (err) => {
            this.errorMessage = 'Failed to delete employee';
            console.error(err);
          },
        });
    }
  }

  // Delete salary
  deleteSalary(id: number, skipConfirm: boolean = false): void {
    if (skipConfirm || confirm('Are you sure you want to delete this salary record?')) {
      // Temp IDs are Date.now() values — always larger than int32 max (2,147,483,647)
      if (id > 2_147_483_647) {
        this.employeeSalaries = this.employeeSalaries.filter(s => s.salaryID !== id);
        this.toast.success('Salary record deleted successfully', 3000);
        return;
      }
      const headers = this.getAuthHeaders();
      this.http
        .delete(`${environment.apiUrl}/api/EmployeeSalaries/Delete/${id}`, {
          headers,
        })
        .subscribe({
          next: () => {
            this.loadSalaries();
            this.toast.success('Salary record deleted successfully', 3000);
          },
          error: (err) => {
            this.errorMessage = 'Failed to delete salary record';
            console.error(err);
          },
        });
    }
  }

  // Cancel employee edit

  // Cancel salary edit

  // Format date for display

  // Toggle employee status

  // Get employee name by ID
  getEmployeeName(id: number | null): string {
    // Allow 'id' to be number or null
    // Handle null or undefined IDs
    if (id === null || id === undefined) {
      return 'Not Assigned'; // Or 'N/A', 'Select Employee', etc.
    }

    // Convert 'id' to a number for reliable comparison, similar to the periodType fix
    const searchId = typeof id === 'string' ? parseInt(id, 10) : id;

    // Find the employee in the 'employees' array
    const employee = this.employees.find((emp) => emp.employeeID === searchId);

    // Return the employee's full name, or 'Unknown' if not found
    return employee ? `${employee.firstName} ${employee.lastName}` : 'Unknown';
  }

  // Get period type description by ID
  windowScrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
  onValidateNext() {
    this.showAlertMessageFromNext = true;
    this.onTabChangeCall = true;

    this.windowScrollToTop();

    const currentIndex = this.tabs.indexOf(this.mainActiveTab);

    // If we’re on the “details” tab, load trading hours
    if (this.mainActiveTab === 'details') {
      this.loadTradingHours();
    }
    if (!this.isLast) {
      // Move to next tab
      this.mainActiveTab = this.tabs[currentIndex + 1];
      this.cdr.detectChanges();
    }
  }

  onNext(): void {
    if (this.mainActiveTab === 'expenses') {
      const variableOverheadValid = this.validateVariableOverheads();
      const fixedOverheadValid = this.validateFixedOverheads();
      if (!variableOverheadValid) {
        this.displayMessage(
          '⚠️Please correct the invalid fields and remember to Save inline.'
        );
        this.cdr.detectChanges();

        return;
      } else {
        this.onValidateNext();
        this.onSaveVariableOverheads('tab-change');
      }

      if (!fixedOverheadValid) {
        this.displayMessage(
          '⚠️Please correct the invalid fields and remember to Save inline.'
        );
        this.cdr.detectChanges();
        return;
      } else {
        this.onValidateNext();
        this.onSaveFixedOverheads('tab-change');
      }
    }

    if (this.mainActiveTab === 'schedule') {
      if (!this.validateScheduleFields()) {
        return;
      }
      this.handleSubmitSchedule('tab-change');
      this.onValidateNext();
    }
    if (this.mainActiveTab === 'details') {
      if (!this.validateDetailsAndChallengesFields()) {
        this.displayMessage(
          '⚠️Please fill in all required fields and remember to Save.'
        );
        return;
      }

      this.onValidateNext();
      this.handleSubmitDetailsAndChallenges('tab-change');
    }
  }
  onAllValidPrev() {
    this.showAlertMessageFromNext = true;
    this.onTabChangeCall = true;
    this.windowScrollToTop();
    const currentIndex = this.tabs.indexOf(this.mainActiveTab);
    if (currentIndex > 0) {
      this.mainActiveTab = this.tabs[currentIndex - 1];
      this.cdr.detectChanges();
    }
  }
  onPrevious() {
    // First update current details
    if (this.mainActiveTab === 'expenses') {
      const variableOverheadValid = this.validateVariableOverheads();
      const fixedOverheadValid = this.validateFixedOverheads();
      if (!variableOverheadValid) {
        this.displayMessage(
          '⚠️Please correct the invalid fields and remember to Save inline.'
        );
        this.cdr.detectChanges();

        return;
      } else {
        this.onSaveVariableOverheads('tab-change');
      }

      if (!fixedOverheadValid) {
        this.displayMessage(
          '⚠️Please correct the invalid fields and remember to Save inline.'
        );
        this.cdr.detectChanges();
        return;
      } else {
        this.onSaveFixedOverheads('tab-change');
      }
    }
    if (this.mainActiveTab == 'details') {
      if (!this.validateDetailsAndChallengesFields()) {
        this.displayMessage(
          '⚠️Please fill in all required fields and remember to Save.'
        );
        return;
      }
      this.onAllValidPrev();
      this.handleSubmitDetailsAndChallenges('tab-change');
    }

    if (this.mainActiveTab == 'schedule') {
      if (!this.validateScheduleFields()) {
        return;
      }
      this.handleSubmitSchedule('tab-change');
      this.onAllValidPrev();
    }
  }
  onUpdate() {
    this.onSubmit();
  }
  getPublicHolidaysForCurrentYear(): void {
    const year = this.currentYear;
    const from = `${year}-01-01`;
    const to = `${year}-12-31`;

    const params = new HttpParams()
      .set('countryIsoCode', 'ZA')
      .set('languageIsoCode', 'EN')
      .set('validFrom', from)
      .set('validTo', to);

    const token = localStorage.getItem('authToken');
    if (!token) {
      this.showMessageModal = true;
      this.alertInfo = `⚠️Session time expired. Please Login`;

      return;
    }
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    });
    this.http
      .get(`${environment.apiUrl}/api/Holidays/PublicHolidays`, {
        headers,
        params,
      })
      .subscribe({
        next: (data: any) => {
          this.holidays = data;
          this.prefillHolidaysAsExceptions();
        },
        error: (err) => {
          console.error('❌ Failed to fetch holidays:', err);
        },
      });
  }
  private prefillHolidaysAsExceptions(): void {
    this.exceptions = this.holidays.map((holiday) => ({
      exceptionDate: holiday.startDate, // Use startDate for the exception date
      openTime: '00:00', // Holidays are typically full day, so set a default time or leave empty if not applicable
      closeTime: '23:59', // Same as above
      isClosed: true, // Public holidays usually mean the business is closed
      reason: holiday.name.length > 0 ? holiday.name[0].text : 'Public Holiday', // Use the English name as the reason
    }));
  }
  ngOnInit(): void {
    const JWT = localStorage.getItem('authToken');
    const decodedToken: any = jwtDecode(JWT!);
    this.tenantName = decodedToken.TenantName;
    this.fullName = decodedToken.FullName;
    //this.getPublicHolidaysForCurrentYear();
    this.isProcessing = true;

    // Read the tab parameter from the query string
    this.route.queryParams.subscribe(params => {
      if (params['tab'] && this.tabs.includes(params['tab'])) {
        this.mainActiveTab = params['tab'];
      }
    });

    // First, initialize ALL dropdown options synchronously
    this.initializeAllDropdownOptions();

    // Then initialize async operations
    this.initializeHoursOpenPerMonth().subscribe((hours) => {
      this._hoursOpenPerMonth = hours;

      this.loadSalaries(); // Load salaries after hours are initialized
    });

    // Load data operations
    this.loadAllOverheadRelatedData();
    this.loadInitialData();
    this.loadFixedOverheads();
    this.loadRoles();
    this.loadEmployeesAndRoles();
    this.loadTradingHours();
    this.loadPeriodTypes();
    this.loadSalaries();

    // Load existing profile AFTER all options are initialized
    // Add a small delay to ensure change detection has run
    setTimeout(() => {
      this.loadExistingProfile();
    }, 0);

    // Initialize overhead items
    this.initializeOverheadItems();
  }

  private initializeAllDropdownOptions(): void {
    // Business Models
    this.businessModels = [
      { value: 'Business to Customer', label: 'Business to Customer' },
      { value: 'Direct to Consumer', label: 'Direct to Consumer' },
      { value: 'Business to Business', label: 'Business to Business' },
      { value: 'Franchise', label: 'Franchise' },
    ];

    // Industry Map
    this.industryMap = {
      'Trade & Retail': [
        { value: 'Pharmacy', label: 'Pharmacy' },
        { value: 'Street Market Vendors', label: 'Street Market Vendors' },
        {
          value: 'Second-hand Clothing Stores',
          label: 'Second-hand Clothing Stores',
        },
        { value: 'Convenience Stores', label: 'Convenience Stores' },
        {
          value: 'Mobile Phone Accessory Kiosks',
          label: 'Mobile Phone Accessory Kiosks',
        },
      ],
      'Professional / Scientific / Technical': [
        {
          value: 'Freelance Graphic Designers',
          label: 'Freelance Graphic Designers',
        },
        { value: 'IT Consulting Firms', label: 'IT Consulting Firms' },
        { value: 'Engineering Consultants', label: 'Engineering Consultants' },
        { value: 'Freelance Architects', label: 'Freelance Architects' },
        {
          value: 'Independent Scientific Researchers',
          label: 'Independent Scientific Researchers',
        },
      ],
      'Hospitality & Food Services': [
        { value: 'Cafés & Coffee Shops', label: 'Cafés & Coffee Shops' },
        { value: 'Food Trucks', label: 'Food Trucks' },
        { value: 'Local Bakeries', label: 'Local Bakeries' },
        {
          value: 'Small Catering Businesses',
          label: 'Small Catering Businesses',
        },
        {
          value: 'Home-based Food Providers',
          label: 'Home-based Food Providers',
        },
      ],
      'Personal Services': [
        { value: 'Hair & Beauty Salons', label: 'Hair & Beauty Salons' },
        { value: 'Barber', label: 'Barber' },
        {
          value: 'Tailoring & Clothing Repairs',
          label: 'Tailoring & Clothing Repairs',
        },
        { value: 'Massages', label: 'Massages' },
        { value: 'Spa"s', label: 'Spa"s' },
      ],
      'General Services': [
        { value: 'Auto Mechanic', label: 'Auto Mechanic' },
        {
          value: 'Electronic Device Repairs',
          label: 'Electronic Device Repairs',
        },
        { value: 'Electrical Services', label: 'Electrical Services' },
        { value: 'Plumbing', label: 'Plumbing' },
        {
          value: 'Gardening & Tree Felling Services',
          label: 'Gardening & Tree Felling Services',
        },
      ],
      'Manufacturing / Handicraft': [
        { value: 'Furniture Makers', label: 'Furniture Makers' },
        { value: 'Handmade Jewellery', label: 'Handmade Jewellery' },
        { value: 'Textile', label: 'Textile' },
        { value: 'Leather goods', label: 'Leather goods' },
        { value: 'Embroidery', label: 'Embroidery' },
      ],
      'Agriculture & Fishing': [
        {
          value: 'Small-scale Vegetable Farming',
          label: 'Small-scale Vegetable Farming',
        },
        { value: 'Poultry & Egg Farms', label: 'Poultry & Egg Farms' },
        { value: 'Dairy Producers', label: 'Dairy Producers' },
        {
          value: 'Beekeeping and Honey Production',
          label: 'Beekeeping and Honey Production',
        },
        { value: 'Fishing Operations', label: 'Fishing Operations' },
      ],
      'IT / Creative': [
        { value: 'Web Design Agencies', label: 'Web Design Agencies' },
        {
          value: 'Independent Content Creators',
          label: 'Independent Content Creators',
        },
        {
          value: 'Digital Marketing Consultants',
          label: 'Digital Marketing Consultants',
        },
        { value: 'Mobile App Developers', label: 'Mobile App Developers' },
        { value: 'Photography Studios', label: 'Photography Studios' },
      ],
      'Business Admin Support': [
        { value: 'Virtual Assistants', label: 'Virtual Assistants' },
        { value: 'Bookkeeping Services', label: 'Bookkeeping Services' },
        {
          value: 'Freelance Administrative Support',
          label: 'Freelance Administrative Support',
        },
        {
          value: 'Translation & Interpretation Services',
          label: 'Translation & Interpretation Services',
        },
        { value: 'Data Entry Specialists', label: 'Data Entry Specialists' },
      ],
      'Construction & Building Services': [
        { value: 'Small-scale Brickmakers', label: 'Small-scale Brickmakers' },
        { value: 'Painting Contractors', label: 'Painting Contractors' },
        { value: 'Plumbing Services', label: 'Plumbing Services' },
        { value: 'Carpentry Workshops', label: 'Carpentry Workshops' },
        {
          value: 'Residential Renovation Services',
          label: 'Residential Renovation Services',
        },
      ],
      'Transport & Logistics': [
        {
          value: 'Motorcycle Delivery Services',
          label: 'Motorcycle Delivery Services',
        },
        { value: 'Informal Taxi Operators', label: 'Informal Taxi Operators' },
        {
          value: 'Bicycle Courier Services',
          label: 'Bicycle Courier Services',
        },
        { value: 'Small Freight Movers', label: 'Small Freight Movers' },
        { value: 'Local Moving Services', label: 'Local Moving Services' },
      ],
      'Healthcare & Wellness': [
        { value: 'Mobile Health Clinics', label: 'Mobile Health Clinics' },
        { value: 'Home Care Providers', label: 'Home Care Providers' },
        { value: 'Alternative Medicine', label: 'Alternative Medicine' },
        { value: 'Medical Services', label: 'Medical Services' },
        { value: 'Medical Practices', label: 'Medical Practices' },
      ],
      'Real Estate & Rentals': [
        {
          value: 'Property Management Services',
          label: 'Property Management Services',
        },
        { value: 'Rentals', label: 'Rentals' },
        {
          value: 'Short-term Office Rentals',
          label: 'Short-term Office Rentals',
        },
        { value: 'Storage Space Providers', label: 'Storage Space Providers' },
        { value: 'Real Estate Agents', label: 'Real Estate Agents' },
      ],
      Tourism: [
        { value: 'Bed & Breakfasts', label: 'Bed & Breakfasts' },
        { value: 'Tour Guides', label: 'Tour Guides' },
        { value: 'Safari & Hunting', label: 'Safari & Hunting' },
        { value: 'Shuttle service', label: 'Shuttle service' },
        {
          value: 'Vehicle & Equipment Rentals',
          label: 'Vehicle & Equipment Rentals',
        },
      ],
      'Pet Services & Animal Care': [
        { value: 'Pet Grooming', label: 'Pet Grooming' },
        { value: 'Small Vet Clinics', label: 'Small Vet Clinics' },
        { value: 'Dog Walking Services', label: 'Dog Walking Services' },
        { value: 'Pet Boarding Services', label: 'Pet Boarding Services' },
        { value: 'Pet Food Suppliers', label: 'Pet Food Suppliers' },
      ],
      'Events, Media & Entertainment': [
        {
          value: 'Event Planning Businesses',
          label: 'Event Planning Businesses',
        },
        { value: 'Wedding Photographers', label: 'Wedding Photographers' },
        { value: 'Mobile DJs', label: 'Mobile DJs' },
        { value: 'Videographers', label: 'Videographers' },
        {
          value: 'Local Performers & Entertainers',
          label: 'Local Performers & Entertainers',
        },
      ],
      'Financial/Advisory Micro providers': [
        { value: 'Independent Accountants', label: 'Independent Accountants' },
        { value: 'Tax Advisory Services', label: 'Tax Advisory Services' },
        { value: 'Insurance Brokers', label: 'Insurance Brokers' },
        { value: 'Microcredit Providers', label: 'Microcredit Providers' },
        { value: 'Investment Advisers', label: 'Investment Advisers' },
      ],
    };

    // Populate industries dropdown
    this.industries = Object.keys(this.industryMap).map((key) => ({
      value: key,
      label: key,
    }));

    // Business Sizes
    this.businessSizes = [
      { value: 'Startup', label: 'Startup' },
      { value: 'SME', label: 'SME' },
      { value: 'Big Business', label: 'Big Business' },
      { value: 'Enterprise', label: 'Enterprise' },
    ];

    // Target Markets
    this.targetMarkets = [
      { value: 'General Consumers', label: 'General Consumers' },
      {
        value: 'Families with Young Children',
        label: 'Families with Young Children',
      },
      { value: 'Students & Young Adults', label: 'Students & Young Adults' },
      {
        value: 'Income Earning Individuals',
        label: 'Income Earning Individuals',
      },
      {
        value: 'Small & Micro Enterprises',
        label: 'Small & Micro Enterprises',
      },
      { value: 'Medium-sized Enterprises', label: 'Medium-sized Enterprises' },
      { value: 'Retailers & Resellers', label: 'Retailers & Resellers' },
      { value: 'Tourists & Visitors', label: 'Tourists & Visitors' },
      {
        value: 'Restaurants & Food Service Providers',
        label: 'Restaurants & Food Service Providers',
      },
      {
        value: 'Hotels & Accommodation Providers',
        label: 'Hotels & Accommodation Providers',
      },
      { value: 'Government Institutions', label: 'Government Institutions' },
      {
        value: 'Healthcare Clinics & Practices',
        label: 'Healthcare Clinics & Practices',
      },
      { value: 'Educational Institutions', label: 'Educational Institutions' },
      { value: 'Non-profits & NGOs', label: 'Non-profits & NGOs' },
      {
        value: 'Event Management Companies',
        label: 'Event Management Companies',
      },
      {
        value: 'Real Estate Agencies & Property Managers',
        label: 'Real Estate Agencies & Property Managers',
      },
      {
        value: 'Construction Contractors & Property Developers',
        label: 'Construction Contractors & Property Developers',
      },
      { value: 'Pet Owners', label: 'Pet Owners' },
      { value: 'Households', label: 'Households' },
      {
        value: 'Agricultural Businesses & Small-scale Farmers',
        label: 'Agricultural Businesses & Small-scale Farmers',
      },
      { value: 'Other', label: 'Other' },
    ];

    // Vendor Types
    this.vendorTypes = [
      { value: 'Vat Vendor', label: 'VAT Vendor' },
      { value: 'Non-Vat Vendor', label: 'Non-VAT Vendor' },
    ];

    // Sales Channels
    this.salesChannels = [
      { value: 'Direct Sales', label: 'Direct Sales' },
      { value: 'Third Party Retail', label: 'Third Party Retail' },
      { value: 'Online Platforms', label: 'Online Platforms' },
      { value: 'Wholesale & Distribution', label: 'Wholesale & Distribution' },
      { value: 'Subscriptions', label: 'Subscriptions' },
      { value: 'Exhibitions', label: 'Exhibitions' },
      { value: 'Partnerships', label: 'Partnerships' },
      { value: 'Contracts', label: 'Contracts' },
      { value: 'Referrals', label: 'Referrals' },
      { value: 'Markets', label: 'Markets' },
      { value: 'Other', label: 'Other' },
    ];

  this.fixedOverheads = [
  { value: 'Accounting & bookkeeping', label: 'Accounting & bookkeeping' },
  { value: 'Bank charges – monthly fees', label: 'Bank charges – monthly fees' },
  { value: 'Branding (design, printing – amortised if material)', label: 'Branding (design, printing – amortised if material)' },
  { value: 'Business consulting', label: 'Business consulting' },
  { value: 'Business licences & permits', label: 'Business licences & permits' },
  { value: 'Business liability insurance', label: 'Business liability insurance' },
  { value: 'Cleaning', label: 'Cleaning' },
  { value: 'Computers & devices (depreciation-based)', label: 'Computers & devices (depreciation-based)' },
  { value: 'Depreciation', label: 'Depreciation' },
  { value: 'Donations & sponsorships (committed/fixed)', label: 'Donations & sponsorships (committed/fixed)' },
  { value: 'Employee benefits', label: 'Employee benefits' },
  { value: 'Employee salaries (salaried)', label: 'Employee salaries (salaried)' },
  { value: 'Financial advisory & audit', label: 'Financial advisory & audit' },
  { value: 'Furniture', label: 'Furniture' },
  { value: 'Household Support Payments', label: 'Household Support Payments' },
  { value: 'IT support & maintenance', label: 'IT support & maintenance' },
  { value: 'Income tax (planning assumption)', label: 'Income tax (planning assumption)' },
  { value: 'Insurance', label: 'Insurance' },
  { value: 'Interest on overdraft / loans', label: 'Interest on overdraft / loans' },
  { value: 'Lease / loan payments (vehicles)', label: 'Lease / loan payments (vehicles)' },
  { value: 'Legal fees', label: 'Legal fees' },
  { value: 'License & Subscription Fees', label: 'License & Subscription Fees' },
  { value: 'Lights & Water', label: 'Lights & Water' },
  { value: 'Marketing consultants & agencies (retainers)', label: 'Marketing consultants & agencies (retainers)' },
  { value: 'Owner household support payments', label: 'Owner household support payments' },
  { value: 'Owner salary', label: 'Owner salary' },
  { value: 'PAYE / SARS', label: 'PAYE / SARS' },
  { value: 'Professional indemnity insurance', label: 'Professional indemnity insurance' },
  { value: 'Property insurance', label: 'Property insurance' },
  { value: 'Recruitment & hiring (treated as period cost)', label: 'Recruitment & hiring (treated as period cost)' },
  { value: 'Regulatory & compliance fees', label: 'Regulatory & compliance fees' },
  { value: 'Rent', label: 'Rent' },
  { value: 'Repairs & maintenance (planned)', label: 'Repairs & maintenance (planned)' },
  { value: 'Software subscriptions', label: 'Software subscriptions' },
  { value: 'Staff training & development', label: 'Staff training & development' },
  { value: 'Subscriptions (non-software)', label: 'Subscriptions (non-software)' },
  { value: 'Telephone & Internet', label: 'Telephone & Internet' },
  { value: 'Transport Costs', label: 'Transport Costs' },
  { value: 'UIF', label: 'UIF' },
  { value: 'Vehicle insurance', label: 'Vehicle insurance' },
  { value: 'Vehicle licensing', label: 'Vehicle licensing' },
  { value: 'Website hosting & domain', label: 'Website hosting & domain' },
  { value: 'Workers’ compensation', label: 'Workers’ compensation' }
];
   this.variableOverheads = [
  { value: 'Accommodation', label: 'Accommodation' },
  { value: 'Advertising', label: 'Advertising' },
  { value: 'Bad Debt', label: 'Bad Debt' },
  { value: 'Bank Charges', label: 'Bank Charges' },
  { value: 'Bonuses & Commissions', label: 'Bonuses & Commissions' },
  { value: 'Business Travel', label: 'Business Travel' },
  { value: 'Commissions', label: 'Commissions' },
  { value: 'Conference Fees', label: 'Conference Fees' },
  { value: 'Consumables', label: 'Consumables' },
  { value: 'Delivery Fees', label: 'Delivery Fees' },
  { value: 'Digital Advertising', label: 'Digital Advertising' },
  { value: 'Equipment Hire', label: 'Equipment Hire' },
  { value: 'Fines & Penalties', label: 'Fines & Penalties' },
  { value: 'Fuel', label: 'Fuel' },
  { value: 'Gas', label: 'Gas' },
  { value: 'Meals & Entertainment', label: 'Meals & Entertainment' },
  { value: 'Motor Vehicle Expense', label: 'Motor Vehicle Expense' },
  { value: 'Office Supplies', label: 'Office Supplies' },
  { value: 'Outsourced Contractors', label: 'Outsourced Contractors' },
  { value: 'Packaging', label: 'Packaging' },
  { value: 'Packaging Materials', label: 'Packaging Materials' },
  { value: 'Parking & Tolls', label: 'Parking & Tolls' },
  { value: 'Phone', label: 'Phone' },
  { value: 'Postage & Shipping', label: 'Postage & Shipping' },
  { value: 'Print Advertising', label: 'Print Advertising' },
  { value: 'Repairs & Maintenance', label: 'Repairs & Maintenance' },
  { value: 'Sponsorships & Events', label: 'Sponsorships & Events' },
  { value: 'Stationary', label: 'Stationary' },
  { value: 'Training', label: 'Training' },
  { value: 'VAT / Sales Tax', label: 'VAT / Sales Tax' },
  { value: 'Vehicle Maintenance', label: 'Vehicle Maintenance' },
  { value: 'Water & Electricity', label: 'Water & Electricity' }
];

    // Initialize filteredBusinessTypes as empty initially
    this.filteredBusinessTypes = [];
  }

  private initializeOverheadItems(): void {
    // Initialize with one row for each overhead type
    this.fixedOverheadItems.push({
      overhead: '',
      cost: 0,
      periodTypeID: null,
      invalidperiodTypeID: false,
      isEditing: false,
      invalidOverhead: false,
      invalidCost: false,
      createdAt: '',
      validTo: '',
      validFrom: '',
      overheadAllocationRateID: 0,
      overheadCostPoolID: 0,
      touched: false,
    });

    this.variableOverheadItems.push({
      overhead: null,
      customOverhead: null,
      supplierID: null,
      purchasePrice: null,
      purchaseQuantity: null,
      uomID: null,
      overheadCostPoolID: this.variableOverheadCostPoolID,
      isNew: true,
      isEditing: true,
      invalidOverhead: false,
      invalidSupplier: false,
      invalidPurchasePrice: false,
      invalidPurchaseQuantity: false,
      invalidUOM: false,
      overheadName: '',
      lowStockThreshold: null,
      categoryID: null,
      invalidLowStockThreshold: false,
      leadTimeDays: null,
      userIDEntered: 0,
      itemSupplierPriceHistoryID: null,
      touched: false,
    });
  }
  onIndustryChange(): void {
    // Reset the businessType to null when the industry changes.
    // This will force the dropdown to show its placeholder.
    this.businessType = null;

    if (this.industry) {
      this.filteredBusinessTypes = this.industryMap[this.industry];
    } else {
      // If the industry is cleared, clear the business types as well.
      this.filteredBusinessTypes = [];
    }
  }

  isValidOverhead(item: VariableOverheadItem): boolean {
    // Adjust based on your validation logic
    return !!item.overhead || !!item.supplierID || !!item.purchasePrice;
  }
  loadAllOverheadRelatedData(): void {
    const headers = this.getAuthHeaders(); // Assuming this returns HttpHeaders

    this.isLoadingData = true;

    forkJoin({
      // Fetch all lookup data first
      suppliers: this.http
        .get<SupplierDTO[]>(`${environment.apiUrl}/api/Suppliers/GetAll`, {
          headers,
        })
        .pipe(
          tap((data) => console.log('ForkJoin - Suppliers Loaded:', data)),
          catchError((error) => {
            console.error('Error fetching suppliers in forkJoin:', error);

            return of([]);
          })
        ),
      unitsOfMeasure: this.http
        .get<any[]>(`${environment.apiUrl}/api/UnitOfMeasure/GetAll`, {
          headers,
        })
        .pipe(
          map(
            (data: any[]) =>
              data.map((uom) => ({
                uomID: uom.uomid,
                uomCode: uom.uomCode,
                uomName: uom.uomName,
              })) as UnitOfMeasureDTO[]
          ),
          tap((data) => console.log('ForkJoin - Transformed UOM DATA:', data)),
          catchError((error) => {
            console.error(
              'Error fetching units of measure in forkJoin:',
              error
            );

            return of([]);
          })
        ),
      categories: this.http
        .get<CategoryDTO[]>(`${environment.apiUrl}/api/Category/GetAll`, {
          headers,
        })
        .pipe(
          tap((data) => console.log('ForkJoin - Categories Loaded:', data)),
          catchError((error) => {
            console.error('Error fetching categories in forkJoin:', error);

            return of([]);
          })
        ),
      // Then fetch the items themselves, but this will now run AFTER the lookup data is available within the map
      items: this.http
        .get<ItemDTO[]>(`${environment.apiUrl}/api/Items/ByType/3`, { headers })
        .pipe(
          tap((data) => console.log('ForkJoin - Items Loaded (Type 3):', data)),
          catchError((error: HttpErrorResponse) => {
            if (error.status === 404) {
              console.warn(
                'No items of type 3 found (404). Proceeding with empty data.'
              );
              return of([]);
            } else {
              console.error('Error fetching items in forkJoin:', error);

              return throwError(() => error);
            }
          })
        ),
      history: this.http
        .get<ItemSupplierPriceHistoryDTO[]>(
          `${environment.apiUrl}/api/ItemSupplierPriceHistory/GetAll`,
          { headers }
        )
        .pipe(
          tap((data) => console.log('ForkJoin - History Loaded:', data)),
          catchError((error) => {
            console.error('Error fetching history in forkJoin:', error);

            return of([]);
          })
        ),
      supplierLocations: this.http
        .get<SupplierLocationsDTO[]>(
          `${environment.apiUrl}/api/SupplierLocations/GetAll`,
          { headers }
        )
        .pipe(
          tap((data) =>
            console.log('')
          ),
          catchError((error) => {


            return of([]);
          })
        ),
    })
      .pipe(
        map(
          ({
            items,
            history,
            supplierLocations,
            suppliers,
            unitsOfMeasure,
            categories,
          }) => {
            // Assign all lookup data to component properties first
            this.items = items.map((item) => ({
              ...item,
              itemName: item.itemName ? item.itemName.trim() : '',
            }));
            this.suppliers = suppliers; // This is the crucial assignment for your dropdowns
            this.supplierLocations = supplierLocations;
            this.unitsOfMeasure = unitsOfMeasure; // This is the crucial assignment for your dropdowns
            this.categories = categories; // This is the crucial assignment for your dropdowns
            // Create a map for efficient item lookup by itemID
            const itemMap = new Map<number, ItemDTO>();
            this.items.forEach((item) => itemMap.set(item.itemID, item));

            // Create a map for efficient supplier lookup by supplierLocationID
            const supplierLocationToSupplierMap = new Map<number, number>();
            this.supplierLocations.forEach((loc) =>
              supplierLocationToSupplierMap.set(loc.locationID, loc.supplierID)
            );

            // Filter history to only include relevant items (Type 3) and then map
            // You should map directly from the 'items' data to create `VariableOverheadItem`
            // and then potentially find the latest history entry for `itemSupplierPriceHistoryID`, `validFrom`, `leadTimeDays`, `validTo`, `userIDEntered`
            return this.items
              .filter((item) => item.itemTypeID === 3) // Ensure only type 3 items are processed
              .map((item) => {
                const itemName = item.itemName || 'Unknown Item';

                // Determine overheadType and customOverhead
                let overheadType: string = '';
                let customOverheadName: string | undefined = undefined;
                const matchedOption = this.variableOverheads.find(
                  (option) => option.label === itemName
                );
                if (matchedOption) {
                  overheadType = matchedOption.value;
                } else {
                  overheadType = 'custom';
                  customOverheadName = itemName;
                }

                // Find the latest history entry for this item and supplier, if any.
                // You might need a more robust way to determine "latest" if there are multiple entries for the same item/supplier.
                // For simplicity, this takes the first one found or you might want to sort by validFrom/createdAt.
                const latestHistoryEntry = history.find(
                  (hist) =>
                    hist.itemID === item.itemID &&
                    supplierLocationToSupplierMap.get(
                      hist.supplierLocationID
                    ) === item.supplierID
                );

                const variableItem: VariableOverheadItem = {
                  touched: false,
                  variableOverheadItemID: item.itemID, // <-- This is the ItemID from the ItemDTO
                  itemSupplierPriceHistoryID:
                    latestHistoryEntry?.itemSupplierPriceID ?? 0, // Get the ID from the history if it exists
                  leadTimeDays: latestHistoryEntry?.leadTimeDays || null,
                  overhead: overheadType,
                  customOverhead: customOverheadName,
                  validFrom:
                    latestHistoryEntry?.validFrom || new Date().toISOString(), // From history
                  validTo: latestHistoryEntry?.validTo, // From history
                  overheadName: itemName,
                  supplierID: item.supplierID ?? null, // From ItemDTO
                  purchasePrice: item.purchasePrice ?? 0, // From ItemDTO
                  purchaseQuantity: item.purchaseQuantity ?? 0, // From ItemDTO
                  uomID: item.purchaseUOMID ?? 0, // From ItemDTO
                  overheadCostPoolID: this.variableOverheadCostPoolID,
                  categoryID: item.categoryID ?? null,
                  lowStockThreshold: item.lowStockThreshold ?? null,
                  isNew: false,
                  isModified: false,
                  isEditing: false,
                  invalidOverhead: false,
                  invalidSupplier: false,
                  invalidPurchasePrice: false,
                  invalidPurchaseQuantity: false,
                  invalidUOM: false,
                  invalidCategory: false,
                  invalidLowStockThreshold: false,

                  // originalItem for rollback - CRITICAL to keep this consistent
                  originalItem: {
                    variableOverheadItemID: item.itemID,
                    itemSupplierPriceHistoryID:
                      latestHistoryEntry?.itemSupplierPriceID ?? 0,
                    overhead: overheadType,
                    createdBy: latestHistoryEntry?.createdBy || null,
                    leadTimeDays: latestHistoryEntry?.leadTimeDays || null,
                    customOverhead: customOverheadName,
                    validFrom:
                      latestHistoryEntry?.validFrom || new Date().toISOString(),
                    validTo: latestHistoryEntry?.validTo,
                    overheadName: itemName,
                    supplierID: item.supplierID ?? null,
                    purchasePrice: item.purchasePrice ?? 0,
                    purchaseQuantity: item.purchaseQuantity ?? 0,
                    uomID: item.purchaseUOMID ?? 0,
                    overheadCostPoolID: this.variableOverheadCostPoolID,
                    categoryID: item.categoryID ?? null,
                    lowStockThreshold: item.lowStockThreshold ?? null,
                    invalidOverhead: false,
                    invalidSupplier: false,
                    invalidPurchasePrice: false,
                    invalidPurchaseQuantity: false,
                    invalidUOM: false,
                    invalidCategory: false,
                    invalidLowStockThreshold: false,
                  } as unknown as VariableOverheadItem,
                  userIDEntered: null,
                };
                return variableItem;
              });
          }
        )
      )
      .subscribe((mappedData: VariableOverheadItem[]) => {
        this.variableOverheadItems = mappedData;
        this.isLoadingData = false;
        this.cdr.detectChanges(); // Force change detection after all data is ready
      });
  }

  getSupplierDisplayName(supplierId: number | null): string {
    if (supplierId === null) {
      return 'N/A';
    }
    const supplier = this.suppliers.find((s) => s.supplierID === supplierId);
    return supplier ? supplier.companyName : 'Unknown Supplier';
  }
  getUOMDisplayName(uomId: number | null): string {
    if (uomId === null) {
      return 'N/A';
    }
    // This method now correctly looks for uomID (camelCase) because the unitsOfMeasure array
    // has been transformed to use it.
    const uom = this.unitsOfMeasure.find((u) => u.uomID === uomId);

    return uom ? ` ${uom.uomCode}` : 'Unknown UOM';
  }
  getCategoryDisplayName(categoryId: number | null | undefined): string {
    if (categoryId === null || categoryId === undefined) {
      return 'N/A';
    }
    const category = this.categories.find((c) => c.categoryId === categoryId);
    return category ? category.categoryName : 'Unknown Category';
  }

  toggleEditMode(item: FixedOverheadItem): void {
    item.isEditing = !item.isEditing;
    // When entering edit mode, if it's a custom overhead that was loaded
    // and its 'overhead' property is the actual custom name (not 'custom' yet),
    // then set 'overhead' to 'custom' and populate 'customOverhead' for the input field.
    if (item.isEditing) {
      // Check if the current item.overhead is NOT among the original predefined options
      // (and is not already the string 'custom')
      const isPredefined = this.fixedOverheads.some(
        (option) => option.value === item.overhead && option.value !== 'custom' // Exclude the 'custom' option itself
      );

      // If it's not predefined and not already set to 'custom' (meaning it's a dynamically added custom name)
      if (!isPredefined && item.overhead !== 'custom') {
        item.customOverhead = item.overhead; // Move the actual custom name to customOverhead
        item.overhead = 'custom'; // Set dropdown to 'custom'
      }
    }
  }
  // Helper to display overhead type
  getOverheadTypeDisplay(item: any): string {
    if (item.overhead === 'custom') {
      return item.customOverhead || 'Custom Overhead';
    }

    const option = this.fixedOverheads.find(
      (opt) => opt.value === item.overhead
    );
    return option ? option.label : 'Not selected';
  }

  // Helper to display period type
  getPeriodTypeDisplay(periodTypeID: number | null): string {
    const periodType = this.periodTypes.find(
      (pt) => pt.periodTypeID === periodTypeID
    );
    return periodType ? periodType.description : 'Not selected';
  }

  // When adding new overhead

  // Assuming FixedOverheadItem and other interfaces are correctly defined as in previous responses

  loadFixedOverheads(): void {
    this.isProcessing = true;
    const token = localStorage.getItem('authToken');
    if (!token) {
      console.error('Authentication error. Please log in again.');
      return;
    }

    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    });

    this.http
      .get<OverheadCostItemDTO[]>(
        `${environment.apiUrl}/api/OverheadCostItem/GetAll`,
        { headers }
      )
      .subscribe({
        next: (overheadItemsFromApi) => {
          if (!overheadItemsFromApi.length) {
            this.fixedOverheadItems = [];
            this.isProcessing = false;
            return;
          }

          const overheadRequests = overheadItemsFromApi.map((item) =>
            this.http
              .get<OverheadAllocationRateDTO[]>(
                `${environment.apiUrl}/api/OverheadAllocationRate/GetByCostItemId/${item.overheadCostItemID}`,
                { headers }
              )
              .pipe(
                catchError((err) => {
                  if (err.status === 404) {
                    console.warn(
                      `No allocation rate found for CostItemID: ${item.overheadCostItemID}`
                    );
                    return of([]);
                  } else {
                    console.error(
                      `Error fetching rate for CostItemID ${item.overheadCostItemID}`,
                      err
                    );
                    return of([]);
                  }
                }),
                map((allocRates: OverheadAllocationRateDTO[]) => {
                  const allocRate =
                    allocRates.length > 0 ? allocRates[0] : null;

                  let effectiveOverheadName: string;
                  let actualCustomName: string | undefined;

                  if (item.overheadName === 'custom' && item.description) {
                    effectiveOverheadName = 'custom';
                    actualCustomName = item.description;
                  } else {
                    const isPredefined = this.fixedOverheads.some(
                      (option) => option.value === item.overheadName
                    );
                    if (isPredefined) {
                      effectiveOverheadName = item.overheadName;
                    } else {
                      effectiveOverheadName = 'custom';
                      actualCustomName = item.overheadName;
                    }
                  }

                  if (actualCustomName && effectiveOverheadName === 'custom') {
                    const exists = this.fixedOverheads.some(
                      (opt) => opt.value === actualCustomName
                    );
                    if (!exists) {
                      this.fixedOverheads.push({
                        value: actualCustomName,
                        label: actualCustomName,
                      });
                    }
                  }

                  const loadedItem: FixedOverheadItem = {
                    fixedOverheadID: item.overheadCostItemID,
                    overheadAllocationRateID:
                      allocRate?.overheadAllocationRateID || null,
                    overhead: effectiveOverheadName,
                    customOverhead: actualCustomName,
                    cost: allocRate?.rateValue ?? 0,
                    periodTypeID: allocRate?.periodTypeID ?? null,
                    isEditing: false,
                    isNew: false,
                    isModified: false,
                    invalidOverhead: false,
                    invalidCost: false,
                    invalidperiodTypeID: false,
                    createdAt: item.createdAt || new Date().toISOString(),
                    validFrom: allocRate?.validFrom || new Date().toISOString(),
                    validTo: allocRate?.validTo || '2099-12-31T00:00:00Z',
                    // ✅ CRITICAL CHANGE: Assign directly or use nullish coalescing if 0 is *never* a valid ID
                    overheadCostPoolID: item.overheadCostPoolID,
                    touched: false,
                  };

                  loadedItem.originalItem = { ...loadedItem };
                  return loadedItem;
                })
              )
          );

          forkJoin(overheadRequests).subscribe({
            next: (mappedItems) => {
              this.fixedOverheadItems = mappedItems;
              this.isProcessing = false;
            },
            error: (err) => {
              console.error('Error loading overhead items:', err);
              this.fixedOverheadItems = [];
              this.isProcessing = false;
            },
          });
        },
        error: (err) => {
          this.isProcessing = false;
          console.error('Error loading overhead items:', err);
          this.fixedOverheadItems = [];
        },
      });
  }
  closeShowMessageModal() {
    this.showMessageModal = false;
    this.alertInfo = '';
  }
  async loadInitialData(): Promise<void> {
    this.loading = true;
    this.errorMessage = null;

    try {
      const token = localStorage.getItem('authToken');
      if (!token) {
        throw new Error('Authentication token missing. Please log in.');
      }

      const headers = new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      });

      // Use forkJoin to load all data in parallel
      const [roles, periodTypes, employees] = await lastValueFrom(
        forkJoin([
          this.http.get<Role[]>(`${environment.apiUrl}/api/Role/GetAll`, {
            headers,
          }),
          this.http.get<PeriodType[]>(
            `${environment.apiUrl}/api/PeriodTypes/GetAll`,
            { headers }
          ),
          this.http.get<Employee[]>(
            `${environment.apiUrl}/api/Employees/GetAll`,
            { headers }
          ),
        ])
      );

      // ✅ keep only non-admin roles
      this.roles = roles.filter((r) => !r.isAdmin);

      this.periodTypes = periodTypes;

      this.employees = employees.map((emp) => ({
        ...emp,
        isEditing: false,
        isNew: false,
        originalEmployee: { ...emp },
        originalIsActive: emp.isActive,
        roleDescription: this.getRoleDescription(emp.roleID, this.roles),
      }));

      // Load salaries (still async)
      await this.loadSalaries();

      this.loading = false;
    } catch (err: any) {
      console.error('Error loading initial data:', err);
      this.errorMessage = `Failed to load initial data: ${
        err.message || err
      }. Please try again later.`;
      this.loading = false;
    }
  }

  // --- Salary Management Logic (MODIFIED TO USE RAW API CALLS) ---

  loadAllData(): void {
    this.loading = true;
    this.errorMessage = null;

    const headers = this.getAuthHeaders();

    const loadRolesPromise = this.http
      .get<Role[]>(`${environment.apiUrl}/api/Role/GetAll`, { headers })
      .toPromise();
    const loadEmployeesPromise = this.http
      .get<Employee[]>(`${environment.apiUrl}/api/Employees/GetAll`, {
        headers,
      })
      .toPromise();

    Promise.all([loadRolesPromise, loadEmployeesPromise])
      .then(([rolesData, employeesData]) => {
        this.roles = rolesData || [];
        this.employees = (employeesData || []).map((e) => {
          const mapped = {
            ...e,
            // Format hireDate for input[type="date"]
            hireDate: e.hireDate
              ? new Date(e.hireDate).toISOString().split('T')[0]
              : '',
            roleDescription: this.getRoleDescription(e.roleID, this.roles), // Populate display description
            isEditing: false,
            isNew: false,
            isDeleted: false,
          } as Employee;

          // Establish a stable baseline for subsequent edits
          mapped.originalEmployee = {
            employeeID: mapped.employeeID,
            firstName: mapped.firstName,
            lastName: mapped.lastName,
            contactInfo: mapped.contactInfo,
            hireDate: mapped.hireDate,
            roleID: mapped.roleID,
            isActive: mapped.isActive,
          };
          mapped.originalIsActive = mapped.isActive;

          return mapped;
        });
        this.clearPendingEmployeeChanges();
        this.loading = false;
      })
      .catch((err) => {
        this.errorMessage = 'Failed to load employees or roles.';
        this.loading = false;
        console.error('Error loading data:', err);
      });
  }
  dateValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      if (!control.value) {
        return null; // Don't validate empty values, handled by Validators.required
      }
      const date = new Date(control.value);
      if (isNaN(date.getTime())) {
        return { invalidDate: true };
      }
      return null;
    };
  }
  getRoleDescription(roleId: number | null, roles: Role[]): string {
    if (roleId === null) {
      return '—';
    }
    const role = roles.find((r) => r.roleID === roleId);
    // Updated as per previous conversation to consistently show roleName
    return role ? role.roleName : 'Unknown Role';
  }

  formatDate(dateString: string | null): string {
    if (!dateString) return '—';
    try {
      const date = new Date(dateString);
      // Format to DD/MM/YYYY
      return date.toLocaleDateString('en-GB', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
      });
    } catch (e) {
      return dateString; // Return original if parsing fails
    }
  }

  // --- Inline Editing Methods ---
  hasIncompleteEmployee(): boolean {
    // Check if there's any employee currently being edited or newly added
    // that has incomplete 'firstName', 'lastName', or 'roleID'.
    return this.employees.some(
      (emp) =>
        (emp.isEditing || emp.isNew) &&
        (!emp.firstName || !emp.lastName || emp.roleID === null)
    );
  }
  addNewEmployee(): void {
    // Auto-save any incomplete employee before adding a new one
    const incompleteEmployee = this.employees.find(
      (emp) =>
        (emp.isEditing || emp.isNew) &&
        emp.firstName && emp.lastName && emp.roleID !== null
    );

    if (incompleteEmployee) {
      // Find the index of the incomplete employee
      const index = this.employees.indexOf(incompleteEmployee);
      // Automatically save the employee inline
      this.saveEmployeeInline(incompleteEmployee, index);
    }

    // Check if there's still an incomplete employee with missing required fields
    if (this.hasIncompleteEmployee()) {
      this.showMessageModal = true;
      this.alertInfo =
        '⚠️Please complete the current employee entry with all required fields (First Name, Last Name, and Role) before adding a new one.';
      return; // Stop the function execution
    }

    // Clear any existing error messages
    this.errorMessage = null;
    const tempId = --this.newEmployeesCounter; // Unique temporary ID for local tracking
    const newEmployee: Employee = {
      employeeID: tempId,
      firstName: '',
      lastName: '',
      contactInfo: null,
      hireDate: new Date().toISOString().split('T')[0], // Set today's date in YYYY-MM-DD format
      roleID: null, // No role selected initially
      isActive: true,
      isEditing: true, // New employees start in edit mode
      isNew: true,
      isDeleted: false,
      roleDescription: 'N/A', // Default for display
    };
    this.employees.unshift(newEmployee); // Add to the beginning of the array
  }

  startEditEmployee(employee: Employee): void {
    if (employee.isNew || employee.isEditing) {
      return; // Already editing or a new row
    }
    // Store a deep copy of the original state for cancellation and change tracking
    if (employee.employeeID !== null) {
      this.originalEmployeeState[employee.employeeID] = { ...employee };
    }
    // Also capture a per-row baseline used by saveEmployeeInline comparisons
    employee.originalEmployee = {
      employeeID: employee.employeeID,
      firstName: employee.firstName,
      lastName: employee.lastName,
      contactInfo: employee.contactInfo,
      hireDate: employee.hireDate,
      roleID: employee.roleID,
      isActive: employee.isActive,
    };
    employee.isEditing = true;
    employee.isEditing = true;
  }

  saveEmployeeInline(employee: Employee, index: number): void {
    // 1. Client-side Validation
    if (!employee.firstName || employee.firstName.trim() === '') {
      this.errorMessage = 'First Name is required.';
      return;
    }
    if (!employee.lastName || employee.lastName.trim() === '') {
      this.errorMessage = 'Last Name is required.';
      return;
    }
    if (!employee.hireDate || employee.hireDate.trim() === '') {
      this.errorMessage = 'Hire Date is required.';
      return;
    }
    if (employee.roleID === null) {
      this.errorMessage = 'Role is required.';
      return;
    }
    this.errorMessage = null; // Clear previous errors

    // Update the display roleDescription
    employee.roleDescription = this.getRoleDescription(
      employee.roleID,
      this.roles
    );

    // 2. Mark employee as not editing
    // employee.isEditing = false; // This line should be moved for existing employees
    // and set correctly for new employees.

    // Create a clean payload object, ensuring no UI flags are sent to the API
    const employeePayload = {
      employeeID: employee.employeeID,
      firstName: employee.firstName.trim(),
      lastName: employee.lastName.trim(),
      contactInfo: employee.contactInfo?.trim() || null, // Ensure null for empty string
      hireDate: employee.hireDate,
      roleID: employee.roleID,
      isActive: employee.isActive,
    };

    // 3. Handle New Employees
    if (employee.isNew) {
      const existingNewIndex = this.pendingEmployeeChanges.added.findIndex(
        (e) => e.employeeID === employee.employeeID
      );

      if (existingNewIndex > -1) {
        // If it's a new employee that was already being edited (e.g., re-edited before final save)
        this.pendingEmployeeChanges.added[existingNewIndex] = {
          ...employeePayload,
        };
      } else {
        // If it's a completely new employee being added
        this.pendingEmployeeChanges.added.push({ ...employeePayload });
      }

      // After "saving" a new employee inline (to pending), mark it as no longer new/editing for display
      employee.isNew = false;
      employee.isEditing = false;
      employee.originalEmployee = { ...employee }; // Store current state as original for future edits
    }
    // 4. Handle Existing Employees (Updated)
    else if (
      employee.employeeID !== null &&
      employee.originalEmployee // Use the originalEmployee property on the employee itself
    ) {
      const original =
      employee.originalEmployee ||
      (employee.employeeID !== null
        ? this.originalEmployeeState[employee.employeeID]
        : undefined) ||
      {
        employeeID: employee.employeeID,
        firstName: employee.firstName.trim(),
        lastName: employee.lastName.trim(),
        contactInfo: (employee.contactInfo?.trim() || ''),
        hireDate: employee.hireDate,
        roleID: employee.roleID,
        isActive: employee.isActive,
      };

      // Compare current state with original state to detect actual changes
      const hasChanged =
        employee.firstName.trim() !== original.firstName.trim() ||
        employee.lastName.trim() !== original.lastName.trim() ||
        (employee.contactInfo?.trim() || '') !==
          (original.contactInfo?.trim() || '') ||
        employee.hireDate !== original.hireDate ||
        employee.roleID !== original.roleID ||
        employee.isActive !== original.isActive; // This also covers status toggle changes

      if (hasChanged) {
        // If there are changes, add/update the employee in the pending.updated array
        const existingUpdatedIndex =
          this.pendingEmployeeChanges.updated.findIndex(
            (e) => e.employeeID === employee.employeeID
          );

        // Create a payload similar to what saveEmployeeInline creates for consistency
        const employeePayload = {
          employeeID: employee.employeeID,
          firstName: employee.firstName.trim(),
          lastName: employee.lastName.trim(),
          contactInfo: employee.contactInfo?.trim() || null,
          hireDate: employee.hireDate,
          roleID: employee.roleID,
          isActive: employee.isActive,
        };

        if (existingUpdatedIndex > -1) {
          this.pendingEmployeeChanges.updated[existingUpdatedIndex] =
            employeePayload;
        } else {
          // Add to pendingEmployeeChanges.updated
          this.pendingEmployeeChanges.updated.push(employeePayload);
        }
      } else {
        // If no changes, ensure it's not in pending updates
        this.pendingEmployeeChanges.updated =
          this.pendingEmployeeChanges.updated.filter(
            (e) => e.employeeID !== employee.employeeID
          );
      }

      employee.isEditing = false;
      // After inline save, update originalEmployee to reflect current state
      employee.originalEmployee = {
        employeeID: employee.employeeID,
        firstName: employee.firstName,
        lastName: employee.lastName,
        contactInfo: employee.contactInfo,
        hireDate: employee.hireDate,
        roleID: employee.roleID,
        isActive: employee.isActive,
      };
      employee.originalIsActive = employee.isActive;
      // ---------------------------------------------------
    }

    this.updateHasPendingEmployeeChanges(); // Crucial to update the "Save Changes" button state
    this.inlineSaving = true;
    this.confirmSaveAllEmployeesChanges();
  }

  hasIncompleteSalary(): boolean {
    return this.employeeSalaries.some((salary) => {
      // Only check rows being edited or newly added
      if (!(salary.isEditing || salary.isNew)) {
        return false; // Skip entries not being edited or newly added
      }

      // --- Basic Required Field Checks ---
      if (
        salary.employeeID === null ||
        salary.periodTypeID === null ||
        !salary.effectiveFromDate ||
        !salary.currency
      ) {
        return true; // An essential field is missing
      }

      // --- Stronger 'amount' Validation ---
      // Convert the amount to a number explicitly for robust checks.
      // If the input field for amount is directly bound to a 'number' type in ngModel,
      // it might already handle basic conversion. However, for thoroughness,
      // especially if the input is text and then parsed, these checks are vital.
      const parsedAmount = Number(salary.amount);

      if (
        isNaN(parsedAmount) || // Cannot be converted to a number
        !isFinite(parsedAmount) || // Avoids Infinity, -Infinity
        parsedAmount <= 0 // Must be a positive number
        // Add check for whole number if necessary, e.g., if salaries can't have decimals
      ) {
        return true; // Amount is invalid
      }

      // If all checks pass for this salary, it's considered complete for the purpose of blocking a new add.
      return false;
    });
  }

  // Add this method (only addition needed)

  // 1. Corrected addNewSalary() method
  addNewSalary(): void {
    if (!this._hoursOpenPerMonth || this._hoursOpenPerMonth <= 0) {
      console.info('Schedule hours not yet entered — salary will require manual Hours Worked.');
    }

    // Auto-save any complete salary before adding a new one
    const completeSalary = this.employeeSalaries.find(
      (salary) =>
        (salary.isEditing || salary.isNew) &&
        salary.employeeID !== null &&
        salary.periodTypeID !== null &&
        salary.effectiveFromDate &&
        salary.currency &&
        salary.amount > 0
    );

    if (completeSalary) {
      // Find the index of the complete salary
      const index = this.employeeSalaries.indexOf(completeSalary);
      // Automatically save the salary inline
      this.saveSalaryInline(completeSalary, index);
    }

    // Check if there's still an incomplete salary with missing required fields
    if (this.hasIncompleteSalary()) {
      this.showMessageModal = true;
      this.alertInfo =
        '⚠️Please complete the current salary entry with all required fields (Employee, Period Type, Date, Amount, Hours) before adding a new one.';
      return; // Stop the function execution
    }

    const monthlyPeriodType = this.periodTypes.find(
      (pt) => pt.description.toLowerCase() === 'monthly'
    );

    const defaultHours =
      this._hoursOpenPerMonth && this._hoursOpenPerMonth > 0
        ? this._hoursOpenPerMonth
        : null;

    const newSalary: Salary = {
      salaryID: Date.now(), // Temp ID for new unsaved salary
      employeeID:
        this.employees.length > 0 ? this.employees[0].employeeID! : null, // Pre-select first employee if available
      periodTypeID: monthlyPeriodType ? monthlyPeriodType.periodTypeID : null, // Pre-select Monthly if found, otherwise null
      effectiveFromDate: new Date().toISOString().split('T')[0], // Today's date
      effectiveToDate: null,
      amount: 0,
      hoursWorked: defaultHours,
      currency: 'ZAR',
      isEditing: true,
      isNew: true,
      originalSalary: undefined,
    };

    this.employeeSalaries.unshift(newSalary); // Add to the top of the list
    this.pendingSalaryChanges.added.push(newSalary);
    this.updateHasPendingSalaryChanges();
    this.errorMessage = null;
    this.showSalaryForm = false; // Hide the old form if it was visible

    // Manually call onSalaryFieldChange to trigger hoursWorked pre-fill immediately
    // Pass 'periodTypeID' as the field name to trigger the auto-fill logic.
    if (monthlyPeriodType) {
      this.onSalaryFieldChange(newSalary, 'periodTypeID');
    }
  }
  onSalaryFieldChange(salary: Salary, fieldName: string): void {
    // Logic to pre-fill hoursWorked based on PeriodType, but only when periodTypeID is the field being changed
    const monthlyPeriodType = this.periodTypes.find(
      (pt) => pt.description.toLowerCase() === 'monthly'
    );

    const hourlyPeriodType = this.periodTypes.find(
      (pt) => pt.description.toLowerCase() === 'hourly'
    );

    // Check if the changed field is the period type.
    // This prevents the user's manual input for hoursWorked from being overwritten.
    if (fieldName === 'periodTypeID') {
      if (
        monthlyPeriodType &&
        salary.periodTypeID === monthlyPeriodType.periodTypeID
      ) {
        // If 'Monthly' is selected, automatically set hoursWorked when schedule hours are available
        salary.hoursWorked =
          this._hoursOpenPerMonth && this._hoursOpenPerMonth > 0
            ? this._hoursOpenPerMonth
            : null;
      } else if (
        hourlyPeriodType &&
        salary.periodTypeID === hourlyPeriodType.periodTypeID
      ) {
        // If 'Hourly' is selected, automatically set hoursWorked to 1 and lock it
        salary.hoursWorked = 1;
      } else {
        // If a different period type is selected, clear hoursWorked for manual input
        salary.hoursWorked = null;
      }
    }

    // If the salary is new, we don't need to check for changes against an original state.
    // We just update the pending changes and return.
    if (salary.isNew) {
      // You might want to update the entry in `pendingSalaryChanges.added` here if needed,
      // but the `saveSalaryInline` function already handles this.
      // For now, just updating the flag is sufficient.
      this.updateHasPendingSalaryChanges();
      return;
    }

    // The following logic is for tracking changes on existing salaries.
    // It checks if the current state of the salary object is different from its original state.
    if (salary.salaryID !== null && salary.originalSalary) {
      const original = salary.originalSalary;

      const hasChanged =
        salary.employeeID !== original.employeeID ||
        salary.periodTypeID !== original.periodTypeID ||
        salary.effectiveFromDate !== original.effectiveFromDate ||
        (salary.effectiveToDate?.trim() || '') !==
          (original.effectiveToDate?.trim() || '') ||
        salary.amount !== original.amount ||
        salary.hoursWorked !== original.hoursWorked ||
        salary.currency !== original.currency;

      if (hasChanged) {
        // If there are changes, add/update the salary in the pending.updated array
        const existingUpdatedIndex =
          this.pendingSalaryChanges.updated.findIndex(
            (s) => s.salaryID === salary.salaryID
          );

        // Create a payload object with the current values of the salary.
        const salaryPayload = {
          salaryID: salary.salaryID,
          employeeID: salary.employeeID,
          periodTypeID: salary.periodTypeID,
          effectiveFromDate: salary.effectiveFromDate,
          effectiveToDate: salary.effectiveToDate?.trim() || null,
          amount: salary.amount,
          hoursWorked: salary.hoursWorked,
          currency: salary.currency,
        };

        if (existingUpdatedIndex > -1) {
          // If it's already there, replace it with the new payload.
          this.pendingSalaryChanges.updated[existingUpdatedIndex] =
            salaryPayload;
        } else {
          // If it's not there, add it to the 'updated' list.
          this.pendingSalaryChanges.updated.push(salaryPayload);
        }
      } else {
        // If changes were made and then reverted, remove from pending.updated
        this.pendingSalaryChanges.updated =
          this.pendingSalaryChanges.updated.filter(
            (s) => s.salaryID !== salary.salaryID
          );
      }
    }
    this.updateHasPendingSalaryChanges(); // Update pending changes flag
  }
  startEditSalary(salary: Salary): void {
    salary.originalSalary = { ...salary }; // Deep copy original state
    salary.isEditing = true;
    this.showSalaryForm = false; // Hide the old form if editing inline
  }

  saveSalaryInline(salary: Salary, index: number): void {
    // Client-side Validation - COLLECT ALL ERRORS FIRST
    const validationErrors: string[] = [];

    if (!salary.employeeID) {
      validationErrors.push('Employee is required.');
    }
    if (!salary.periodTypeID) {
      validationErrors.push('Payment Period Type is required.');
    }
    if (!salary.effectiveFromDate) {
      validationErrors.push('Effective From Date is required.');
    }
    if (salary.amount === null || salary.amount < 0) {
      validationErrors.push('Amount must be a non-negative number.');
    }
    if (salary.hoursWorked === null || salary.hoursWorked === undefined) {
      validationErrors.push(
        'Hours Worked is required. Set your operating schedule or enter the correct hours manually.'
      );
    } else if (salary.hoursWorked < 0) {
      validationErrors.push('Hours Worked must be a non-negative number.');
    }

    if (validationErrors.length > 0) {
      this.showMessage(
        '⚠️Salary cannot be saved due to the following issues:<br>' +
          validationErrors.join('<br>')
      );
      return;
    }

    // --- Duplicate Check for New Entries ---
    if (salary.isNew) {
      // Check if a salary with the same employeeID and periodTypeID already exists
      // You might need to refine this duplicate logic based on what makes a salary "unique"
      const isDuplicate = this.employeeSalaries.some(
        (s) =>
          s.employeeID === salary.employeeID &&
          s.periodTypeID === salary.periodTypeID &&
          s.salaryID !== salary.salaryID // Exclude the salary being edited if it's already in the main list
      );

      if (isDuplicate) {
        validationErrors.push(
          'A salary entry for this Employee and Payment Period Type already exists.'
        );
      }
    }

    // If there are validation errors, display them and stop
    if (validationErrors.length > 0) {
      this.errorMessage = validationErrors.join('\n'); // Join all errors with a newline
      // You can use a more user-friendly notification system than alert
      // alert('Missing Information or Duplicate Entry:\n' + this.errorMessage);
      return;
    }

    this.errorMessage = null; // Clear errors if validation passes

    const normalizedEmployeeId =
      typeof salary.employeeID === 'string'
        ? parseInt(salary.employeeID, 10)
        : salary.employeeID;
    const normalizedPeriodTypeId =
      typeof salary.periodTypeID === 'string'
        ? parseInt(salary.periodTypeID, 10)
        : salary.periodTypeID;
    const normalizedAmount =
      typeof salary.amount === 'string'
        ? parseFloat(salary.amount)
        : salary.amount;
    const normalizedHoursWorked =
      typeof salary.hoursWorked === 'string'
        ? parseFloat(salary.hoursWorked)
        : salary.hoursWorked;

    if (
      normalizedEmployeeId === null ||
      normalizedEmployeeId === undefined ||
      Number.isNaN(normalizedEmployeeId)
    ) {
      validationErrors.push('Employee selection is invalid.');
    }

    if (
      normalizedPeriodTypeId === null ||
      normalizedPeriodTypeId === undefined ||
      Number.isNaN(normalizedPeriodTypeId)
    ) {
      validationErrors.push('Payment Period Type is invalid.');
    }

    if (normalizedAmount === null || Number.isNaN(normalizedAmount)) {
      validationErrors.push('Amount must be a valid number.');
    }

    if (normalizedHoursWorked === null || Number.isNaN(normalizedHoursWorked)) {
      validationErrors.push('Hours Worked must be a valid number.');
    }

    if (validationErrors.length > 0) {
      this.showMessage(
        '⚠️Salary cannot be saved due to the following issues:<br>' +
          validationErrors.join('<br>')
      );
      return;
    }

    salary.employeeID = normalizedEmployeeId;
    salary.periodTypeID = normalizedPeriodTypeId;
    salary.amount = normalizedAmount;
    salary.hoursWorked = normalizedHoursWorked;

    const salaryPayload = {
      salaryID: salary.salaryID,
      employeeID: normalizedEmployeeId,
      periodTypeID: normalizedPeriodTypeId,
      effectiveFromDate: salary.effectiveFromDate,
      effectiveToDate: salary.effectiveToDate?.trim() || null, // Ensure null for empty string
      amount: normalizedAmount,
      hoursWorked: normalizedHoursWorked,
      currency: salary.currency,
    };

    // Logic for handling new vs. existing salaries
    if (salary.isNew) {
      const existingNewIndex = this.pendingSalaryChanges.added.findIndex(
        (s) => s.salaryID === salary.salaryID
      );

      if (existingNewIndex > -1) {
        // If it's a new salary that was already being edited (e.g., re-edited before final save)
        this.pendingSalaryChanges.added[existingNewIndex] = {
          ...salaryPayload,
          isNew: true,
        }; // Keep isNew flag for pending list
      } else {
        // If it's a completely new salary being added
        this.pendingSalaryChanges.added.push({ ...salaryPayload, isNew: true });
      }

      // After "saving" a new salary inline (to pending), mark it as no longer new/editing for display
      salary.isNew = false;
      salary.isEditing = false;
      salary.originalSalary = { ...salary }; // Store current state as original for future edits
    } else {
      // This is an existing salary that was edited
      // 1. Update the display object's 'originalSalary' to the current state
      salary.originalSalary = { ...salary };

      // 2. Add or update it in the 'updated' array of pending changes
      const existingUpdatedIndex = this.pendingSalaryChanges.updated.findIndex(
        (s) => s.salaryID === salary.salaryID
      );
      if (existingUpdatedIndex > -1) {
        this.pendingSalaryChanges.updated[existingUpdatedIndex] = salaryPayload;
      } else {
        // Add to pendingSalaryChanges.updated
        this.pendingSalaryChanges.updated.push(salaryPayload);
      }
    }

    // Finally, update the overall flag for pending changes
    this.updateHasPendingSalaryChanges();
    // Only call confirmSaveAllSalariesChanges if there are actual pending changes
    if (this.hasPendingSalaryChanges()) {
      this.confirmSaveAllSalariesChanges();
    }
  }

  canSave(s: Salary): boolean {
    return !!(
      s.employeeID &&
      s.periodTypeID &&
      s.effectiveFromDate &&
      s.amount !== null &&
      s.amount >= 0 &&
      s.hoursWorked !== null &&
      s.hoursWorked >= 0
    );
  }

  cancelSalaryEdit(salary: Salary, index: number): void {
    this.errorMessage = null; // Clear any error messages
    if (salary.isNew) {
      // Just drop the unsaved row
      this.employeeSalaries.splice(index, 1);
      // Also remove it from the pending 'added' list
      this.pendingSalaryChanges.added = this.pendingSalaryChanges.added.filter(
        (s) => s.salaryID !== salary.salaryID
      );
    } else if (salary.isEditing && salary.originalSalary) {
      // Revert existing salary to its original state before editing
      Object.assign(salary, salary.originalSalary);
      // Remove from 'updated' list if it was there (since changes are cancelled)
      this.pendingSalaryChanges.updated =
        this.pendingSalaryChanges.updated.filter(
          (s) => s.salaryID !== salary.salaryID
        );
    }
    salary.isEditing = false; // Exit edit mode for the display object
    this.updateHasPendingSalaryChanges(); // Update pending changes flag
  }

  async markSalaryForDeletion(salary: Salary): Promise<void> {
    this.showDeleteConfirm = true;
    const confirmed = await this.deleteConfirmed;
    if (!confirmed) {
      this.deleteConfirmed = new Promise((resolve) => {
        this.resolveDelete = resolve;
      });
      return; // User cancelled
    }
    this.deleteConfirmed = new Promise((resolve) => {
      this.resolveDelete = resolve;
    });

    if (salary.isNew) {
      // If it's a new salary, just remove it from the local display and pending 'added' list.
      this.employeeSalaries = this.employeeSalaries.filter(
        (s) => s.salaryID !== salary.salaryID
      );
      this.pendingSalaryChanges.added = this.pendingSalaryChanges.added.filter(
        (s) => s.salaryID !== salary.salaryID
      );
    } else {
      // Ensure salary.salaryID is a number and not null/undefined before converting
      // If salary.salaryID can be null for existing salaries, you need to handle that edge case
      // For deletion, it should definitely have a non-null ID
      if (salary.salaryID === null || salary.salaryID === undefined) {
        // This should ideally not happen for an existing, non-new salary
        console.warn('Attempted to delete a salary without a valid salaryID.');
        return;
      }

      const salaryIdAsString = String(salary.salaryID); // Convert number to string

      const existingDeletedIndex = this.pendingSalaryChanges.deleted.findIndex(
        (id) => id === salaryIdAsString // Compare string with string
      );

      if (existingDeletedIndex === -1) {
        this.pendingSalaryChanges.deleted.push(salaryIdAsString); // Push the string ID
        this.employeeSalaries = this.employeeSalaries.filter(
          (s) => s.salaryID !== salary.salaryID
        ); // Optimistically remove from display (here you compare number with number)
        // Also remove from 'updated' if it was being updated
        this.pendingSalaryChanges.updated =
          this.pendingSalaryChanges.updated.filter(
            (s) => s.salaryID !== salary.salaryID
          );
      }
    }
    this.updateHasPendingSalaryChanges();
    this.confirmSaveAllSalariesChanges();

    // this.showSuccessMessage(
    //   'Salary record marked for deletion. Click "Save Changes" to confirm.'
    // );
  }

  hasPendingSalaryChanges(): boolean {
    return (
      this.pendingSalaryChanges.added.length > 0 ||
      this.pendingSalaryChanges.updated.length > 0 ||
      this.pendingSalaryChanges.deleted.length > 0
    );
  }

  updateHasPendingSalaryChanges(): void {
  }
  openSaveAllSalariesModal(): void {
    this.salaryModalMessage = null;
    this.isSalarySaveSuccess = null;
    this.showSaveSalaryModal = true;
  }

  closeSaveSalaryModal(): void {
    this.showSaveSalaryModal = false;
    this.salaryModalMessage = null;
    this.isSalarySaveSuccess = null;
  }
  private formatApiDateToInputDate(
    dateString: string | null | undefined
  ): string | null {
    if (!dateString) {
      return null;
    }
    try {
      const date = new Date(dateString);
      // Use ISO string and take the date part
      return date.toISOString().split('T')[0];
    } catch (e) {
      console.error('Invalid date string from API:', dateString, e);
      return null; // Or return original string if you want to keep invalid data
    }
  }

  confirmSaveAllSalariesChanges(): void {
    //this.isSavingSalaries = true;
    //this.salaryModalMessage = 'Saving salary changes...';

    // Define the expected response type for the API calls
    type ApiResponse = any | { error: boolean; message: string };

    // Initialize saveRequests with proper type annotation
    const saveRequests: Observable<ApiResponse>[] = [];
    const headers: HttpHeaders = this.getAuthHeaders();
    const url = `${environment.apiUrl}/api/EmployeeSalaries`;

    if (!this.ensureValidEmployeeIdsForPendingSalaries()) {
      return;
    }

    // --- Add new salaries ---
    for (const sal of this.pendingSalaryChanges.added) {
      const payload = { ...sal };
      delete (payload as any).isNew;
      delete (payload as any).isEditing;
      delete (payload as any).originalSalary;
      if (typeof payload.salaryID === 'number') {
        delete (payload as any).salaryID;
      }

      const req$ = this.http.post(`${url}/Add`, payload, { headers }).pipe(
        catchError((error) => {
          console.error('Error adding salary:', error, 'Backend details:', error?.error);
          return of({ error: true, message: error?.error?.InnerError || 'Failed to add salary.' });
        })
      );
      saveRequests.push(req$);
    }

    // --- Update salaries ---
    for (const sal of this.pendingSalaryChanges.updated) {
      const payload = { ...sal };
      delete (payload as any).isNew;
      delete (payload as any).isEditing;
      delete (payload as any).originalSalary;

      // A Date.now() temp ID exceeds int max — route to POST /Add instead of PUT /Update.
      if (typeof payload.salaryID === 'number' && payload.salaryID > 2_147_483_647) {
        delete (payload as any).salaryID;
        const req$ = this.http.post(`${url}/Add`, payload, { headers }).pipe(
          catchError((error) => {
            console.error('Error adding salary (re-routed from update):', error, 'Backend details:', error?.error);
            return of({ error: true, message: error?.error?.InnerError || 'Failed to add salary.' });
          })
        );
        saveRequests.push(req$);
        continue;
      }

      const req$ = this.http
        .put(`${url}/Update/${payload.salaryID}`, payload, { headers })
        .pipe(
          catchError((error) => {
            console.error('Error updating salary:', error, 'Backend details:', error?.error);
            return of({ error: true, message: error?.error?.InnerError || 'Failed to update salary.' });
          })
        );
      saveRequests.push(req$);
    }

    // --- Delete salaries ---
    for (const salaryId of this.pendingSalaryChanges.deleted) {
      const req$ = this.http
        .delete(`${url}/Delete/${salaryId}`, { headers })
        .pipe(
          catchError((error) => {
            console.error('Error deleting salary:', error);
            return of({ error: true, message: 'Failed to delete salary.' });
          })
        );
      saveRequests.push(req$);
    }

    // --- Execute all requests ---
    if (saveRequests.length === 0) {
      this.isSalarySaveSuccess = true;
      this.closeSaveSalaryModal();
      return;
    }

    forkJoin(saveRequests).subscribe({
      next: (results: ApiResponse[]) => {
        const hasError = results.some(
          (r) => r && typeof r === 'object' && 'error' in r && r.error
        );

        if (hasError) {
          this.isSalarySaveSuccess = false;
          // If there's an error, you might want to revert the *display* state
          // for the items that failed, using their originalSalary.
          // Or, you might need to re-fetch all data to ensure consistency.
        } else {
          this.isSalarySaveSuccess = true;
          if (this.isMobileView()) {
            this.showSuccessMessage('Salary saved successfully');
          }
          // After successful save, reset pending changes
          this.resetSalaryPendingChanges();

          // Update originalSalary for each salary without reloading (prevents table flash)
          this.employeeSalaries.forEach(s => {
            if (!s.isNew && !s.isEditing) {
              s.originalSalary = { ...s };
            }
          });
        }
        // ... (rest of next block) ...
      },
      error: (err) => {
        // ... (error handling) ...
        // On network error, potentially revert all pending changes using originalSalary
        // this.cancelAllPendingSalaryEdits(); // You'd need to implement this
      },
      complete: () => {
        this.isSavingSalaries = false;
        setTimeout(() => (this.showDeleteConfirm = false), 500);
        this.loadEmployeesAndRoles();
      },
    });
  }

  resetSalaryPendingChanges(): void {
    this.pendingSalaryChanges = {
      added: [],
      updated: [],
      deleted: [],
    };
  }

  private ensureValidEmployeeIdsForPendingSalaries(): boolean {
    const normalizeEmployeeId = (value: number | string | null | undefined) =>
      typeof value === 'string' ? parseInt(value, 10) : value;

    const entries = [
      ...this.pendingSalaryChanges.added,
      ...this.pendingSalaryChanges.updated,
    ];

    for (const entry of entries) {
      const normalizedId = normalizeEmployeeId(entry.employeeID);
      if (normalizedId && normalizedId > 0) {
        entry.employeeID = normalizedId;
        continue;
      }

      const sourceSalary = this.employeeSalaries.find(
        (salary) => salary.salaryID === entry.salaryID
      );
      const resolvedId = normalizeEmployeeId(sourceSalary?.employeeID);
      if (resolvedId && resolvedId > 0) {
        entry.employeeID = resolvedId;
        continue;
      }

      this.showMessage(
        '⚠️Employee changes must be saved before adding salaries. Please save employees, refresh the list, and try again.'
      );
      return false;
    }

    return true;
  }

  showSuccessMessage(message: string): void {
    this.checkSetupStatus();
    this.toast.success(message, 5000);
  }

  // Mobile uses toasts for save/delete feedback; desktop keeps its inline modal
  // banners and "removed from list" notices. The mobile view is shown below the
  // Bootstrap md breakpoint (<768px, via `d-md-none`), so gate mobile-only toasts
  // on the viewport width to avoid changing mobile behavior.
  private isMobileView(): boolean {
    return window.innerWidth < 768;
  }

  // --- OLD SALARY FORM METHODS (KEPT, BUT MODIFIED TO USE RAW API CALLS) ---
  // You can remove these if you fully switch to inline editing
  async saveSalary(): Promise<void> {
    if (this.salaryForm.invalid) {
      this.errorMessage =
        '⚠️Please fill in all required salary fields correctly.';
      this.salaryForm.markAllAsTouched();
      return;
    }
    this.errorMessage = null;

    const salaryData = this.salaryForm.value;

    try {
      if (this.editingSalary) {
        // Update existing salary (via old form)
        const response = await fetch(
          `${environment.apiUrl}/api/EmployeeSalaries/Update`,
          {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(salaryData),
          }
        );
        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(
            errorData.message ||
              `Failed to update salary: ${response.statusText}`
          );
        }
        this.showSuccessMessage('Salary record updated successfully ✅');
        this.cancelSalaryEditOldForm();
        await this.loadSalaries(); // Reload to reflect changes
      } else {
        // Add new salary (via old form)
        // Remove salaryID for new additions as backend generates it
        const payload = { ...salaryData };
        delete payload.salaryID;

        const response = await fetch(
          `${environment.apiUrl}/api/EmployeeSalaries/Add`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
          }
        );
        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(
            errorData.message || `Failed to add salary: ${response.statusText}`
          );
        }
        this.showSuccessMessage('Salary record added successfully ✅');
        this.cancelSalaryEditOldForm();
        await this.loadSalaries(); // Reload to reflect new data
      }
    } catch (err: any) {
      this.errorMessage = `Operation failed: ${err.message || err}`;
      console.error(err);
    }
  }

  // You will also need these to handle the old form:
  cancelSalaryEditOldForm(): void {
    this.editingSalary = null;
    this.showSalaryForm = false;
    this.salaryForm.reset({ currency: 'ZAR' }); // Reset form to default values
    this.errorMessage = null;
  }

  onEmployeeFieldChange(employee: Employee): void {
    if (employee.roleID === 0) {
      this.navigateToAddRole();
    }
    // This method's primary purpose is to update the pendingEmployeeChanges.updated array
    // if the employee is an existing one and their data has been modified.

    if (employee.isNew) {
      // For new employees, they are always considered "added" until saved.
      // No need to track individual field changes as "updates" for new entries here.
      // Their "isModified" state is implicitly handled by their presence in pendingEmployeeChanges.added.
      this.updateHasPendingEmployeeChanges();
      return;
    }

    // For existing employees, compare with their original state
    if (employee.employeeID !== null && employee.originalEmployee) {
      const original = employee.originalEmployee;

      // Check if any field has changed
      const hasChanged =
        employee.firstName.trim() !== original.firstName.trim() ||
        employee.lastName.trim() !== original.lastName.trim() ||
        (employee.contactInfo?.trim() || '') !==
          (original.contactInfo?.trim() || '') ||
        employee.hireDate !== original.hireDate ||
        employee.roleID !== original.roleID ||
        employee.isActive !== original.isActive; // This also covers status toggle changes

      if (hasChanged) {
        // If there are changes, add/update the employee in the pending.updated array
        const existingUpdatedIndex =
          this.pendingEmployeeChanges.updated.findIndex(
            (e) => e.employeeID === employee.employeeID
          );

        // Create a payload similar to what saveEmployeeInline creates for consistency
        const employeePayload = {
          employeeID: employee.employeeID,
          firstName: employee.firstName.trim(),
          lastName: employee.lastName.trim(),
          contactInfo: employee.contactInfo?.trim() || null,
          hireDate: employee.hireDate,
          roleID: employee.roleID,
          isActive: employee.isActive,
        };

        if (existingUpdatedIndex > -1) {
          this.pendingEmployeeChanges.updated[existingUpdatedIndex] =
            employeePayload;
        } else {
          // Add to pendingEmployeeChanges.updated
          this.pendingEmployeeChanges.updated.push(employeePayload);
        }
      } else {
        // If changes were made and then reverted, remove from pending.updated
        this.pendingEmployeeChanges.updated =
          this.pendingEmployeeChanges.updated.filter(
            (e) => e.employeeID !== employee.employeeID
          );
      }
    }
    this.updateHasPendingEmployeeChanges(); // Re-evaluate the "Save All Changes" button's state
  }

  cancelEmployeeEdit(employee: Employee, index: number): void {
    if (employee.isNew) {
      // If it's a new employee, remove it completely from the UI
      this.employees.splice(index, 1);
      // Also remove it from pending additions if it was there
      this.pendingEmployeeChanges.added =
        this.pendingEmployeeChanges.added.filter(
          (e) => e.employeeID !== employee.employeeID
        );
    } else if (
      employee.employeeID !== null &&
      this.originalEmployeeState[employee.employeeID]
    ) {
      // If it's an existing employee, revert its properties to the original state
      const original = this.originalEmployeeState[employee.employeeID];
      employee.firstName = original.firstName;
      employee.lastName = original.lastName;
      employee.contactInfo = original.contactInfo;
      employee.hireDate = original.hireDate;
      employee.roleID = original.roleID;
      employee.isActive = original.isActive;
      employee.isEditing = false;
      employee.roleDescription = this.getRoleDescription(
        original.roleID,
        this.roles
      ); // Revert display description
      delete this.originalEmployeeState[employee.employeeID]; // Clear original state

      // Remove from pending updates if it was there (since changes are now reverted)
      this.pendingEmployeeChanges.updated =
        this.pendingEmployeeChanges.updated.filter(
          (e) => e.employeeID !== employee.employeeID
        );
    }
    employee.isEditing = false; // Ensure editing mode is off
    this.errorMessage = null; // Clear any validation errors
  }

  // Handle status toggle (isActive) - this should also stage a change, not immediately send API call
  toggleEmployeeStatus(employee: Employee): void {
    if (employee.isEditing) {
      this.showMessageModal = true;
      this.alertInfo = `⚠️Please save or cancel the current edit before changing status.`;

      // Revert the toggle if it happened via UI
      employee.isActive = !employee.isActive;
      return;
    }

    // Toggle the status locally
    employee.isActive = !employee.isActive;

    // Check if this is a new employee (not yet saved)
    if (employee.isNew) {
      // If it's new, find it in pending.added and update its status
      const pendingNew = this.pendingEmployeeChanges.added.find(
        (e) => e.employeeID === employee.employeeID
      );
      if (pendingNew) {
        pendingNew.isActive = employee.isActive;
      }
    } else {
      // For existing employees, we need to track this as an update
      if (!this.originalEmployeeState[employee.employeeID!]) {
        // If not currently in edit mode, store its current state as original
        this.originalEmployeeState[employee.employeeID!] = {
          ...employee,
          isActive: !employee.isActive,
        }; // Store state *before* toggle
      }

      const originalStatus =
        this.originalEmployeeState[employee.employeeID!].isActive;

      if (employee.isActive !== originalStatus) {
        // Status has changed relative to original, add/update in pending.updated
        const existingUpdateIndex =
          this.pendingEmployeeChanges.updated.findIndex(
            (e) => e.employeeID === employee.employeeID
          );
        const employeePayload = { ...employee }; // Create a copy of the current state
        if (existingUpdateIndex > -1) {
          this.pendingEmployeeChanges.updated[existingUpdateIndex] =
            employeePayload;
        } else {
          // Add to pendingEmployeeChanges.updated
          this.pendingEmployeeChanges.updated.push(employeePayload);
        }
      } else {
        // Status reverted to original, remove from pending.updated if it was there
        this.pendingEmployeeChanges.updated =
          this.pendingEmployeeChanges.updated.filter(
            (e) => e.employeeID !== employee.employeeID
          );
      }
    }
  }
  resolveDelete: any;
  closeDeleteConfirm() {
    this.showDeleteConfirm = false;
    this.resolveDelete(false);
  }

  async confirmDelete() {
    this.showDeleteConfirm = false;
    this.resolveDelete(true);
  }
  deleteConfirmed = new Promise((resolve) => {
    this.resolveDelete = resolve;
  });
  async markEmployeeForDeletion(employee: Employee): Promise<void> {
    if (employee.isEditing) {
      this.showMessageModal = true;
      this.alertInfo = `⚠️Please save or cancel the current edit before marking this employee for deletion.`;

      return;
    }
    this.showDeleteConfirm = true;
    const confirmed = await this.deleteConfirmed;

    if (!confirmed) {
      this.deleteConfirmed = new Promise((resolve) => {
        this.resolveDelete = resolve;
      });
      return; // User cancelled
    }

    this.deleteConfirmed = new Promise((resolve) => {
      this.resolveDelete = resolve;
    });
    //this.resolveDelete(false);
    // Handle new employees (which only exist locally)
    if (employee.isNew) {
      // Just drop the unsaved row
      this.employees = this.employees.filter(
        (e) => e.employeeID !== employee.employeeID
      );
      this.pendingEmployeeChanges.added =
        this.pendingEmployeeChanges.added.filter(
          (e) => e.employeeID !== employee.employeeID
        );

      return;
    }

    // Handle existing employees (which exist on backend)
    this.pendingEmployeeChanges.updated =
      this.pendingEmployeeChanges.updated.filter(
        (e) => e.employeeID !== employee.employeeID
      ); // Remove from updates if it was there

    const existingDeletionIndex = this.pendingEmployeeChanges.deleted.findIndex(
      (e) => e.employeeID === employee.employeeID
    );
    if (existingDeletionIndex === -1) {
      employee.isDeleted = true; // Optional: for visual indication before removal if you change mind
      this.pendingEmployeeChanges.deleted.push({ ...employee }); // Push a copy

    }

    // Remove the employee from the UI immediately
    this.employees = this.employees.filter(
      (e) => e.employeeID !== employee.employeeID
    );





    this.confirmSaveAllEmployeesChanges();
  }

  // --- Batch Save Modal & Methods ---

  hasPendingEmployeeChanges(): boolean {
    return (
      this.pendingEmployeeChanges.added.length > 0 ||
      this.pendingEmployeeChanges.updated.length > 0 ||
      this.pendingEmployeeChanges.deleted.length > 0
    );
  }

  openSaveAllEmployeesModal(): void {
    this.isSavingEmployees = false;
    this.employeeModalMessage = null;
    this.isEmployeeSaveSuccess = null;

    const activeEdits = this.employees.some((employee) => employee.isEditing);
    if (activeEdits) {
      this.showMessageModal = true;
      this.alertInfo = `⚠️Please save or cancel all active inline edits before saving all changes.`;

      return;
    }

    if (this.hasPendingEmployeeChanges()) {
      this.showSaveEmployeeModal = true;

    } else {
      this.showMessageModal = true;
      this.alertInfo = `No employee changes to save.`;

    }
  }

  closeSaveEmployeeModal(): void {
    this.showSaveEmployeeModal = false;
    this.employeeModalMessage = null;
    this.isEmployeeSaveSuccess = null;
    if (this.isEmployeeSaveSuccess) {
      // If save was successful, reload employees
      this.loadAllData(); // Reloads both roles and employees for consistency
    }

  }

  confirmSaveAllEmployeesChanges(): void {
    this.isSavingEmployees = true;
    this.employeeModalMessage = 'Saving employee changes...';
    this.isEmployeeSaveSuccess = null;

    const headers = this.getAuthHeaders();
    const saveOperations: Promise<any>[] = [];

    // 1. Handle Added Employees
    const addedEmployeePromises = this.pendingEmployeeChanges.added.map((emp) => {
      const tempEmployeeId = emp.employeeID;
      const payload = {
        firstName: emp.firstName,
        lastName: emp.lastName,
        contactInfo: emp.contactInfo,
        hireDate: emp.hireDate,
        roleID: emp.roleID,
        isActive: emp.isActive,
      };
      return this.http
        .post<Employee>(`${environment.apiUrl}/api/Employees/Add`, payload, {
          headers,
        })
        .pipe(
          tap((created) => {
            if (!created || created.employeeID === undefined || created.employeeID === null) {
              console.warn('Added employee response missing employeeID.', created);
              return;
            }

            const pendingIndex = this.pendingEmployeeChanges.added.findIndex(
              (addedEmp) => addedEmp.employeeID === tempEmployeeId
            );
            if (pendingIndex > -1) {
              this.pendingEmployeeChanges.added[pendingIndex].employeeID = created.employeeID;
            }

            this.employees = this.employees.map((localEmp) =>
              localEmp.employeeID === tempEmployeeId
                ? {
                    ...localEmp,
                    employeeID: created.employeeID,
                    isNew: false,
                    isEditing: false,
                  }
                : localEmp
            );

            this.employeeSalaries.forEach((salary) => {
              if (salary.employeeID === tempEmployeeId) {
                salary.employeeID = created.employeeID;
                if (salary.originalSalary) {
                  salary.originalSalary.employeeID = created.employeeID;
                }
              }
            });

            this.pendingSalaryChanges.added.forEach((pendingSal) => {
              if (pendingSal.employeeID === tempEmployeeId) {
                pendingSal.employeeID = created.employeeID;
              }
            });

            this.pendingSalaryChanges.updated.forEach((pendingSal) => {
              if (pendingSal.employeeID === tempEmployeeId) {
                pendingSal.employeeID = created.employeeID;
              }
            });

            emp.employeeID = created.employeeID;
          })
        )
        .toPromise();
    });
    saveOperations.push(...addedEmployeePromises);

    // 2. Handle Updated Employees
    this.pendingEmployeeChanges.updated.forEach((emp) => {
      const payload = {
        employeeID: emp.employeeID,
        firstName: emp.firstName,
        lastName: emp.lastName,
        contactInfo: emp.contactInfo,
        hireDate: emp.hireDate,
        roleID: emp.roleID,
        isActive: emp.isActive,
      };
      saveOperations.push(
        this.http
          .put(
            `${environment.apiUrl}/api/Employees/Update/${emp.employeeID}`,
            payload,
            { headers }
          )
          .toPromise()
      );
    });

    // 3. Handle Deleted Employees
    this.pendingEmployeeChanges.deleted.forEach((emp) => {
      saveOperations.push(
        this.http
          .delete(
            `${environment.apiUrl}/api/Employees/Delete/${emp.employeeID}`,
            { headers }
          )
          .toPromise()
      );
    });

    // Execute all operations concurrently
    Promise.all(saveOperations)
      .then(() => {
        this.inlineSaving = false;
        this.employeeModalMessage = this.sanitizer.bypassSecurityTrustHtml(`
          <span style="display: flex; align-items: center; gap: 8px;">
            All changes saved successfully
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="color: #28a745;">
                <path d="M22 11.08V12a10 10 0 1 1-5.93-8.15"></path>
                <polyline points="22 4 12 14.01 9 11.01"></polyline>
            </svg>
          </span>
        `);
        this.isEmployeeSaveSuccess = true;
        this.isSavingEmployees = false;
        if (this.isMobileView()) {
          this.showSuccessMessage('Employee changes saved successfully');
        }

        // Clear pending changes without reloading data (prevents table flash)
        this.clearPendingEmployeeChanges();
        this.loadEmployeesAndRoles();

        setTimeout(() => {
          this.closeSaveEmployeeModal();
          this.showDeleteConfirm = false;
        }, 1500);
      })
      .catch((error) => {
        this.employeeModalMessage = 'Failed to save all employee changes.';
        this.isEmployeeSaveSuccess = false;
        this.isSavingEmployees = false;
        console.error('Error saving employee changes:', error);
      });
  }

  private clearPendingEmployeeChanges(): void {
    this.pendingEmployeeChanges = {
      added: [],
      updated: [],
      deleted: [],
    };
    this.originalEmployeeState = {}; // Also clear original state tracking
  }

  loadTradingHours(): void {
    this.isProcessing = true;
    const year = new Date().getFullYear();
    const token =
      localStorage.getItem('authToken') || sessionStorage.getItem('authToken');

    this.getLatestTenantProfileId()
      .pipe(
        switchMap((businessId: number | null) => {
          if (!token) {
            console.error('Authentication error: No auth token found.');
            return throwError(
              () => new Error('Authentication error. Please log in again.')
            );
          }
          if (businessId === null) {
            return forkJoin([
              of<OperatingScheduleEntry[]>([]),
              of<OperatingException[]>([]),
              this.getPublicHolidaysForCurrentYearObservable(token),
            ]);
          }

          const headers = new HttpHeaders({
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          });

          const scheduleUrl = `${environment.apiUrl}/api/OperatingSchedule/${businessId}/schedule`;
          const scheduleGet$ = this.http.get<OperatingScheduleEntry[]>(
            scheduleUrl,
            { headers }
          );

          const exceptionsUrl = `${environment.apiUrl}/api/OperatingException/${businessId}/${year}/exceptions`;
          const exceptionsGet$ = this.http.get<OperatingException[]>(
            exceptionsUrl,
            { headers }
          );

          return forkJoin([
            scheduleGet$,
            exceptionsGet$,
            this.getPublicHolidaysForCurrentYearObservable(token),
          ]); // Include public holidays in the forkJoin
        }),
        catchError((err) => {
          //console.error('Error loading schedule or exceptions:', err);
          //this.showMessageModal = true;
          // this.alertInfo = `Could not load trading hours. Please try again later.`;
          return throwError(
            () =>
              new Error('Could not load trading hours. Please try again later.')
          );
        })
      )
      .subscribe({
        next: ([scheduleArr, apiExceptionsArr, publicHolidaysArr]) => {


          // --- 1) Reset local arrays before populating ---
          this.operatingHours = this.daysOfWeek.map((day) => ({
            dayOfWeek: day.value,
            openTime: null,
            closeTime: null,
            isClosed: false,
            businessID: 0, // You might need to set a default businessID or fetch it
          }));
          this.days = this.daysOfWeek.map((day) => ({
            name: day.name,
            openingTime: '',
            closingTime: '',
            closed: false,
          }));

          // --- 2) Map scheduleArr → this.operatingHours & this.days ---
          scheduleArr.forEach((entry) => {
            const dow = entry.dayOfWeek;
            const isClosed = entry.isClosed;

            const hhmm = (full: string | null): string => {
              if (!full) return '';
              return full.substring(0, 5);
            };

            const openHHmm = hhmm(entry.openTime);
            const closeHHmm = hhmm(entry.closeTime);

            this.operatingHours[dow] = {
              dayOfWeek: dow,
              openTime: isClosed ? null : openHHmm,
              closeTime: isClosed ? null : closeHHmm,
              isClosed: isClosed,
              businessID: entry.businessID, // Ensure businessID is carried over
            };

            this.days[dow].closed = isClosed;
            this.days[dow].openingTime = isClosed ? '' : openHHmm;
            this.days[dow].closingTime = isClosed ? '' : closeHHmm;
          });

          // --- 3) Handle Exceptions: Prioritize API data, then prefill with public holidays if API data is empty ---
          if (apiExceptionsArr && apiExceptionsArr.length > 0) {
            this.exceptions = apiExceptionsArr.map((exc) => {
              const rawDate = exc.exceptionDate;
              const dt = new Date(rawDate);
              const yyyy = dt.getFullYear();
              const mm = String(dt.getMonth() + 1).padStart(2, '0');
              const dd = String(dt.getDate()).padStart(2, '0');
              const isoDate = `${yyyy}-${mm}-${dd}`;

              const hhmm = (full: string | null): string => {
                if (!full) return '';
                return full.substring(0, 5);
              };
              const openHHmm = hhmm(exc.openTime);
              const closeHHmm = hhmm(exc.closeTime);

              const title = `${dt.toLocaleString('en-US', {
                month: 'long',
              })} ${dt.getDate()}`;

              return {
                title: title, // This might not be needed for user-added exceptions, but good to have a consistent structure
                exceptionDate: isoDate,
                openTime: exc.isClosed ? '' : openHHmm,
                closeTime: exc.isClosed ? '' : closeHHmm,
                isClosed: exc.isClosed,
                reason: exc.reason || '',
              };
            });

          } else {


            // Check if we have holidays data to prefill
            if (publicHolidaysArr && publicHolidaysArr.length > 0) {
              // This is where you prefill if no user data exists
              this.exceptions = publicHolidaysArr.map((holiday) => {
                const reasonText =
                  holiday.name && holiday.name.length > 0
                    ? holiday.name[0].text
                    : 'Public Holiday';

                return {
                  title:
                    holiday.name && holiday.name.length > 0
                      ? holiday.name[0].text
                      : '', // Or a default title
                  exceptionDate: holiday.startDate, // This should already be YYYY-MM-DD
                  openTime: '00:00', // Default full day closure or specific times
                  closeTime: '23:59', // Default full day closure
                  isClosed: true, // Public holidays are often closed days
                  reason: reasonText,
                };
              });
            } else {
              console.warn('⚠️ No public holidays data available to prefill');
              this.exceptions = [];
            }
          }
          const loadedHours = this.computeHoursOpenPerMonthFromSchedule(
            scheduleArr
          );
          if (loadedHours > 0) {
            this._hoursOpenPerMonth = loadedHours;
            this.isOperatingScheduleLoaded = true;
          }

          this.isProcessing = false;
          // Trigger change detection to ensure UI updates with loaded holidays
          this.cdr.detectChanges();
        },
        error: (err) => {
          this.isProcessing = false;
          console.error('Subscription error:', err);
        },
      });
  }
  private getPublicHolidaysForCurrentYearObservable(
    token: string
  ): Observable<Holiday[]> {
    const year = this.currentYear;
    const from = `${year}-01-01`;
    const to = `${year}-12-31`;

    const params = new HttpParams()
      .set('countryIsoCode', 'ZA')
      .set('languageIsoCode', 'EN')
      .set('validFrom', from)
      .set('validTo', to);

    if (!token) {
      console.error('Authentication error: No auth token found for holidays.');
      return throwError(() => new Error('Authentication token missing.'));
    }

    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    });
    return this.http
      .get<Holiday[]>(`${environment.apiUrl}/api/Holidays/PublicHolidays`, {
        headers,
        params,
      })
      .pipe(
        tap((holidays) => {
        }),
        catchError((err) => {
          console.error('❌ Failed to fetch holidays:', err);
          console.error('Error details:', {
            status: err.status,
            message: err.message,
            url: err.url
          });
          // Do not throw a hard error here, just return an empty array or handle gracefully
          return of([]); // Return an empty array if holidays can't be fetched
        })
      );
  }
  daysOfWeek = [
    { name: 'Sunday', value: 0 },
    { name: 'Monday', value: 1 },
    { name: 'Tuesday', value: 2 },
    { name: 'Wednesday', value: 3 },
    { name: 'Thursday', value: 4 },
    { name: 'Friday', value: 5 },
    { name: 'Saturday', value: 6 },
  ];

  operatingHours: any[] = this.daysOfWeek.map((day) => ({
    dayOfWeek: day.value,
    openTime: null,
    closeTime: null,
    isClosed: false,
  }));

  // business schedule

  days = [
    {
      name: 'Sunday',
      openingTime: '09:00',
      closingTime: '17:00',
      closed: true,
    },
    {
      name: 'Monday',
      openingTime: '08:00',
      closingTime: '18:00',
      closed: false,
    },
    {
      name: 'Tuesday',
      openingTime: '08:00',
      closingTime: '18:00',
      closed: false,
    },
    {
      name: 'Wednesday',
      openingTime: '08:00',
      closingTime: '18:00',
      closed: false,
    },
    {
      name: 'Thursday',
      openingTime: '08:00',
      closingTime: '18:00',
      closed: false,
    },
    {
      name: 'Friday',
      openingTime: '08:00',
      closingTime: '20:00',
      closed: false,
    },
    {
      name: 'Saturday',
      openingTime: '10:00',
      closingTime: '16:00',
      closed: false,
    },
  ];

  toggleDayClosed(index: number, event: Event) {
    const isChecked = (event.target as HTMLInputElement).checked;
    this.days[index].closed = isChecked;

    if (isChecked) {
      this.days[index].openingTime = '';
      this.days[index].closingTime = '';
    } else {
      // Set default times if empty
      if (!this.days[index].openingTime) {
        this.days[index].openingTime = '08:00';
      }
      if (!this.days[index].closingTime) {
        this.days[index].closingTime = '18:00';
      }
    }
  }

  updateDayTime(
    index: number,
    field: 'openingTime' | 'closingTime',
    event: Event
  ) {
    this.days[index][field] = (event.target as HTMLInputElement).value;
  }

  addException() {
    this.exceptions.unshift({
      title: '',
      date: '',
      openingTime: '08:00',
      closingTime: '18:00',
      closed: false,
      reason: '',
    });
  }

  removeException(index: number) {
    this.exceptions.splice(index, 1);
  }

  toggleExceptionClosed(index: number, event: Event) {
    const isChecked = (event.target as HTMLInputElement).checked;
    this.exceptions[index].closed = isChecked;

    if (isChecked) {
      this.exceptions[index].openingTime = '';
      this.exceptions[index].closingTime = '';
    } else {
      // Set default times if empty
      if (!this.exceptions[index].openingTime) {
        this.exceptions[index].openingTime = '08:00';
      }
      if (!this.exceptions[index].closingTime) {
        this.exceptions[index].closingTime = '18:00';
      }
    }
  }

  updateException(index: number, field: string, event: Event) {
    const value = (event.target as HTMLInputElement).value;
    (this.exceptions[index] as any)[field] = value;

    // Auto-generate title if it's empty and date is set
    if (field === 'date' && !this.exceptions[index].title && value) {
      const date = new Date(value);
      this.exceptions[index].title = date.toLocaleDateString('en-US', {
        month: 'long',
        day: 'numeric',
      });
    }
  }

  // Add a new fixed overhead row
  hasIncompleteFixedOverhead(): boolean {
    return this.fixedOverheadItems.some((item) => {
      // Only check rows being edited or newly added
      if (!(item.isEditing || item.isNew)) {
        return false; // Skip entries not being edited or newly added
      }

      // --- Basic Required Field Checks ---
      // 'overhead' is crucial. If 'overhead' is 'Other', then 'customOverhead' becomes crucial.
      const isOverheadMissing =
        !item.overhead || (item.overhead === 'Other' && !item.customOverhead);

      if (
        isOverheadMissing ||
        item.periodTypeID === null || // Period Type ID is crucial
        item.cost === null // Cost must not be null initially (will be validated further)
      ) {
        return true; // An essential text/dropdown field is missing or unselected
      }

      // --- Stronger 'cost' Validation ---
      const parsedCost = Number(item.cost);

      if (
        isNaN(parsedCost) || // Cannot be converted to a number
        !isFinite(parsedCost) || // Avoids Infinity, -Infinity
        parsedCost <= 0 // Must be a positive number
        // Consider adding Number.isInteger(parsedCost) if costs must be whole numbers
      ) {
        return true; // Cost is invalid
      }

      // If all checks pass for this item, it's considered complete for the purpose of blocking a new add.
      return false;
    });
  }
  onAddSaveFixed: boolean = false;
  addFixedOverhead(): void {
    // Step 1: Check for incomplete entries before allowing a new one
    if (this.hasIncompleteFixedOverhead()) {
      this.showMessageModal = true;
      this.alertInfo =
        '⚠️Please complete the current fixed cost and Save inline entry before adding a new one.';
      // You could also highlight the incomplete row here if desired
      return; // Stop the function execution
    }

    // Step 2: Trigger a save for any pending changes, indicating it's from the add button.
    // This save will *not* show a success message due to the `savingInitiator` check.
    this.onSaveFixedOverheads('add-button');

    // Step 3: Prepare the new empty item
    let defaultPeriodTypeId: number | null = null;
    const monthlyPeriodType = this.periodTypes.find(
      (pt) => pt.description.toLowerCase() === 'monthly'
    );

    if (monthlyPeriodType) {
      defaultPeriodTypeId = monthlyPeriodType.periodTypeID;
    } else {
      console.warn(
        'Monthly period type not found. Defaulting periodTypeID to null.'
      );
      // Consider setting a default to the first available period type if Monthly isn't mandatory
    }

    const newItem: FixedOverheadItem = {
      fixedOverheadID: 0, // Placeholder for new items
      overheadAllocationRateID: 0, // Placeholder
      overhead: '', // Starts empty, user must select
      customOverhead: undefined,
      cost: null, // Starts null, user must enter
      periodTypeID: defaultPeriodTypeId, // Pre-fill if 'Monthly' was found
      isEditing: true, // New item starts in edit mode
      isNew: true, // Mark as new for saving logic
      isModified: false, // Not modified until user interacts
      overheadCostPoolID: null, // Assuming this might be null or requires selection
      createdAt: new Date().toISOString(),
      validFrom: new Date().toISOString(),
      validTo: '2099-12-31T00:00:00Z',

      // Initial validation state for the new, empty row
      invalidOverhead: true, // Initially invalid as overhead is empty
      invalidCost: true, // Initially invalid as cost is null
      invalidperiodTypeID: defaultPeriodTypeId === null, // Reflects if Monthly was not found
      isValid: false, // Overall invalid until all required fields are filled

      originalItem: undefined,
      touched: false,
    };

    // Step 4: Add the new item to the array
    this.fixedOverheadItems.unshift(newItem);

    // Step 5: Immediately validate the new item to provide visual feedback (e.g., red borders)
    this.validateFixedOverheadItem(newItem); // You need to implement this method to update item.isValid etc.
    this.cdr.detectChanges(); // Ensure Angular updates the view immediately
  }
  private validateFixedOverheadItem(item: FixedOverheadItem): void {
    // Validate Overhead Name
    if (item.overhead === 'custom') {
      item.invalidOverhead =
        !item.customOverhead || item.customOverhead.trim() === '';
    } else {
      item.invalidOverhead = !item.overhead || item.overhead.trim() === '';
    }

    // Validate Cost
    // Check for null, undefined, non-numeric, or non-positive values
    item.invalidCost = item.cost === null || isNaN(item.cost) || item.cost <= 0;

    // Validate Payment Period
    item.invalidperiodTypeID = item.periodTypeID === null; // Check if a period type is selected

    // Update overall validity
    item.isValid =
      !item.invalidOverhead && !item.invalidCost && !item.invalidperiodTypeID;
  }
  // Remove a fixed overhead row

  toggleEditModeVariable(item: VariableOverheadItem): void {
    // If we are currently in edit mode and about to switch to read-only
    if (item.isEditing) {
      // If it's a new item (that hasn't been saved yet) and we're canceling, remove it
      if (item.isNew) {
        this.variableOverheadItems = this.variableOverheadItems.filter(
          (voh) => voh !== item
        );
      } else {
        // If it's an existing item, revert to its original state (before editing started)
        // Check if originalItem exists to prevent errors if not set for some reason
        if (item.originalItem) {
          Object.assign(item, item.originalItem); // Revert all properties
        }
        // Explicitly set flags for an existing item after reverting to original
        item.isEditing = false; // Exit edit mode
        item.isModified = false; // It's no longer considered modified if reverted

        // Reset all invalid flags for the item, as we've reverted to a valid (presumably) original state
        item.invalidOverhead = false;
        item.invalidSupplier = false;
        item.invalidPurchasePrice = false;
        item.invalidPurchaseQuantity = false;
        item.invalidUOM = false;
        item.invalidCategory = false; // Add this one
        item.invalidLowStockThreshold = false; // Add this one
        item.isValid = true; // Assume the original item was valid
      }
    } else {
      // When entering edit mode
      // Store a deep copy of the original item. This ensures changes made during editing
      // don't affect the 'originalItem' until saved, allowing a true revert.
      item.originalItem = JSON.parse(JSON.stringify(item));
      item.isEditing = true; // Enter edit mode
      // When entering edit mode, it's good practice to re-run validation
      // in case it was valid before but some data constraint changed or was missed.
      this.validateVariableOverheadItem(item); // Ensure this function exists and works
    }
    this.cdr.detectChanges(); // Force change detection update
  }
  onVariableOverheadFieldChange(item: VariableOverheadItem): void {
    // 0. Mark item as touched (used to control when to show validation messages)
    item.touched = true;

    // 1. Re-run comprehensive validation for the item
    this.validateVariableOverheadItem(item); // Keep your existing validation logic

    // 2. Determine if the item has been modified from its original state
    if (!item.isNew && item.originalItem) {
      const hasChanged =
        item.overhead !== item.originalItem.overhead ||
        item.customOverhead !== item.originalItem.customOverhead ||
        item.categoryID !== item.originalItem.categoryID ||
        item.supplierID !== item.originalItem.supplierID ||
        item.purchasePrice !== item.originalItem.purchasePrice ||
        item.purchaseQuantity !== item.originalItem.purchaseQuantity ||
        item.uomID !== item.originalItem.uomID ||
        item.lowStockThreshold !== item.originalItem.lowStockThreshold;

      item.isModified = hasChanged;
    } else if (item.isNew) {
      // For new items, consider them modified if they are valid or being edited
      item.isModified = item.isValid;
    }

    // Optional debugging logs
    // Manually trigger change detection to update the UI
    this.cdr.detectChanges();
  }
  private validateVariableOverheadItem(item: VariableOverheadItem): void {
    // Validate Overhead Name (Type)
    if (item.overhead === 'custom') {
      item.invalidOverhead =
        !item.customOverhead || item.customOverhead.trim() === '';
    } else {
      // Ensure item.overhead is not null/empty if not custom
      item.invalidOverhead = !item.overhead || item.overhead.trim() === '';
    }

    // Validate Category
    // Assuming 0 is NOT a valid categoryID (if it can be, adjust this check)
    item.invalidCategory =
      item.categoryID === null ||
      item.categoryID === undefined ||
      item.categoryID <= 0;

    // Validate Supplier
    item.invalidSupplier =
      item.supplierID === null ||
      item.supplierID === undefined ||
      item.supplierID <= 0;

    // Validate Purchase Price
    item.invalidPurchasePrice =
      item.purchasePrice === null ||
      isNaN(item.purchasePrice) ||
      item.purchasePrice <= 0;

    // Validate Purchase Quantity
    item.invalidPurchaseQuantity =
      item.purchaseQuantity === null ||
      isNaN(item.purchaseQuantity) ||
      item.purchaseQuantity < 1;

    // Validate Units of Measurement
    item.invalidUOM =
      item.uomID === null || item.uomID === undefined || item.uomID <= 0;

    // Validate Low Stock Threshold (optional, but non-negative if provided)
    // Only invalid if it's a number AND less than 0
    item.invalidLowStockThreshold =
      item.lowStockThreshold !== null &&
      item.lowStockThreshold !== undefined &&
      item.lowStockThreshold < 0;

    // Update overall validity: ALL required fields must be valid
    item.isValid =
      !item.invalidOverhead &&
      !item.invalidCategory &&
      !item.invalidSupplier &&
      !item.invalidPurchasePrice &&
      !item.invalidPurchaseQuantity &&
      !item.invalidUOM &&
      !item.invalidLowStockThreshold; // Include lowStockThreshold validation in overall validity if desired
  }
  getVariableOverheadTypeDisplay(item: VariableOverheadItem): string {
    if (item.overhead === 'custom') {
      return item.customOverhead || 'Custom Overhead';
    }
    const option = this.variableOverheads.find(
      (o) => o.value === item.overhead
    );
    return option ? option.label : item.overheadName || 'N/A';
  }

  private generateVariableOverheadItemCode(itemName: string): string {
    if (!itemName) {
      return 'VOH_UNKNOWN'; // Fallback if itemName is empty or null
    }

    // 1. Remove special characters and replace spaces with underscores
    //    Keeps alphanumeric characters and converts to uppercase
    const sanitizedName = itemName
      .replace(/[^a-zA-Z0-9\s]/g, '') // Remove non-alphanumeric (except spaces)
      .replace(/\s+/g, '_') // Replace multiple spaces with single underscore
      .toUpperCase(); // Convert to uppercase

    // 2. Prefix with "VOH_"
    return `VOH_${sanitizedName}`;
  }

  /**
   * Handles the submission logic for 'details' and 'challenges' tabs.
   */
  private async handleSubmitDetailsAndChallenges(
    initiator: 'add-button' | 'tab-change' | 'manual-save' = 'manual-save'
  ) {
    this.isProcessing = true;
    if (!this.validateDetailsAndChallengesFields()) {
      this.displayMessage(
        '⚠️Please fill in all required fields and remember to Save.'
      );
      this.isProcessing = false;
      return;
    }

    const token = localStorage.getItem('authToken');
    if (!token) {
      this.displayMessage('⚠️Authentication error. Please log in again.');
      return;
    }

    try {
      await this.fetchAndSetTenantProfileId();

      const isUpdate = this.tenantProfileID && this.tenantProfileID !== 0;

      // Prepare the request body
      const requestBody = {
        tenantProfileID: this.tenantProfileID || 0, // Will be set by the backend for new records
        tenantProfileName: this.businessName,
        industry: this.industry,
        businessModels: 'Business to Business',
        location: this.location,
        businessType: this.businessType,
        businessBrief: this.businessBrief,
        businessSize: 'Small to medium enterprice (SME)',
        targetMarkets: this.targetMarket.join(', '),
        vendorType: this.vendorType,
        salesChannels: this.salesChannel.join(','),
        keyChallenges: this.keyChallenges,
      };

      let apiUrl: string;
      let method: string;

      if (isUpdate) {
        // For updates, include the ID in both the URL and the body
        apiUrl = `${environment.apiUrl}/api/TenantProfile/Update?TenantProfileId=${this.tenantProfileID}`;
        method = 'PUT';
      } else {
        // For new records, just use the Add endpoint
        apiUrl = `${environment.apiUrl}/api/TenantProfile/Add`;
        method = 'POST';
      }

      const response = await fetch(apiUrl, {
        method: method,
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestBody),
      });

      if (!response.ok) {
        const errorData = await response.json();
        console.error('API Error Response:', errorData);
        throw new Error(`API error: ${response.statusText}`);
      }

      const responseData = await response.json();
      this.isProcessing = false;
      if (initiator === 'manual-save') {
        this.savingInitiator = null;
        this.displaySuccessMessage('All changes saved successfully');
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      this.isProcessing = false;
      this.displayMessage(
        'An error occurred while submitting. Please try again later.'
      );
    }
    this.onTabChangeCall = false;
    this.savingInitiator = null;
  }

  /**
   * Validates the required fields for the 'details' and 'challenges' tabs.
   * @returns {boolean} - True if all required fields are filled, false otherwise.
   */

  private validateDetailsAndChallengesFields(): boolean {
    return (
      !!this.businessName &&
      !!this.industry &&
      !!this.location &&
      !!this.businessType &&
      !!this.businessBrief &&
      this.targetMarket.length > 0 &&
      !!this.vendorType &&
      this.salesChannel.length > 0
    );
  }

  /**
   * Fetches the latest tenant profile ID and sets it to `this.tenantProfileID`.
   */
  private async fetchAndSetTenantProfileId(): Promise<void> {
    try {
      const fetchedId = await this.getLatestTenantProfileId().toPromise();
      this.tenantProfileID = fetchedId || 0;
    } catch (error) {
      console.error('Error fetching latest tenant profile ID:', error);
      throw error; // Re-throw to stop execution in calling function
    }
  }

  /**
   * Handles the submission logic for the 'expenses' tab, including fixed and variable overheads.
   *
   */
  async removeVariableOverhead(index: number, skipConfirm: boolean = false): Promise<void> {
    const token = this.getAuthToken();
    if (!token) {
      this.displayMessage('⚠️Authentication error. Please log in again.');
      return;
    }

    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    });
    const itemToRemove = this.variableOverheadItems[index];
    if (!skipConfirm) {
      this.showDeleteConfirm = true;
      const confirmed = await this.deleteConfirmed;
      if (!confirmed) {
        this.deleteConfirmed = new Promise((resolve) => {
          this.resolveDelete = resolve;
        });
        return; // User cancelled
      }
      this.deleteConfirmed = new Promise((resolve) => {
        this.resolveDelete = resolve;
      });
    }
    // If the item has a variableOverheadID (which now represents the ItemID),
    // it means it's an existing Item from the backend that we want to delete.
    if (itemToRemove.variableOverheadItemID) {
      this.deletedOverheadIds.push(itemToRemove.variableOverheadItemID);
    } else {
      // If it's a new item (no ItemID yet), it was never saved to the backend as an Item,
      // so no need to track its deletion from the backend Items table.
    }

    // Always remove from the frontend array immediately
    this.variableOverheadItems.splice(index, 1);
    this.cdr.detectChanges();
    if (this.isMobileView()) {
      this.toast.success('Variable cost removed', 3000);
    }
  }
  async onSaveVariableOverheads(
    initiator: 'add-button' | 'tab-change' | 'manual-save' = 'manual-save'
  ): Promise<void> {
    // CRUCIAL: Set the savingInitiator flag immediately to track the source of this save.

    this.savingInitiator = initiator;

    try {
      const headers = this.getAuthHeaders(); // Gets token and sets headers
      await this.processVariableOverheads(headers, initiator);
    } catch (error) {
      console.error('Error in onSaveVariableOverheads:', error);
      // getAuthHeaders might throw, or processVariableOverheads could have an immediate sync error
      this.displayMessage(
        '⚠️An unexpected error occurred while initiating save.'
      );
      this.savingInitiator = null; // Reset if an error prevents processVariableOverheads from even starting
    }
  }
  async onSaveFixedOverheads(
    initiator: 'add-button' | 'tab-change' | 'manual-save' = 'manual-save'
  ): Promise<void> {
    // CRUCIAL: Set the savingInitiator flag immediately to track the source of this save.
    this.savingInitiator = initiator;

    const token = this.getAuthToken();
    if (!token) {
      this.displayMessage('⚠️Authentication error. Please log in again.');
      this.savingInitiator = null; // Reset flag if authentication fails immediately
      return;
    }

    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    });

    try {
      await this.processFixedOverheads(headers, initiator);
    } catch (error) {
      console.error('Error in onSaveFixedOverheads:', error);
      this.displayMessage('⚠️An unexpected error occurred during save.');
    }
    // The 'finally' block for resetting `savingInitiator` is no longer needed here,
    // as it's handled in the `complete` callback of `processFixedOverheads`.
  }

  /**
   * Validates all fixed overhead items.
   * @returns {boolean} - True if all fixed overheads are valid, false otherwise.
   */
  private validateFixedOverheads(): boolean {
    this.fixedOverheadItems.forEach((item) => {
      item.invalidOverhead = false;
      item.invalidCost = false;
      item.invalidperiodTypeID = false;
    });

    return this.fixedOverheadItems.every((item) => {
      let valid = true;
      if (item.isEditing || item.isNew || item.isModified) {
        if (!item.overhead?.trim()) {
          item.invalidOverhead = true;
          valid = false;
        } else if (item.overhead === 'custom' && !item.customOverhead?.trim()) {
          item.invalidOverhead = true;
          valid = false;
        }
        if (item.cost === null || item.cost === undefined || item.cost < 0) {
          item.invalidCost = true;
          valid = false;
        }
        if (item.periodTypeID === null || item.periodTypeID === undefined) {
          item.invalidperiodTypeID = true;
          valid = false;
        }
      }
      return valid;
    });
  }

  /**
   * Processes the add/update operations for fixed overhead items.
   * @param {HttpHeaders} headers - The HTTP headers for the request.
   */
  private async processFixedOverheads(
    headers: HttpHeaders,
    initiator: 'add-button' | 'tab-change' | 'manual-save' = 'manual-save'
  ): Promise<void> {
    this.isProcessing = true;
    const overheadRequests = this.fixedOverheadItems
      .filter((item) => item.isNew || item.isModified) // Only process items that are new or have been changed
      .map((item) => {
        // Determine the correct overhead name to send to the backend
        let nameToSendToBackend: string;
        if (item.overhead === 'custom') {
          nameToSendToBackend = item.customOverhead?.trim() || ''; // Use custom if 'custom' is selected
        } else {
          const selectedOption = this.fixedOverheads.find(
            (option) => option.value === item.overhead
          );
          nameToSendToBackend = selectedOption
            ? selectedOption.label
            : item.overhead || ''; // Use label or fallback to value/empty
        }

        if (item.fixedOverheadID && !item.isNew) {
          // --- Update Existing Item ---
          const overheadItemDto: OverheadCostItemDTO = {
            overheadCostItemID: item.fixedOverheadID,
            overheadName: nameToSendToBackend,
            overheadCostPoolID: item.overheadCostPoolID, // Assuming this is set for existing items
            description: nameToSendToBackend,
            createdAt: item.originalItem?.createdAt || new Date().toISOString(),
            updatedAt: new Date().toISOString(),
          };

          const allocRateDto: OverheadAllocationRateDTO = {
            overheadAllocationRateID: item.overheadAllocationRateID ?? 0,
            overheadCostItemID: item.fixedOverheadID, // Link to the overhead cost item
            periodTypeID: item.periodTypeID ?? 1, // Default if null, though validation should prevent this
            rateValue: item.cost ?? 0, // Default if null, though validation should prevent this
            currencyCode: 'ZAR', // Assuming a default currency
            validFrom: item.originalItem?.validFrom || new Date().toISOString(),
            validTo: item.originalItem?.validTo || '2099-12-31T00:00:00Z',
            createdAt: item.originalItem?.createdAt || new Date().toISOString(),
            updatedAt: new Date().toISOString(),
          };

          return this.http
            .put<any>(
              `${environment.apiUrl}/api/OverheadCostItem/Update?id=${item.fixedOverheadID}`,
              overheadItemDto,
              { headers }
            )
            .pipe(
              switchMap(() => {
                return this.http.put<any>(
                  `${environment.apiUrl}/api/OverheadAllocationRate/Update?OverheadAllocationRateId=${item.overheadAllocationRateID}`,
                  allocRateDto,
                  { headers }
                );
              }),
              tap((response) => {
                // Reset flags for the updated item
                item.isNew = false;
                item.isModified = false;
                item.isEditing = false;
                item.originalItem = { ...item }; // Update original for future comparisons
              }),
              catchError((err) => {
                console.error(
                  `Error updating fixed overhead (ID: ${item.fixedOverheadID}):`,
                  err
                );
                return of(null); // Return an observable of null to allow forkJoin to continue
              })
            );
        } else if (item.isNew) {
          // --- Add New Item ---
          const overheadItemDto: OverheadCostItemDTO = {
            overheadCostItemID: 0, // Backend will assign actual ID
            overheadName: nameToSendToBackend,
            overheadCostPoolID: item.overheadCostPoolID, // Should be set if linked to a pool
            description: nameToSendToBackend,
            createdAt: new Date().toISOString(),
            updatedAt: new Date().toISOString(),
          };

          return this.http
            .post<OverheadCostItemDTO>(
              `${environment.apiUrl}/api/OverheadCostItem/Add`,
              overheadItemDto,
              { headers }
            )
            .pipe(
              switchMap((createdItem: OverheadCostItemDTO) => {
                // Update the new item with the ID from the backend
                item.fixedOverheadID = createdItem.overheadCostItemID;

                const allocRateDto: OverheadAllocationRateDTO = {
                  overheadAllocationRateID: 0, // Backend will assign actual ID
                  overheadCostItemID: createdItem.overheadCostItemID, // Link to newly created item
                  periodTypeID: item.periodTypeID ?? 1,
                  rateValue: item.cost ?? 0,
                  currencyCode: 'ZAR',
                  validFrom: item.validFrom || new Date().toISOString(),
                  validTo: item.validTo || '2099-12-31T00:00:00Z',
                  createdAt: new Date().toISOString(),
                  updatedAt: new Date().toISOString(),
                };
                return this.http.post<OverheadAllocationRateDTO>(
                  `${environment.apiUrl}/api/OverheadAllocationRate/Add`,
                  allocRateDto,
                  { headers }
                );
              }),
              tap((createdAllocRate: OverheadAllocationRateDTO) => {
                // Update the item with the ID from the backend for the allocation rate
                item.overheadAllocationRateID =
                  createdAllocRate.overheadAllocationRateID;
                // Reset flags for the newly saved item
                item.isNew = false;
                item.isModified = false;
                item.isEditing = false;
                item.originalItem = { ...item }; // Set original for future comparisons
              }),
              catchError((err) => {
                console.error('Error adding new fixed overhead:', err);
                return of(null);
              })
            );
        }
        return of(null); // Return an observable of null for items that don't need update/add
      });

    const activeOverheadRequests = overheadRequests.filter(
      (req) => req !== null // Filter out any 'null' observables (items skipped)
    );

    if (activeOverheadRequests.length > 0) {
      // Use forkJoin to wait for all active requests to complete
      forkJoin(activeOverheadRequests).subscribe({
        next: (results) => {
          const successfulResults = results.filter((res) => res !== null);
          if (successfulResults.length > 0) {
            // --- CRUCIAL: Conditional Message Display ---
            // Only show success message if the save was NOT initiated by the 'add-button'
            this.isProcessing = false;
            if (initiator === 'manual-save') {
              this.displaySuccessMessage(
                'Fixed expenses successfully saved/updated'
              );
            }
            // --- END CRUCIAL ---

            this.deletedOverheadIds = []; // Clear deleted IDs after successful processing
          } else {
            this.displayMessage('⚠️Fixed expenses save or update failed.');
          }
        },
        error: (err) => {
          console.error('Error processing fixed overheads:', err);
          this.displayMessage(
            '⚠️An error occurred while saving fixed overheads. Please try again.'
          );
        },
        complete: () => {
          // --- CRUCIAL: Resetting the initiator and refreshing data ---
          this.isProcessing = false;
          this.cdr.detectChanges(); // Ensures UI updates are triggered
          this.loadFixedOverheads(); // Reload data to reflect saved changes
          this.savingInitiator = null; // Reset the flag AFTER all async work is done
        },
      });
    } else {
      this.isProcessing = false;
      // If no requests were needed, reset the initiator immediately.
      this.savingInitiator = null;
    }
  }

  /**
   * Validates all variable overhead items.
   * @returns {boolean} - True if all variable overheads are valid, false otherwise.
   */
  private validateVariableOverheads(): boolean {
    this.variableOverheadItems.forEach((item) => {
      item.invalidOverhead = false;
      item.invalidSupplier = false;
      item.invalidPurchasePrice = false;
      item.invalidPurchaseQuantity = false;
      item.invalidUOM = false;
    });

    return this.variableOverheadItems.every((item) => {
      let valid = true;
      if (item.isEditing || item.isNew || item.isModified) {
        if (!item.overhead?.trim()) {
          item.invalidOverhead = true;
          valid = false;
        } else if (item.overhead === 'custom' && !item.customOverhead?.trim()) {
          item.invalidOverhead = true;
          valid = false;
        }
        if (item.supplierID === null || item.supplierID === undefined) {
          item.invalidSupplier = true;
          valid = false;
        }
        if (
          item.purchasePrice === null ||
          item.purchasePrice === undefined ||
          item.purchasePrice < 0
        ) {
          item.invalidPurchasePrice = true;
          valid = false;
        }
        if (
          item.purchaseQuantity === null ||
          item.purchaseQuantity === undefined ||
          item.purchaseQuantity < 1
        ) {
          item.invalidPurchaseQuantity = true;
          valid = false;
        }
        if (item.uomID === null || item.uomID === undefined) {
          item.invalidUOM = true;
          valid = false;
        }
      }
      return valid;
    });
  }

  /**
   * Processes the deletion, add, and update operations for variable overhead items.
   * @param {HttpHeaders} headers - The HTTP headers for the request.
   */
  hasIncompleteVariableOverhead(): boolean {
    return this.variableOverheadItems.some((item) => {
      // Only check items that are in an active editing/new state
      if (!(item.isEditing || item.isNew)) {
        return false; // Skip items not being actively worked on
      }

      // Call the detailed validation for the specific item
      this.validateVariableOverheadItem(item);

      // If any of the specific 'invalid' flags are true, the item is incomplete/invalid.
      // Also check for nulls if validateVariableOverheadItem doesn't set isValid based on them.
      if (
        item.invalidOverhead ||
        item.invalidSupplier ||
        item.invalidPurchasePrice ||
        item.invalidPurchaseQuantity ||
        item.invalidUOM ||
        item.invalidCategory ||
        item.invalidLowStockThreshold ||
        item.isValid === false // Explicitly check isValid if your validate method sets it
      ) {
        return true;
      }

      // Additional check for cases where the flag might not be immediately set by validateVariableOverheadItem
      if (
        item.overhead === null ||
        (item.overhead === 'custom' && !item.customOverhead?.trim()) ||
        item.supplierID === null ||
        item.purchasePrice === null ||
        item.purchaseQuantity === null ||
        item.uomID === null ||
        item.categoryID === null
      ) {
        return true;
      }

      // Check numerical values specifically
      const parsedPurchasePrice = Number(item.purchasePrice);
      const parsedPurchaseQuantity = Number(item.purchaseQuantity);
      const parsedLowStockThreshold = Number(item.lowStockThreshold);

      if (
        isNaN(parsedPurchasePrice) ||
        parsedPurchasePrice < 0 ||
        isNaN(parsedPurchaseQuantity) ||
        parsedPurchaseQuantity <= 0 || // Quantity usually must be > 0
        isNaN(parsedLowStockThreshold) ||
        parsedLowStockThreshold < 0
      ) {
        return true;
      }

      return false; // If all checks pass for this item, it's considered complete/valid for blocking purposes
    });
  }

  addVariableOverhead(): void {
    // Find the "Unselected" supplier's ID (case insensitive)
    if (this.hasIncompleteVariableOverhead()) {
      this.showMessageModal = true;
      this.alertInfo =
        '⚠️Please complete all current variable overhead entries and Save inline before adding a new one.';
      return; // Stop execution
    }
    this.onSaveVariableOverheads('add-button');
    const categoryID = this.categories[0].categoryId; // This is the crucial assignment for your dropdowns
    const unselectedSupplier = this.suppliers?.find(
      (s) => s.companyName?.toLowerCase() === 'Unlisted'
    );
    const unselectedSupplierID = unselectedSupplier
      ? unselectedSupplier.supplierID
      : this.suppliers[0].supplierID;
    if (!unselectedSupplierID) {
      console.warn(
        'Unlisted supplier not found. Defaulting supplierID to null.'
      );
    }

    const newItem: VariableOverheadItem = {
      touched: false,
      overhead: null,
      supplierID: unselectedSupplierID, // Set default supplier ID here
      purchasePrice: null,
      purchaseQuantity: null,
      uomID: null,
      categoryID: categoryID,
      lowStockThreshold: 1,
      overheadCostPoolID: this.variableOverheadCostPoolID,
      userIDEntered: null,
      leadTimeDays: null,
      isNew: true,
      isModified: false,
      isEditing: true,
      invalidOverhead: true,
      invalidSupplier: true,
      invalidPurchasePrice: true,
      invalidPurchaseQuantity: true,
      invalidUOM: true,
      invalidCategory: true,
      invalidLowStockThreshold: false,
      itemSupplierPriceHistoryID: null,
    };

    newItem.originalItem = { ...newItem };
    this.variableOverheadItems.unshift(newItem);
    this.cdr.detectChanges();
  }
  private async processVariableOverheads(
    headers: HttpHeaders,
    initiator: 'add-button' | 'tab-change' | 'manual-save' = 'manual-save'
  ) {
    this.isProcessing = true;
    // Create a new HttpHeaders object that includes the current user
    // This ensures the original 'headers' object (likely containing auth) is preserved,
    // and we add the initiator information.
    // You might already have a centralized way to add headers, but for this specific
    // scenario, we'll add it here for clarity.
    let requestHeaders = headers;
    if (this.currentUser) {
      requestHeaders = requestHeaders.set('X-Initiated-By', this.currentUser);
      // 'X-Initiated-By' is a common pattern for custom headers.
      // Your backend API will need to be configured to read this header.
    }

    // 1. Prepare deletion requests
    const deleteRequests: Observable<any>[] = [];
    if (this.deletedOverheadIds.length > 0) {
      this.deletedOverheadIds.forEach((overheadId) => {
        deleteRequests.push(
          this.http
            .delete(
              `${environment.apiUrl}/api/Items/Delete?ItemId=${overheadId}`, // Removed deletedBy from query param
              { headers: requestHeaders } // Use the new headers object
            )
            .pipe(
              tap(() =>
                console.log(``)
              ),
              catchError((err) => {

                return throwError(
                  () =>
                    new Error(`Failed to delete overhead ID: ${overheadId}`)
                );
              })
            )
        );
      });
    }

    // 2. Prepare add/update requests for variable overhead items
    const variableOverheadRequests = this.variableOverheadItems
      .filter((item) => item.isNew || item.isModified)
      .filter((item) => {
        const hasUom = typeof item.uomID === 'number' && item.uomID > 0;
        if (!hasUom) {
          console.warn(
            `Skipping variable overhead "${item.overheadName || item.overhead}" — no UOM selected.`
          );
        }
        return hasUom;
      })
      .map((item) => {
        const resolvedPredefinedName = (() => {
          if (typeof item.overhead === 'string' && item.overhead !== 'custom') {
            return item.overhead.trim();
          }

          if (item.overheadName && typeof item.overheadName === 'string') {
            return item.overheadName.trim();
          }

          const match = this.variableOverheads.find(
            (option) => option.value === item.overhead || option.label === item.overhead
          );
          return match?.label?.trim() || '';
        })();

        const actualOverheadName: string =
          item.overhead === 'custom'
            ? item.customOverhead?.trim() || ''
            : resolvedPredefinedName;
        let itemOperation$: Observable<ItemDTO>;
        let existingItem: ItemDTO | undefined;

        if (actualOverheadName) {
          existingItem = this.items.find(
            (i) => i.itemName.toLowerCase() === actualOverheadName.toLowerCase()
          );
        }

        if (item.overhead === 'custom' && actualOverheadName) {
          // Custom Overhead Logic
          if (!existingItem) {
            // New custom item
            const generatedItemCode = this.generateVariableOverheadItemCode(
              actualOverheadName || ''
            );
            const newItemPayload: ItemDTO = {
              itemName: actualOverheadName,
              itemCode: generatedItemCode,
              description: actualOverheadName,
              itemTypeID: 3, // Assuming 3 is the ItemTypeID for Variable Overheads
              purchaseUOMID: item.uomID ?? 0,
              lowStockThreshold: item.lowStockThreshold,
              isActive: true,
              sellingPrice: 0,
              profitMarginPercent: 0,
              purchasePrice: item.purchasePrice ?? 0,
              purchaseQuantity: item.purchaseQuantity ?? 0,
              valuationMethodCode: 'AverageCost',
              categoryID: item.categoryID ?? null,
              itemID: 0,
              supplierID: item.supplierID ?? null,
              createdAt: new Date().toISOString(),
              updatedAt: new Date().toISOString(),
              createdBy: this.currentUser,
            };
            itemOperation$ = this.http
              .post<ItemDTO>(
                `${environment.apiUrl}/api/Items/Add`,
                newItemPayload,
                { headers: requestHeaders } // Use the new headers object
              )
              .pipe(
                tap((newItem) => {
                  this.items.push(newItem);
                }),
                catchError((err) => {
                  console.error(
                    `Error adding new Item '${actualOverheadName}':`,
                    err
                  );
                  if (err.error) {
                    console.error('Backend Error Details:', err.error);
                  }
                  return throwError(
                    () =>
                      new Error(`Failed to add new Item: ${actualOverheadName}`)
                  );
                })
              );
          } else {
            // Existing custom item
            const originalItemInItemsList = this.items.find(
              (i) => i.itemID === existingItem!.itemID
            );
            let itemNeedsUpdate = false;
            const updatePayload: ItemDTO = { ...existingItem! };

            if (item.customOverhead?.trim() !== existingItem.itemName) {
              itemNeedsUpdate = true;
              updatePayload.itemName = item.customOverhead?.trim() || '';
              updatePayload.description = item.customOverhead?.trim() || '';
            }
            if (item.uomID !== originalItemInItemsList?.purchaseUOMID) {
              itemNeedsUpdate = true;
              updatePayload.purchaseUOMID = item.uomID ?? 0;
            }
            if (
              item.lowStockThreshold !==
              originalItemInItemsList?.lowStockThreshold
            ) {
              itemNeedsUpdate = true;
              updatePayload.lowStockThreshold = item.lowStockThreshold;
            }
            if (item.categoryID !== originalItemInItemsList?.categoryID) {
              itemNeedsUpdate = true;
              updatePayload.categoryID = item.categoryID ?? null;
            }
            if (item.purchasePrice !== originalItemInItemsList?.purchasePrice) {
              itemNeedsUpdate = true;
              updatePayload.purchasePrice = item.purchasePrice ?? 0;
            }
            if (
              item.purchaseQuantity !==
              originalItemInItemsList?.purchaseQuantity
            ) {
              itemNeedsUpdate = true;
              updatePayload.purchaseQuantity = item.purchaseQuantity ?? 0;
            }
            if (item.supplierID !== originalItemInItemsList?.supplierID) {
              itemNeedsUpdate = true;
              updatePayload.supplierID = item.supplierID ?? null;
            }

            if (itemNeedsUpdate) {
              updatePayload.updatedAt = new Date().toISOString();
              // updatePayload.updatedBy = this.currentUser; // Removed from DTO

              itemOperation$ = this.http
                .put<ItemDTO>(
                  `${environment.apiUrl}/api/Items/Update?ItemId=${existingItem.itemID}`,
                  updatePayload,
                  { headers: requestHeaders } // Use the new headers object
                )
                .pipe(
                  tap((updatedItem) => {
                    const index = this.items.findIndex(
                      (i) => i.itemID === updatedItem.itemID
                    );
                    if (index !== -1) {
                      this.items[index] = updatedItem;
                    }
                  }),
                  catchError((err) => {
                    console.error(
                      `Error updating existing Item '${actualOverheadName}':`,
                      err
                    );
                    return throwError(
                      () =>
                        new Error(
                          `Failed to update Item: ${actualOverheadName}`
                        )
                    );
                  })
                );
            } else {
              itemOperation$ = of(existingItem);
            }
          }
        } else if (item.overhead !== 'custom' && actualOverheadName) {
          // Predefined Overhead Logic
          if (!existingItem) {
            // Predefined overhead not found in fetched items. Treat as new item and add it.
            console.warn(
              `Predefined overhead name '${actualOverheadName}' not found in fetched items. Adding as new item.`
            );
            const generatedItemCode = this.generateVariableOverheadItemCode(
              actualOverheadName || ''
            );
            const newItemPayload: ItemDTO = {
              itemID: 0,
              itemName: actualOverheadName,
              itemCode: generatedItemCode,
              description: actualOverheadName,
              itemTypeID: 3,
              purchaseUOMID: item.uomID ?? 0,
              lowStockThreshold: item.lowStockThreshold,
              isActive: true,
              sellingPrice: 0,
              profitMarginPercent: 0,
              purchaseQuantity: item.purchaseQuantity ?? 0,
              purchasePrice: item.purchasePrice ?? 0,
              valuationMethodCode: 'AverageCost',
              categoryID: item.categoryID ?? null,
              supplierID: item.supplierID ?? null,
              createdAt: new Date().toISOString(),
              updatedAt: new Date().toISOString(),
              createdBy: this.currentUser,
            };
            itemOperation$ = this.http
              .post<ItemDTO>(
                `${environment.apiUrl}/api/Items/Add`,
                newItemPayload,
                { headers: requestHeaders } // Use the new headers object
              )
              .pipe(
                tap((newItem) => {
                  this.items.push(newItem);
                }),
                catchError((err) => {
                  console.error(
                    `Error adding new Item for 'predefined as new' '${actualOverheadName}':`,
                    err
                  );
                  if (err.error) {
                    console.error('Backend Error Details:', err.error);
                  }
                  return throwError(
                    () =>
                      new Error(`Failed to add new Item: ${actualOverheadName}`)
                  );
                })
              );
          } else {
            // Existing predefined item: Check for updates to its ItemDTO properties
            const originalItemInItemsList = this.items.find(
              (i) => i.itemID === existingItem!.itemID
            );
            let itemNeedsUpdate = false;
            const updatePayload: ItemDTO = { ...existingItem! };

            if (item.uomID !== originalItemInItemsList?.purchaseUOMID) {
              itemNeedsUpdate = true;
              updatePayload.purchaseUOMID = item.uomID ?? 0;
            }
            if (
              item.lowStockThreshold !==
              originalItemInItemsList?.lowStockThreshold
            ) {
              itemNeedsUpdate = true;
              updatePayload.lowStockThreshold = item.lowStockThreshold;
            }
            if (item.categoryID !== originalItemInItemsList?.categoryID) {
              itemNeedsUpdate = true;
              updatePayload.categoryID = item.categoryID ?? null;
            }
            if (item.purchasePrice !== originalItemInItemsList?.purchasePrice) {
              itemNeedsUpdate = true;
              updatePayload.purchasePrice = item.purchasePrice ?? 0;
            }
            if (
              item.purchaseQuantity !==
              originalItemInItemsList?.purchaseQuantity
            ) {
              itemNeedsUpdate = true;
              updatePayload.purchaseQuantity = item.purchaseQuantity ?? 0;
            }
            if (item.supplierID !== originalItemInItemsList?.supplierID) {
              itemNeedsUpdate = true;
              updatePayload.supplierID = item.supplierID ?? null;
            }

            if (itemNeedsUpdate) {
              updatePayload.updatedAt = new Date().toISOString();
              // updatePayload.updatedBy = this.currentUser; // Removed from DTO

              itemOperation$ = this.http
                .put<ItemDTO>(
                  `${environment.apiUrl}/api/Items/Update?ItemId=${existingItem.itemID}`,
                  updatePayload,
                  { headers: requestHeaders } // Use the new headers object
                )
                .pipe(
                  tap((updatedItem) => {
                    const index = this.items.findIndex(
                      (i) => i.itemID === updatedItem.itemID
                    );
                    if (index !== -1) {
                      this.items[index] = updatedItem;
                    }
                  }),
                  catchError((err) => {
                    console.error(
                      `Error updating existing Predefined Item '${actualOverheadName}':`,
                      err
                    );
                    return throwError(
                      () =>
                        new Error(
                          `Failed to update Predefined Item: ${actualOverheadName}`
                        )
                    );
                  })
                );
            } else {
              itemOperation$ = of(existingItem);
            }
          }
        } else {
          const errorMessage = `Invalid overhead type or custom name provided for item.`;
          console.error(errorMessage, item);
          return throwError(() => new Error(errorMessage));
        }

        // Step 2: Use the ItemID to add a new ItemSupplierPriceHistory record
        return itemOperation$.pipe(
          switchMap((resolvedItem) => {
            if (!resolvedItem || !resolvedItem.itemID) {
              console.error(
                'Failed to resolve ItemID for Variable Overhead.',
                resolvedItem
              );
              return throwError(
                () => new Error('Failed to resolve Item for Variable Overhead.')
              );
            }

            const supplierLocation = this.supplierLocations.find(
              (loc: { supplierID: number | null }) =>
                loc.supplierID === resolvedItem.supplierID // Use resolvedItem.supplierID
            );

            if (!supplierLocation || !supplierLocation.locationID) {
              const errorMessage = `Supplier location not found for supplierID: ${resolvedItem.supplierID}. Cannot save price history.`;
              console.error(errorMessage);
              return throwError(() => new Error(errorMessage));
            }

            const itemSupplierPriceDto: ItemSupplierPriceHistoryDTO = {
              itemSupplierPriceID: 0, // This ensures a new record is always created
              itemID: resolvedItem.itemID,
              supplierLocationID: supplierLocation.locationID,
              purchasePrice: resolvedItem.purchasePrice ?? 0,
              purchaseQuantity: resolvedItem.purchaseQuantity ?? 0,
              purchaseUOMID: resolvedItem.purchaseUOMID ?? 0,
              currencyCode: 'ZAR',
              supplierItemCode: resolvedItem.itemCode || 'N/A',
              uomConversionFactor: 1,
              validFrom:
                item.validFrom || new Date().toISOString(), // From history
              leadTimeDays: item.leadTimeDays,
              validTo: null,
              createdAt: new Date().toISOString(),
              createdBy: this.currentUser,
            };
            return this.http
              .post<ItemSupplierPriceHistoryDTO>(
                `${environment.apiUrl}/api/ItemSupplierPriceHistory/Add`,
                itemSupplierPriceDto,
                { headers: requestHeaders } // Use the new headers object
              )
              .pipe(
                tap((createdHistoryItem: ItemSupplierPriceHistoryDTO) => {
                  item.itemSupplierPriceHistoryID =
                    createdHistoryItem.itemSupplierPriceID;
                  item.isNew = false;
                  item.isModified = false;
                  item.isEditing = false;
                  item.originalItem = { ...item };
                }),
                catchError((err) => {
                  console.error(
                    `Error adding new ItemSupplierPriceHistory for ItemID ${resolvedItem.itemID}:`,
                    err
                  );
                  return throwError(
                    () =>
                      new Error(
                        `Failed to add new price history for ItemID ${resolvedItem.itemID}`
                      )
                  );
                })
              );
          })
        );
      });

    const allRequests = [...deleteRequests, ...variableOverheadRequests];

    if (allRequests.length > 0) {
      // Use forkJoin to wait for all active requests to complete
      forkJoin(allRequests).subscribe({
        next: (results) => {
          // Filter out nulls from failed individual requests if you used `of(null)` in catchError
          // If using `throwError`, then `next` will only be called if ALL succeed.
          // --- CRUCIAL: Conditional Message Display ---
          // Only show success message if the save was NOT initiated by the 'add-button'
          this.isProcessing = false;
          if (initiator ===  'manual-save') {
            this.displaySuccessMessage(
              'Variable expenses successfully saved/updated'
            );
          }
          // --- END CRUCIAL ---

          this.deletedOverheadIds = []; // Clear deleted IDs after successful processing
        },
        error: (err) => {
          console.error(
            'Error processing variable overheads via forkJoin:',
            err
          );
          this.displayMessage(
            '⚠️An error occurred while saving variable overheads. Please try again.'
          );
          // If an error occurs, the `complete` callback will still run, ensuring `savingInitiator` is reset.
        },
        complete: () => {
          // --- CRUCIAL: Resetting the initiator and refreshing data ---
          this.isProcessing = false;
          this.cdr.detectChanges(); // Ensure UI updates are triggered
          if (!this.isFirstLogin) {
            this.loadAllOverheadRelatedData(); // Reload all data to reflect backend state
          }
          this.savingInitiator = null; // Reset the flag AFTER all async work is done
        },
      });
    } else {
      this.isProcessing = false;
      // If no requests were needed, reset the initiator immediately.
      this.savingInitiator = null;
    }
  }

  /**
   * Handles the submission logic for the 'schedule' tab.
   */
  private async handleSubmitSchedule(
    initiator: 'add-button' | 'tab-change' | 'manual-save' = 'manual-save'
  ) {
    this.isProcessing = true;
    this.sanitizeOperatingHours();

    if (!this.validateScheduleFields()) {
      this.isProcessing = false;
      return;
    }

    const token = this.getAuthToken();
    if (!token) {
      console.error('Authentication error: No auth token found.');
      this.displayMessage('⚠️Authentication error. Please log in again.');
      return;
    }

    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    });

    try {
      let businessId: number | null = this.tenantProfileID || null;
      if (!businessId) {
        businessId = (await this.getLatestTenantProfileId().toPromise()) ?? null;
      }
      if (businessId === null) {
        console.error('Business ID not found for saving trading hours.');
        this.displayMessage('⚠️Could not determine business ID for saving.');
        return;
      }

      const year = new Date().getFullYear();
      const scheduleReq = this.createOperatingScheduleRequest(
        businessId,
        headers
      );
      const excReq = this.createOperatingExceptionsRequest(
        businessId,
        year,
        headers
      );

      const savedHours = this.computeHoursOpenPerMonthFromSchedule(
        this.operatingHours
      );
      if (savedHours > 0) {
        this._hoursOpenPerMonth = savedHours;
        this.isOperatingScheduleLoaded = true;
      }

      forkJoin([scheduleReq, excReq]).subscribe({
        next: () => {
          if (initiator === 'manual-save') {
            this.savingInitiator = null;
            this.displaySaveSuccessMessage = true;
            this.isProcessing = false;
            this.displaySuccessMessage(
              'Fixed expenses successfully saved/updated'
            );
            this.displaySuccessMessage('All changes saved successfully');
          }
          this.loadTradingHours();
        },
        error: (err) => {
          this.isProcessing = false;
          console.error('Error submitting schedule or exception data:', err);
          this.displayMessage(
            '⚠️An error occurred while saving the schedule. Please try again later.'
          );
        },
        complete: () => {
          // Always reset the flag to true after the submission,
          // so manual saves will show the message again.
        },
      });
    } catch (error) {
      this.isProcessing = false;
      console.error('Error in handleSubmitSchedule:', error);
      this.displayMessage(
        '⚠️An unexpected error occurred while processing the schedule.'
      );
    }
    // The old onTabChangeCall is no longer needed if you use displaySaveSuccessMessage
    this.onTabChangeCall = false;
    this.savingInitiator = null;
  }

  /**
   * Sanitizes operating hours by clearing times if `isClosed` is true.
   */
  private sanitizeOperatingHours() {
    const convertTime = (t: string | null) => {
      if (!t) return null;

      // Split the time string and take only hours and minutes
      const timeParts = t.split(':');
      if (timeParts.length >= 2) {
        // Always return HH:MM:00 format, ignoring any existing seconds
        return `${timeParts[0]}:${timeParts[1]}:00`;
      }

      // Fallback for malformed input
      return `${t}:00`;
    };

    this.operatingHours = this.operatingHours.map((day) => ({
      ...day,
      openTime: day.isClosed ? null : convertTime(day.openTime),
      closeTime: day.isClosed ? null : convertTime(day.closeTime),
    }));
  }
  private computeHoursOpenPerMonthFromSchedule(
    schedule:
      | OperatingSchedule[]
      | OperatingScheduleEntry[]
      | { isClosed: boolean; openTime: string | null; closeTime: string | null }[]
  ): number {
    if (!schedule || schedule.length === 0) {
      return 0;
    }

    const parseTimeToMinutes = (time: string | null | undefined): number | null => {
      if (!time) {
        return null;
      }

      const parts = time.split(':').map((part) => Number(part));
      if (parts.some((value) => Number.isNaN(value))) {
        return null;
      }

      const hours = parts[0];
      const minutes = parts[1] ?? 0;
      return hours * 60 + minutes;
    };

    const totalMinutes = schedule
      .filter((day) => !day.isClosed && day.openTime && day.closeTime)
      .reduce((sum, day) => {
        const startMinutes = parseTimeToMinutes(day.openTime);
        const endMinutes = parseTimeToMinutes(day.closeTime);

        if (startMinutes === null || endMinutes === null) {
          return sum;
        }

        const duration = endMinutes >= startMinutes
          ? endMinutes - startMinutes
          : 1440 - startMinutes + endMinutes;

        return sum + duration;
      }, 0);

    if (totalMinutes <= 0) {
      return 0;
    }

    const weeklyHours = totalMinutes / 60;
    const monthlyHours = parseFloat((weeklyHours * 4).toFixed(2));
    return Number.isFinite(monthlyHours) ? monthlyHours : 0;
  }

  /**
   * Validates the operating schedule and exceptions.
   * @returns {boolean} - True if valid, false otherwise.
   */
  private validateScheduleFields(): boolean {
    // Basic Validation for Operating Hours

    for (const day of this.operatingHours) {
      if (!day.isClosed) {
        if (!day.openTime || !day.closeTime) {
          this.displayMessage(
            '⚠️Please set both opening and closing times for all the weekdays'
          );
          return false;
        }
      }
    }

    // Basic Validation for Exceptions
    for (const exc of this.exceptions) {
      if (!exc.exceptionDate) {
        this.displayMessage(
          '⚠️Please set both opening and closing times for all the weekdays'
        );
        return false;
      }
      if (!exc.isClosed) {
        if (!exc.openTime || !exc.closeTime) {
          this.displayMessage(
            `⚠️Please set both opening and closing times for the exception on ${exc.exceptionDate} or mark it as Closed.`
          );
          return false;
        }
      }
    }
    return true;
  }

  /**
   * Creates the HTTP request for operating schedule.
   * @param {number} businessId - The ID of the business.
   * @param {HttpHeaders} headers - The HTTP headers for the request.
   * @returns {Observable<any>} - The HTTP POST observable.
   */
  private createOperatingScheduleRequest(
    businessId: number | undefined,
    headers: HttpHeaders
  ): Observable<any> {
    const convertTime = (t: string | null) => {
      if (!t) return null;

      // Split the time string and take only hours and minutes
      const timeParts = t.split(':');
      if (timeParts.length >= 2) {
        // Always return HH:MM:00 format, ignoring any existing seconds
        return `${timeParts[0]}:${timeParts[1]}:00`;
      }

      // Fallback for malformed input
      return `${t}:00`;
    };

    const scheduleUrl = `${environment.apiUrl}/api/OperatingSchedule/${businessId}/schedule`;
    const scheduleBody = this.operatingHours.map((day: any) => ({
      operatingScheduleID: 0, // Or existing ID if updating
      dayOfWeek: day.dayOfWeek,
      openTime: convertTime(day.openTime),
      closeTime: convertTime(day.closeTime),
      isClosed: day.isClosed,
      businessID: businessId,
    }));

    return this.http.post(scheduleUrl, scheduleBody, { headers });
  }

  /**
   * Creates the HTTP request for operating exceptions.
   * @param {number} businessId - The ID of the business.
   * @param {number} year - The calendar year for exceptions.
   * @param {HttpHeaders} headers - The HTTP headers for the request.
   * @returns {Observable<any>} - The HTTP POST observable.
   */
  private createOperatingExceptionsRequest(
    businessId: number | undefined,
    year: number,
    headers: HttpHeaders
  ): Observable<any> {
    const convertTime = (t: string | null) => {
      if (!t) return null;

      // Split the time string and take only hours and minutes
      const timeParts = t.split(':');
      if (timeParts.length >= 2) {
        // Always return HH:MM:00 format, ignoring any existing seconds
        return `${timeParts[0]}:${timeParts[1]}:00`;
      }

      // Fallback for malformed input
      return `${t}:00`;
    };
    const excUrl = `${environment.apiUrl}/api/OperatingException/${businessId}/${year}/exceptions`;
    const excBody = this.exceptions.map((exc: any) => ({
      operatingExceptionID: 0, // Or existing ID if updating
      exceptionDate: new Date(exc.exceptionDate).toISOString(),
      calendarYear: new Date(exc.exceptionDate).getFullYear(),
      openTime: exc.isClosed ? null : convertTime(exc.openTime),
      closeTime: exc.isClosed ? null : convertTime(exc.closeTime),
      isClosed: exc.isClosed,
      reason: exc.reason,
      businessID: businessId,
    }));

    return this.http.post(excUrl, excBody, { headers });
  }

  /**
   * Retrieves the authentication token from local storage.
   * @returns {string | null} - The authentication token or null if not found.
   */
  private getAuthToken(): string | null {
    return localStorage.getItem('authToken');
  }

  /**
   * Displays a general message to the user.
   * @param {string} message - The message to display.
   */
  private displayMessage(message: string) {
    this.showMessageModal = true;
    this.alertInfo = message;
    this.showAlertMessageFromNext = false; // Reset for next message if needed
    this.cdr.detectChanges(); // Ensure UI updates
  }

  /**
   * Displays a success message with a checkmark icon.
   * @param {string} message - The success message.
   */
  private displaySuccessMessage(message: string) {
    this.showMessageModal = true;
    this.alertInfo = this.sanitizer.bypassSecurityTrustHtml(`
            <span style="display: flex; align-items: center; gap: 8px;">
                ${message}
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="color: #28a745;">
                    <path d="M22 11.08V12a10 10 0 1 1-5.93-8.15"></path>
                    <polyline points="22 4 12 14.01 9 11.01"></polyline>
                </svg>
            </span>
        `);
    this.showAlertMessageFromNext = false; // Reset for next message if needed

    this.cdr.detectChanges(); // Ensure UI updates
  }

  // Placeholder for `generateVariableOverheadItemCode` - you need to implement this based on your logic

  async removeFixedOverhead(index: number, skipConfirm: boolean = false): Promise<void> {
    const itemToRemove = this.fixedOverheadItems[index];

    if (!skipConfirm) {
      if (!this.deleteConfirmed) {
        this.deleteConfirmed = new Promise((resolve) => {
          this.resolveDelete = resolve;
        });
      }

      this.showDeleteConfirm = true;
      const confirmed = await this.deleteConfirmed;

      this.deleteConfirmed = new Promise((resolve) => {
        this.resolveDelete = resolve;
      });

      if (!confirmed) {
        this.displayMessage('Deletion cancelled.');
        return;
      }
    }

    // User confirmed deletion
    if (itemToRemove.fixedOverheadID && !itemToRemove.isNew) {
      // If it's an existing item, send a DELETE request to your backend
      const token = localStorage.getItem('authToken');
      const headers = new HttpHeaders({
        Authorization: `Bearer ${token}`,
        // Add initiator header if your backend expects it as discussed previously
        // 'X-Initiated-By': this.currentUser // Example if you implement this
      });

      // Chain the deletion requests using switchMap, handling errors for each.
      // Use `tap` for side effects like logging success.
      this.http
        .delete(
          `${environment.apiUrl}/api/OverheadCostItem/${itemToRemove.fixedOverheadID}`,
          { headers }
        )
        .pipe(
          tap(() =>
            console.log(
              ``
            )
          ),
          catchError((err) => {
            console.error(
              ``,
              err
            );
            this.displayMessage('⚠️ Error deleting fixed overhead.'); // Show error message
            return throwError(
              () =>
                new Error(
                  `Failed to delete OverheadCostItem: ${itemToRemove.fixedOverheadID}`
                )
            );
          }),
          switchMap(() => {
            return this.http
              .delete(
                `${environment.apiUrl}/api/OverheadAllocationRate/Delete?OverheadAllocationRateId=${itemToRemove.fixedOverheadID}`,
                { headers }
              )
              .pipe(
                tap(() =>
                  console.log(
                    ``
                  )
                ),
                catchError((err) => {
                  console.error(
                    ``,
                    err
                  );
                  this.displayMessage(
                    '⚠️ Error deleting fixed allocation rate.'
                  ); // Show error message
                  return throwError(
                    () =>
                      new Error(
                        `Failed to delete OverheadAllocationRate: ${itemToRemove.fixedOverheadID}`
                      )
                  );
                })
              );
          })
        )
        .subscribe({
          next: () => {
            // Both deletions were successful
            this.fixedOverheadItems.splice(index, 1);
            this.cdr.detectChanges();
            this.loadFixedOverheads();
            if (this.isMobileView()) {
              this.toast.success('Fixed cost deleted successfully', 3000);
            }
          },
          error: (err) => {
            // An error occurred in either the overhead or allocation rate deletion
            console.error(
              'Final subscription error during fixed overhead deletion:',
              err
            );
            this.displayMessage(
              '⚠️ An error occurred during fixed expense deletion.'
            );
            // The individual catchError blocks already display specific error messages.
            // This one catches any uncaught errors or re-thrown errors.
          },
          complete: () => {
            // Optional: Actions to take when the observable completes (success or error).
            // this.cdr.detectChanges(); // Already called in next, but good to ensure
          },
        });
    } else {
      // If it's a new item not yet saved, just remove it from the frontend array
      this.fixedOverheadItems.splice(index, 1);
      this.cdr.detectChanges();
      this.displaySuccessMessage('New fixed expense removed from list.'); // Message for unsaved item
      this.loadFixedOverheads(); // Reload to reflect changes if necessary
    }
    // The cdr.detectChanges() and loadFixedOverheads() at the end were moved
    // into the subscribe's next block or for the 'isNew' else branch for
    // more precise control based on operation outcome.
  }
  onFixedOverheadFieldChange(item: FixedOverheadItem): void {
    // Mark as modified if it's an existing item being changed
    if (item.fixedOverheadID && !item.isNew && !item.isModified) {
      item.isModified = true;
    }
    item.touched = true;
    this.validateFixedOverheadItem(item); // Re-validate the item
  }

  // You will also need methods to manage exceptions (addException, removeException)

  // Placeholder for getCurrentTabLabel() if it's not defined
  onTabChange(tab: string): void {
    // Set the flag to false because we don't want to show the success message
    // when an auto-save happens due to tab change.
    if (this.mainActiveTab === 'expenses') {
      const variableOverheadValid = this.validateVariableOverheads();
      const fixedOverheadValid = this.validateFixedOverheads();
      if (!variableOverheadValid) {
        this.displayMessage(
          '⚠️Please correct the invalid fields and remember to Save inline.'
        );
        this.cdr.detectChanges();

        return;
      } else {
        this.onSaveVariableOverheads('tab-change');
      }

      if (!fixedOverheadValid) {
        this.displayMessage(
          '⚠️Please correct the invalid fields and remember to Save inline.'
        );
        this.cdr.detectChanges();
        return;
      } else {
        this.onSaveFixedOverheads('tab-change');
      }
    }
    if (tab === 'schedule') {
      if (!this.validateDetailsAndChallengesFields()) {
        this.displayMessage(
          '⚠️Please fill in all required fields before submitting.'
        );
        this.mainActiveTab = 'details';
        return;
      }
      this.loadTradingHours();
      this.handleSubmitSchedule('tab-change');

      this.cdr.detectChanges();
    }
    this.displaySaveSuccessMessage = false;
    this.onTabChangeCall = true;
    this.mainActiveTab = tab;
    // Keep this call for auto-saving changes

    // Reset the flag to true for subsequent manual save operations.
    // It's crucial to reset it AFTER onSubmit() completes or ensures
    // handleSubmitSchedule has processed it. Putting it here is fine
    // if onSubmit is synchronous or handles its own flag reset timing.
    // For async operations, ensure it's reset after the save promise resolves.
    // Given your current structure, it's safer to reset it within handleSubmitSchedule
    // or after its async completion. Let's stick with resetting it in handleSubmitSchedule.
  }
  getCurrentTabLabel(): string {
    switch (this.mainActiveTab) {
      case 'details':
        return 'Details';
      case 'expenses':
        return 'Expenses';
      case 'schedule':
        return 'Schedule';

      case 'employees':
        return 'Employees';
      default:
        return '';
    }
  }

  get currentTabIndex(): number {
    return this.tabs.indexOf(this.mainActiveTab);
  }

  get progressLabel(): string {
    const idx = this.currentTabIndex;
    if (idx < 0) return '';
    const labels: Record<string, string> = {
      details: 'Details', schedule: 'Schedule', expenses: 'Expenses',
      employees: 'Employees', salaries: 'Salaries',
    };
    return `Step ${idx + 1} of ${this.tabs.length} — ${labels[this.mainActiveTab] ?? this.mainActiveTab}`;
  }

  get saveButtonLabel(): string {
    if (!this.isFirstLogin) return 'Save Changes';
    return this.isLast ? 'Finish Setup' : 'Save & Continue';
  }

  saveAndContinue(): void {
    this.onSubmit();
    if (this.isFirstLogin) {
      if (this.isLast) {
        this.onFinish();
      } else {
        const nextTab = this.tabs[this.currentTabIndex + 1];
        this.mainActiveTab = nextTab;
        this.router.navigate([], {
          relativeTo: this.route,
          queryParams: { tab: nextTab },
          queryParamsHandling: '',
        });
      }
    }
  }

  /**
   * Handles form submission for the business details form.
   * Delegates to appropriate handler based on the current active tab.
   */
  onSubmit(): void {
    // Handle submission based on the current active tab
    switch (this.mainActiveTab) {
      case 'details':
      case 'challenges':
        this.handleSubmitDetailsAndChallenges();
        break;
      case 'schedule':
        this.handleSubmitSchedule();
        break;
      case 'expenses':
        // Save both fixed and variable overheads
        this.onSaveFixedOverheads();
        this.onSaveVariableOverheads();
        break;
        case 'employees':
        this.handleSubmitEmployees();
        break;
      case 'salaries':
        // Salaries are saved inline via offcanvas; nothing to submit here
        break;
      default:
        console.warn(`No submission handler for tab: ${this.mainActiveTab}`);
        break;
    }

    // Update the lock state after successful submission
    this.updateLockState();
  }

  async onMobileSubmit(payload: { action: 'save' | 'finish' }): Promise<void> {
    if (payload?.action === 'finish') {
      this.onFinish({ skipNavigate: true, mobileFirstLogin: this.isFirstLogin });
    } else {
      this.onSubmit();
    }
  }

  private handleSubmitEmployees(): void {
    const activeEdits = this.employees.some((e) => e.isEditing);
    if (activeEdits) {
      this.showMessageModal = true;
      this.alertInfo = `⚠️Please save or cancel all active inline edits before saving all changes.`;
      return;
    }
    if (this.hasPendingEmployeeChanges()) {
      this.confirmSaveAllEmployeesChanges();
    } else {
    }
  }
  /**
   * Updates the lock state after form submission
   */
  private updateLockState(): void {
    // Validate all required sections
    const isDetailsValid = this.validateDetailsAndChallengesFields();
    const hasFixedOverheads =
      this.fixedOverheadItems.length > 0 &&
      this.fixedOverheadItems.some((item) => item.overhead?.trim());
    const hasVariableOverheads =
      this.variableOverheadItems.length > 0 &&
      this.variableOverheadItems.some((item) => item.overhead?.trim());
    const hasEmployees = this.employees.length > 0;
    const hasSalaries = this.employeeSalaries.length > 0;

    // Update the lock state
    this.isLockActive =
      isDetailsValid &&
      hasFixedOverheads &&
      hasVariableOverheads &&
      hasEmployees &&
      hasSalaries;

    if (this.isLockActive) {
      // Notify the setup service about the completion status
      this.setupService.completeSetup();
    } else {
      // If not all validations pass, the form remains unlocked
      // No need to explicitly reset the setup service as it maintains its own state
    }

    // Log validation state for debugging
    // Trigger change detection to update the UI
    this.cdr.detectChanges();
  }

  // You might also need a method to set the active tab when a user clicks on a nav-link
  setActiveTab(tabName: string) {
    this.activeTab = tabName;
  }

  // Handlers for "Add More" actions for other multi-select dropdowns
  onAddMoreModel() {
    alert('Add more business model options.');
  }

  onAddMoreTargetMarket() {
    alert('Add more target market options.');
  }

  onAddMoreSalesChannel() {
    alert('Add more sales channel options.');
  }
  onAddMoreIndustry() {
    alert('Add more industry options.');
  }
  onRoleSelect(roleId: string): void {
    if (roleId === 'addNew') {
      this.navigateToAddRole();
    }
  }

  navigateToAddRole(): void {
    this.router.navigate(['/config'], {
      queryParams: {
        tab: 'roles',
        view: 'single'
      },
      state: { from: 'business-details' }
    });
  }
}
